import React from 'react';

export interface IconProps {
  width?: string | number;
  height?: string | number;
  fill?: string;
  className?: string;
  size?: string | number;
  color?: string;
  style?: React.CSSProperties;
  filled?: boolean;
}

export const ArchiveIcon = ({
  width = 16,
  height = 16,
  color = 'var(--text-primary)',
}) => (
  <svg
    width={width}
    height={height}
    viewBox='0 0 12 12'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M10.27 2.615L9.575 1.775C9.44 1.605 9.235 1.5 9 1.5H3C2.765 1.5 2.56 1.605 2.42 1.775L1.73 2.615C1.585 2.785 1.5 3.01 1.5 3.25V9.5C1.5 10.05 1.95 10.5 2.5 10.5H9.5C10.05 10.5 10.5 10.05 10.5 9.5V3.25C10.5 3.01 10.415 2.785 10.27 2.615ZM6 8.75L3.25 6H5V5H7V6H8.75L6 8.75ZM2.56 2.5L2.965 2H8.965L9.435 2.5H2.56Z'
      fill={color}
    />
  </svg>
);

export const CheckmarkIcon: React.FC = () => (
  <svg
    width='12'
    height='12'
    viewBox='0 0 12 12'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M4.39754 7.93746L2.31254 5.85246L1.60254 6.55746L4.39754 9.35246L10.3975 3.35246L9.69254 2.64746L4.39754 7.93746Z'
      fill='var(--text-primary)'
    />
  </svg>
);

export const AddWidgetTickIcon: React.FC<IconProps> = ({
  width = 12,
  height = 12,
  color = 'currentColor',
  className,
}) => (
  <svg
    width={width}
    height={height}
    viewBox='0 0 12 12'
    fill='none'
    className={className}
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M4.55 8.42L2.15 6.02L1.3 6.86L4.55 10.1L10.85 3.8L10 2.95L4.55 8.42Z'
      fill={color}
    />
  </svg>
);

export const AddWidgetPlusIcon: React.FC<IconProps> = ({
  width = 12,
  height = 12,
  color = 'currentColor',
  className,
}) => (
  <svg
    width={width}
    height={height}
    viewBox='0 0 12 12'
    fill='none'
    className={className}
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M6.6 1.5H5.4V5.4H1.5V6.6H5.4V10.5H6.6V6.6H10.5V5.4H6.6V1.5Z'
      fill={color}
    />
  </svg>
);

export const AddStyleFilledIcon: React.FC<IconProps> = ({
  width = 12,
  height = 12,
  color = 'currentColor',
  className,
  style,
}) => (
  <svg
    width={width}
    height={height}
    viewBox='0 0 12 12'
    fill='none'
    className={className}
    // eslint-disable-next-line react/forbid-dom-props -- forwards the caller's style prop
    style={style}
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M9.5 6.5H6.5V9.5H5.5V6.5H2.5V5.5H5.5V2.5H6.5V5.5H9.5V6.5Z'
      fill={color}
    />
  </svg>
);

export const EmojiIcon: React.FC<IconProps> = (props) => (
  <svg
    width={props.width}
    height={props.height}
    viewBox='0 0 24 24'
    fill='none'
    className={props.className}
  >
    <g clipPath='url(#clip0_108_729)'>
      <path
        d='M12 24C9.62663 24 7.30655 23.2962 5.33316 21.9776C3.35977 20.6591 1.8217 18.7849 0.913451 16.5922C0.00519943 14.3995 -0.232441 11.9867 0.230582 9.65892C0.693605 7.33115 1.83649 5.19295 3.51472 3.51472C5.19295 1.83649 7.33115 0.693605 9.65892 0.230582C11.9867 -0.232441 14.3995 0.00519943 16.5922 0.913451C18.7849 1.8217 20.6591 3.35977 21.9776 5.33316C23.2962 7.30655 24 9.62663 24 12C23.9966 15.1815 22.7312 18.2318 20.4815 20.4815C18.2318 22.7312 15.1815 23.9966 12 24ZM12 2.00001C10.0222 2.00001 8.08879 2.5865 6.4443 3.68531C4.79981 4.78412 3.51809 6.34591 2.76121 8.17317C2.00433 10.0004 1.8063 12.0111 2.19215 13.9509C2.578 15.8907 3.53041 17.6725 4.92894 19.0711C6.32746 20.4696 8.10929 21.422 10.0491 21.8079C11.9889 22.1937 13.9996 21.9957 15.8268 21.2388C17.6541 20.4819 19.2159 19.2002 20.3147 17.5557C21.4135 15.9112 22 13.9778 22 12C21.9971 9.34873 20.9426 6.80689 19.0679 4.93215C17.1931 3.05742 14.6513 2.00292 12 2.00001ZM17.666 15.746C17.8641 15.5696 17.9841 15.3218 17.9994 15.057C18.0148 14.7922 17.9244 14.5321 17.748 14.334C17.5716 14.1359 17.3238 14.0159 17.059 14.0006C16.7942 13.9852 16.5341 14.0756 16.336 14.252C15.1135 15.2813 13.5945 15.8936 12 16C10.4064 15.8937 8.88823 15.2821 7.66601 14.254C7.46815 14.0774 7.20824 13.9866 6.94344 14.0016C6.67864 14.0166 6.43064 14.1362 6.25401 14.334C6.07737 14.5319 5.98657 14.7918 6.00157 15.0566C6.01657 15.3214 6.13615 15.5694 6.33401 15.746C7.92187 17.1025 9.91422 17.8951 12 18C14.0858 17.8951 16.0781 17.1025 17.666 15.746ZM6.00001 10C6.00001 11 6.89501 11 8.00001 11C9.10501 11 10 11 10 10C10 9.46957 9.78929 8.96087 9.41422 8.58579C9.03915 8.21072 8.53044 8.00001 8.00001 8.00001C7.46957 8.00001 6.96086 8.21072 6.58579 8.58579C6.21072 8.96087 6.00001 9.46957 6.00001 10ZM14 10C14 11 14.895 11 16 11C17.105 11 18 11 18 10C18 9.46957 17.7893 8.96087 17.4142 8.58579C17.0391 8.21072 16.5304 8.00001 16 8.00001C15.4696 8.00001 14.9609 8.21072 14.5858 8.58579C14.2107 8.96087 14 9.46957 14 10Z'
        fill={props.fill}
      />
    </g>
    <defs>
      <clipPath id='clip0_108_729'>
        <rect width='24' height='24' fill='white' />
      </clipPath>
    </defs>
  </svg>
);

export const SearchIcon: React.FC<IconProps> = (props) => (
  <svg
    width={props.width}
    height={props.height}
    viewBox='0 0 12 12'
    fill='none'
    className={props.className}
  >
    <path
      d='M11.3 10.2L9.1001 7.99995C9.6501 7.19995 10 6.24997 10 5.19997C10 2.59997 7.85 0.449951 5.25 0.449951C2.65 0.449951 0.5 2.59997 0.5 5.19997C0.5 7.79997 2.65 9.94997 5.25 9.94997C6.3 9.94997 7.25005 9.59994 8.05005 9.04994L10.25 11.25L11.3 10.2ZM2 5.24995C2 3.44995 3.45 1.99995 5.25 1.99995C7.05 1.99995 8.5 3.44995 8.5 5.24995C8.5 7.04995 7.05 8.49995 5.25 8.49995C3.45 8.49995 2 7.04995 2 5.24995Z'
      fill={props.fill}
    />
  </svg>
);

export const ChevronRightIcon: React.FC<IconProps> = (props) => (
  <svg
    width={props.width}
    height={props.height}
    viewBox='0 0 24 24'
    fill='none'
    className={props.className}
  >
    <path
      d='M9.70492 6L8.29492 7.41L12.8749 12L8.29492 16.59L9.70492 18L15.7049 12L9.70492 6Z'
      fill={props.fill}
    />
  </svg>
);

export const WarningIcon: React.FC<IconProps> = (props) => (
  <svg
    width={props.width}
    height={props.height}
    viewBox='0 0 24 24'
    fill='none'
    className={props.className}
  >
    <path
      d='M1 21.5H23L12 2.5L1 21.5ZM13 18.5H11V16.5H13V18.5ZM13 14.5H11V10.5H13V14.5Z'
      fill={props.fill}
    />
  </svg>
);

export const CheckBoxIcon: React.FC<IconProps> = (props) => (
  <svg
    width={props.width}
    height={props.height}
    viewBox='0 0 12 12'
    fill='none'
    className={props.className}
  >
    <path
      d='M10.6667 0H1.33333C0.593333 0 0 0.6 0 1.33333V10.6667C0 11.4 0.593333 12 1.33333 12H10.6667C11.4067 12 12 11.4 12 10.6667V1.33333C12 0.6 11.4067 0 10.6667 0ZM4.66667 9.33333L1.33333 6L2.27333 5.06L4.66667 7.44667L9.72667 2.38667L10.6667 3.33333L4.66667 9.33333Z'
      fill={props.fill}
    />
  </svg>
);

export const PlusIcon: React.FC<IconProps> = (props) => (
  <svg
    width={props.width}
    height={props.height}
    className={props.className}
    viewBox='0 0 24 24'
    fill='none'
  >
    <path d='M19 13H13V19H11V13H5V11H11V5H13V11H19V13Z' fill={props.fill} />
  </svg>
);

// export const CrossIcon: React.FC = () => (

export const CrossIcon: React.FC<
  IconProps & { size?: number; color?: string }
> = ({ size = 16, color = 'var(--text-primary)', ...props }) => (
  <svg
    className='cursor-pointer'
    width={size}
    height={size}
    viewBox='0 0 16 16'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M14.0664 3.39998L12.5998 1.93335L7.99976 6.60002L3.39974 1.93335L1.93311 3.39998L6.59977 8L1.93311 12.6L3.39974 14.0667L7.99976 9.39998L12.5998 14.0667L14.0664 12.6L9.39974 8L14.0664 3.39998Z'
      fill={color}
    />
  </svg>
);

export const VibilityWindowIcon: React.FC = () => (
  <svg
    width='12'
    height='12'
    viewBox='0 0 12 12'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M3 1L3.005 4L5 6L3.005 8.005L3 11H9V8L7 6L9 4.005V1H3ZM8 8.25V10H4V8.25L6 6.25L8 8.25Z'
      fill='currentColor'
    />
  </svg>
);

export const BatteryIcon: React.FC = () => (
  <svg
    width='12'
    height='12'
    viewBox='0 0 12 12'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M8.5 2.5V10.5C8.5 10.775 8.275 11 8 11H4C3.725 11 3.5 10.775 3.5 10.5V2.5C3.5 2.225 3.725 2 4 2H5V1H7V2H8C8.275 2 8.5 2.225 8.5 2.5ZM7.5 3H4.5V4H7.5V3Z'
      fill='currentColor'
    />
  </svg>
);

const CELL_SIGNAL_RINGS = [
  'M7.98 2.72A2.8 2.8 0 0 1 7.98 6.68A0.45 0.45 0 0 1 7.34 6.04A1.9 1.9 0 0 0 7.34 3.36A0.45 0.45 0 0 1 7.98 2.72Z',
  'M4.02 6.68A2.8 2.8 0 0 1 4.02 2.72A0.45 0.45 0 0 1 4.66 3.36A1.9 1.9 0 0 0 4.66 6.04A0.45 0.45 0 0 1 4.02 6.68Z',
  'M8.97 1.73A4.2 4.2 0 0 1 8.97 7.67A0.45 0.45 0 0 1 8.33 7.03A3.3 3.3 0 0 0 8.33 2.37A0.45 0.45 0 0 1 8.97 1.73Z',
  'M3.03 7.67A4.2 4.2 0 0 1 3.03 1.73A0.45 0.45 0 0 1 3.67 2.37A3.3 3.3 0 0 0 3.67 7.03A0.45 0.45 0 0 1 3.03 7.67Z',
  'M9.96 0.74A5.6 5.6 0 0 1 9.96 8.66A0.45 0.45 0 0 1 9.32 8.02A4.7 4.7 0 0 0 9.32 1.38A0.45 0.45 0 0 1 9.96 0.74Z',
  'M2.04 8.66A5.6 5.6 0 0 1 2.04 0.74A0.45 0.45 0 0 1 2.68 1.38A4.7 4.7 0 0 0 2.68 8.02A0.45 0.45 0 0 1 2.04 8.66Z',
];

/** Broadcast mast with three ring pairs; `rings` of them are lit from the inside out, the rest dimmed. */
export const CellSignalIcon: React.FC<{ rings: 0 | 1 | 2 | 3 }> = ({
  rings,
}) => (
  <svg
    width='12'
    height='12'
    viewBox='0 0 12 12'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M6 3.5A1.2 1.2 0 1 1 6 5.9A1.2 1.2 0 1 1 6 3.5Z'
      fill='currentColor'
    />
    <path
      d='M6 4.7H6A0.5 0.5 0 0 1 6.5 5.2V10.5A0.5 0.5 0 0 1 6 11H6A0.5 0.5 0 0 1 5.5 10.5V5.2A0.5 0.5 0 0 1 6 4.7Z'
      fill='currentColor'
    />
    {CELL_SIGNAL_RINGS.map((d, i) => (
      <path
        key={d}
        d={d}
        fill='currentColor'
        fillOpacity={Math.floor(i / 2) < rings ? 1 : 0.3}
      />
    ))}
  </svg>
);

export const TempratureRangeIcon: React.FC = () => (
  <svg
    width='12'
    height='12'
    viewBox='0 0 12 12'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M7.5 6.5V2.5C7.5 1.67 6.83 1 6 1C5.17 1 4.5 1.67 4.5 2.5V6.5C3.895 6.955 3.5 7.685 3.5 8.5C3.5 9.88 4.62 11 6 11C7.38 11 8.5 9.88 8.5 8.5C8.5 7.685 8.105 6.955 7.5 6.5ZM5.5 5.5V2.5C5.5 2.225 5.725 2 6 2C6.275 2 6.5 2.225 6.5 2.5V3H6V3.5H6.5V4.5H6V5H6.5V5.5H5.5Z'
      fill='currentColor'
    />
  </svg>
);

export const ShockIcon: React.FC = () => (
  <svg
    width='12'
    height='12'
    viewBox='0 0 12 12'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M7.81507 5.04972C7.75589 4.85795 7.67421 4.68632 7.57005 4.5348C7.46825 4.38092 7.34514 4.24953 7.20073 4.14062C7.05868 4.03172 6.89533 3.95005 6.71067 3.8956C6.52601 3.83878 6.32478 3.81037 6.10698 3.81037C5.71635 3.81037 5.36834 3.90862 5.06294 4.10511C4.75755 4.30161 4.51725 4.59044 4.34206 4.97159C4.16924 5.35038 4.08283 5.81203 4.08283 6.35653C4.08283 6.90578 4.16924 7.37098 4.34206 7.75213C4.51489 8.13329 4.75518 8.4233 5.06294 8.62216C5.37071 8.81866 5.72819 8.9169 6.13539 8.9169C6.50471 8.9169 6.82431 8.84588 7.09419 8.70384C7.36645 8.56179 7.57596 8.36056 7.72275 8.10014C7.86953 7.83736 7.94292 7.52959 7.94292 7.17685L8.24121 7.22301H6.26678V6.19318H9.21777V7.06676C9.21777 7.68939 9.0852 8.22798 8.82005 8.68253C8.55489 9.13707 8.19031 9.48745 7.7263 9.73366C7.26228 9.97751 6.72961 10.0994 6.12828 10.0994C5.4583 10.0994 4.87 9.9491 4.36337 9.64844C3.85911 9.34541 3.46493 8.91572 3.18084 8.35938C2.89912 7.80066 2.75826 7.13778 2.75826 6.37074C2.75826 5.78362 2.84112 5.25923 3.00684 4.79759C3.17492 4.33594 3.4093 3.94413 3.70996 3.62216C4.01062 3.29782 4.36337 3.05161 4.7682 2.88352C5.17303 2.71307 5.61337 2.62784 6.08922 2.62784C6.49168 2.62784 6.86692 2.68703 7.21493 2.8054C7.56294 2.9214 7.87189 3.08712 8.14178 3.30256C8.41403 3.51799 8.63775 3.77367 8.81294 4.0696C8.98813 4.36553 9.10295 4.69223 9.1574 5.04972H7.81507Z'
      fill='currentColor'
    />
  </svg>
);

export const LightIcon: React.FC = () => (
  <svg
    width='12'
    height='12'
    viewBox='0 0 12 12'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <g clipPath='url(#clip0_13810_46620)'>
      <path
        d='M6 3.5C4.62 3.5 3.5 4.62 3.5 6C3.5 7.38 4.62 8.5 6 8.5C7.38 8.5 8.5 7.38 8.5 6C8.5 4.62 7.38 3.5 6 3.5ZM1 6.5H2C2.275 6.5 2.5 6.275 2.5 6C2.5 5.725 2.275 5.5 2 5.5H1C0.725 5.5 0.5 5.725 0.5 6C0.5 6.275 0.725 6.5 1 6.5ZM10 6.5H11C11.275 6.5 11.5 6.275 11.5 6C11.5 5.725 11.275 5.5 11 5.5H10C9.725 5.5 9.5 5.725 9.5 6C9.5 6.275 9.725 6.5 10 6.5ZM5.5 1V2C5.5 2.275 5.725 2.5 6 2.5C6.275 2.5 6.5 2.275 6.5 2V1C6.5 0.725 6.275 0.5 6 0.5C5.725 0.5 5.5 0.725 5.5 1ZM5.5 10V11C5.5 11.275 5.725 11.5 6 11.5C6.275 11.5 6.5 11.275 6.5 11V10C6.5 9.725 6.275 9.5 6 9.5C5.725 9.5 5.5 9.725 5.5 10ZM2.995 2.29C2.8 2.095 2.48 2.095 2.29 2.29C2.095 2.485 2.095 2.805 2.29 2.995L2.82 3.525C3.015 3.72 3.335 3.72 3.525 3.525C3.715 3.33 3.72 3.01 3.525 2.82L2.995 2.29ZM9.18 8.475C8.985 8.28 8.665 8.28 8.475 8.475C8.28 8.67 8.28 8.99 8.475 9.18L9.005 9.71C9.2 9.905 9.52 9.905 9.71 9.71C9.905 9.515 9.905 9.195 9.71 9.005L9.18 8.475ZM9.71 2.995C9.905 2.8 9.905 2.48 9.71 2.29C9.515 2.095 9.195 2.095 9.005 2.29L8.475 2.82C8.28 3.015 8.28 3.335 8.475 3.525C8.67 3.715 8.99 3.72 9.18 3.525L9.71 2.995ZM3.525 9.18C3.72 8.985 3.72 8.665 3.525 8.475C3.33 8.28 3.01 8.28 2.82 8.475L2.29 9.005C2.095 9.2 2.095 9.52 2.29 9.71C2.485 9.9 2.805 9.905 2.995 9.71L3.525 9.18Z'
        fill='currentColor'
      />
    </g>
    <defs>
      <clipPath id='clip0_13810_46620'>
        <rect width='12' height='12' fill='white' />
      </clipPath>
    </defs>
  </svg>
);

export const TiltIcon: React.FC = () => (
  <svg
    width='12'
    height='12'
    viewBox='0 0 12 12'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M5.28638 6.34622L8.86931 2.52443C8.96374 2.4237 8.95864 2.2655 8.85791 2.17106L8.49314 1.82909C8.39241 1.73466 8.2342 1.73976 8.13977 1.84049L1.20308 9.23963C0.747308 9.72578 1.10476 10.5001 1.75151 10.5001H10.4255C10.5636 10.5001 10.6755 10.3881 10.6755 10.2501V9.75008C10.6755 9.61201 10.5636 9.50008 10.4255 9.50008H6.65274C6.60245 8.94922 6.46926 8.40813 6.25685 7.89533C6.02175 7.32774 5.69351 6.80427 5.28638 6.34622ZM2.32964 9.50008H5.64765C5.60077 9.08079 5.49506 8.66933 5.33297 8.27801C5.1523 7.84184 4.90442 7.43752 4.59896 7.07947L2.32964 9.50008Z'
      fill='currentColor'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M5.64765 9.50008C5.63829 9.4164 5.62659 9.33303 5.61257 9.25008C5.55633 8.91736 5.46271 8.59124 5.33297 8.27801C5.18463 7.91989 4.99098 7.58324 4.75735 7.27604C4.70644 7.20909 4.65362 7.14354 4.59896 7.07947L2.32964 9.50008H5.64765ZM5.35881 9.25008C5.30506 8.95028 5.21911 8.65642 5.102 8.37368C4.96732 8.04854 4.79309 7.74214 4.5838 7.46117L2.9067 9.25008H5.35881ZM5.28638 6.34622C5.69351 6.80427 6.02175 7.32774 6.25685 7.89533C6.46926 8.40813 6.60245 8.94922 6.65274 9.50008H10.4255C10.5636 9.50008 10.6755 9.61201 10.6755 9.75008V10.2501C10.6755 10.3881 10.5636 10.5001 10.4255 10.5001H1.75151C1.10476 10.5001 0.747308 9.72578 1.20308 9.23963L8.13977 1.84049C8.2342 1.73976 8.39241 1.73466 8.49314 1.82909L8.85791 2.17106C8.95864 2.2655 8.96374 2.4237 8.86931 2.52443L5.28638 6.34622ZM6.87639 9.25008C6.81096 8.75276 6.6806 8.26507 6.48782 7.79966C6.27129 7.27692 5.97921 6.78997 5.62173 6.35404L9.05169 2.69542C9.24056 2.49396 9.23035 2.17754 9.02889 1.98868L8.66412 1.64671C8.46267 1.45784 8.14625 1.46805 7.95739 1.66951L1.02069 9.06864C0.409493 9.72059 0.894333 10.7501 1.75151 10.7501H10.4255C10.7017 10.7501 10.9255 10.5262 10.9255 10.2501V9.75008C10.9255 9.47393 10.7017 9.25008 10.4255 9.25008H6.87639Z'
      fill='currentColor'
    />
  </svg>
);

export const PressureIcon: React.FC = () => (
  <svg
    width='12'
    height='12'
    viewBox='0 0 12 12'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M5.33582 5.66418C5.66914 5.99751 6.20958 5.99751 6.54291 5.66418C6.87624 5.33086 7.75 3.25 7.75 3.25C7.75 3.25 5.66914 4.12376 5.33582 4.45709C5.00249 4.79042 5.00249 5.33086 5.33582 5.66418Z'
      fill='currentColor'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M6 1C3.79086 1 2 2.79086 2 5C2 6.86384 3.27477 8.42994 5 8.87398V10H1.25C1.11193 10 1 10.1119 1 10.25V11.25C1 11.3881 1.11193 11.5 1.25 11.5H10.75C10.8881 11.5 11 11.3881 11 11.25V10.25C11 10.1119 10.8881 10 10.75 10H7V8.87398C8.72523 8.42994 10 6.86384 10 5C10 2.79086 8.20914 1 6 1ZM3 5C3 3.34315 4.34315 2 6 2C7.65685 2 9 3.34315 9 5C9 6.65685 7.65685 8 6 8C4.34315 8 3 6.65685 3 5Z'
      fill='currentColor'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M6 9C8.20914 9 10 7.20914 10 5C10 2.79086 8.20914 1 6 1C3.79086 1 2 2.79086 2 5C2 7.20914 3.79086 9 6 9ZM6 9.5C8.48528 9.5 10.5 7.48528 10.5 5C10.5 2.51472 8.48528 0.5 6 0.5C3.51472 0.5 1.5 2.51472 1.5 5C1.5 7.48528 3.51472 9.5 6 9.5Z'
      fill='currentColor'
    />
  </svg>
);

export const HumidityIcon: React.FC = () => (
  <svg
    width='12'
    height='12'
    viewBox='0 0 12 12'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M6 1C3.335 3.275 2 5.24 2 6.9C2 9.39 3.9 11 6 11C8.1 11 10 9.39 10 6.9C10 5.24 8.665 3.275 6 1ZM3.915 7C4.1 7 4.25 7.13 4.285 7.31C4.49 8.42 5.425 8.8 6.105 8.745C6.32 8.735 6.5 8.905 6.5 9.12C6.5 9.32 6.34 9.485 6.14 9.495C5.075 9.56 3.83 8.95 3.545 7.435C3.505 7.21 3.685 7 3.915 7Z'
      fill='currentColor'
    />
  </svg>
);

// export const HomeProductIcon: React.FC = () => (

export const HomeProductIcon: React.FC<IconProps> = ({
  width = 16,
  height = 16,
  color = 'currentColor',
}) => (
  <svg
    width={width}
    height={height}
    viewBox='0 0 16 16'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M13.6933 3.48667L12.7667 2.36667C12.5867 2.14 12.3133 2 12 2H4C3.68667 2 3.41333 2.14 3.22667 2.36667L2.30667 3.48667C2.11333 3.71333 2 4.01333 2 4.33333V12.6667C2 13.4 2.6 14 3.33333 14H12.6667C13.4 14 14 13.4 14 12.6667V4.33333C14 4.01333 13.8867 3.71333 13.6933 3.48667ZM4.16 3.33333H11.84L12.6667 4.33333H3.33333L4.16 3.33333ZM3.33333 12.6667V5.33333H12.6667V12.6667H3.33333Z'
      fill={color}
    />
    <path
      d='M12.667 13.333H3.33301V5.33301H12.667V13.333ZM6 5.66699V9H10V5.66699H6Z'
      fill={color}
    />
  </svg>
);

/** Product type — tag/layers mark, distinct from Product box icon. */
export const HomeProductTypeIcon: React.FC = () => (
  <svg
    width='16'
    height='16'
    viewBox='0 0 16 16'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M2.66699 3.33301H13.3337V4.66699H2.66699V3.33301ZM2.66699 7.33301H13.3337V8.66699H2.66699V7.33301ZM2.66699 11.333H10.0003V12.667H2.66699V11.333Z'
      fill='currentColor'
    />
  </svg>
);

export const HomeTemperatureIcon: React.FC<IconProps> = ({
  width = 16,
  height = 16,
  color = 'currentColor',
}) => (
  <svg
    width={width}
    height={height}
    viewBox='0 0 16 16'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M9.99984 8.66665V3.33331C9.99984 2.22665 9.1065 1.33331 7.99984 1.33331C6.89317 1.33331 5.99984 2.22665 5.99984 3.33331V8.66665C5.19317 9.27331 4.6665 10.2466 4.6665 11.3333C4.6665 13.1733 6.15984 14.6666 7.99984 14.6666C9.83984 14.6666 11.3332 13.1733 11.3332 11.3333C11.3332 10.2466 10.8065 9.27331 9.99984 8.66665ZM7.33317 7.33331V3.33331C7.33317 2.96665 7.63317 2.66665 7.99984 2.66665C8.3665 2.66665 8.6665 2.96665 8.6665 3.33331V3.99998H7.99984V4.66665H8.6665V5.99998H7.99984V6.66665H8.6665V7.33331H7.33317Z'
      fill={color}
    />
  </svg>
);

export const HomeTeamsIcon: React.FC = () => (
  <svg
    width='16'
    height='16'
    viewBox='0 0 16 16'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M11.1132 8.75335C12.0265 9.37335 12.6665 10.2134 12.6665 11.3334V13.3334H15.3332V11.3334C15.3332 9.88002 12.9532 9.02002 11.1132 8.75335Z'
      fill='currentColor'
    />
    <path
      d='M5.99984 8.00002C7.4726 8.00002 8.6665 6.80611 8.6665 5.33335C8.6665 3.86059 7.4726 2.66669 5.99984 2.66669C4.52708 2.66669 3.33317 3.86059 3.33317 5.33335C3.33317 6.80611 4.52708 8.00002 5.99984 8.00002Z'
      fill='currentColor'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M9.99984 8.00002C11.4732 8.00002 12.6665 6.80669 12.6665 5.33335C12.6665 3.86002 11.4732 2.66669 9.99984 2.66669C9.6865 2.66669 9.39317 2.73335 9.11317 2.82669C9.6665 3.51335 9.99984 4.38669 9.99984 5.33335C9.99984 6.28002 9.6665 7.15335 9.11317 7.84002C9.39317 7.93335 9.6865 8.00002 9.99984 8.00002Z'
      fill='currentColor'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M5.99984 8.66669C4.21984 8.66669 0.666504 9.56002 0.666504 11.3334V13.3334H11.3332V11.3334C11.3332 9.56002 7.77984 8.66669 5.99984 8.66669Z'
      fill='currentColor'
    />
  </svg>
);

export const HomeRiskIcon: React.FC = () => (
  <svg
    width='16'
    height='16'
    viewBox='0 0 16 16'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M10.4867 2H5.51333L2 5.51333V10.4867L5.51333 14H10.4867L14 10.4867V5.51333L10.4867 2ZM8 11.5333C7.52 11.5333 7.13333 11.1467 7.13333 10.6667C7.13333 10.1867 7.52 9.8 8 9.8C8.48 9.8 8.86667 10.1867 8.86667 10.6667C8.86667 11.1467 8.48 11.5333 8 11.5333ZM8.66667 8.66667H7.33333V4.66667H8.66667V8.66667Z'
      fill='currentColor'
    />
  </svg>
);

export const HomeStatusIcon: React.FC = () => (
  <svg
    width='16'
    height='16'
    viewBox='0 0 16 16'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    {Array.from({ length: 12 }, (_, i) => (
      <rect
        key={i}
        x='7.15'
        y='1.25'
        width='1.7'
        height='3.4'
        rx='0.85'
        fill='currentColor'
        opacity={0.25 + (i / 11) * 0.75}
        transform={`rotate(${i * 30} 8 8)`}
      />
    ))}
  </svg>
);

export const PlayIcon: React.FC = () => (
  <svg
    width='14'
    height='14'
    viewBox='0 0 14 14'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M6.99992 0.333374C3.31992 0.333374 0.333252 3.32004 0.333252 7.00004C0.333252 10.68 3.31992 13.6667 6.99992 13.6667C10.6799 13.6667 13.6666 10.68 13.6666 7.00004C13.6666 3.32004 10.6799 0.333374 6.99992 0.333374ZM5.66659 10V4.00004L9.66659 7.00004L5.66659 10Z'
      fill='currentColor'
    />
  </svg>
);

export const PauseIcon: React.FC = () => (
  <svg
    width='14'
    height='14'
    viewBox='0 0 14 14'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M7 0.333374C3.32 0.333374 0.333333 3.32004 0.333333 7.00004C0.333333 10.68 3.32 13.6667 7 13.6667C10.68 13.6667 13.6667 10.68 13.6667 7.00004C13.6667 3.32004 10.68 0.333374 7 0.333374ZM5.66667 10.3334H4.33333V3.66671H5.66667V10.3334ZM9.66667 10.3334H8.33333V3.66671H9.66667V10.3334Z'
      fill='currentColor'
    />
  </svg>
);

export const DeleteIcon: React.FC<
  Omit<React.SVGProps<SVGSVGElement>, 'color' | 'width' | 'height'> &
    Pick<IconProps, 'color' | 'width' | 'height'>
> = ({
  color = 'var(--text-primary)',
  width = 16,
  height = 16,
  ...svgProps
}) => (
  <svg
    width={width}
    height={height}
    viewBox='0 0 16 16'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...svgProps}
  >
    <path
      d='M4.00004 12.6667C4.00004 13.4 4.60004 14 5.33337 14H10.6667C11.4 14 12 13.4 12 12.6667V4.66667H4.00004V12.6667ZM12.6667 2.66667H10.3334L9.66671 2H6.33337L5.66671 2.66667H3.33337V4H12.6667V2.66667Z'
      fill={color}
    />
  </svg>
);

export const GeoFenceIcon: React.FC<{
  width?: number;
  height?: number;
  color?: string;
}> = ({ width = 9, height = 11, color = 'var(--text-primary)' }) => (
  // No clipPath/id here (unlike most icons in this file): this renders once per
  // table row, and duplicate SVG ids across many rows is worth avoiding. The
  // path already fits the viewBox exactly, so a clip would be a no-op anyway.
  <svg
    width={width}
    height={height}
    viewBox='0 0 9 11'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M7.055 0.835L7.89 0L8.95 1.06L8.115 1.895L7.055 0.835ZM6.555 1.335L7.615 2.395L4.56 5.45H3.5V4.395L6.555 1.335ZM5.565 1.27L2.75 4.085V6.205H4.87L7.68 3.395C7.885 3.89 8 4.445 8 5.055C8 6.715 6.665 8.68 4 10.955C1.335 8.68 0 6.715 0 5.055C0 2.565 1.9 0.955 4 0.955C4.545 0.955 5.08 1.065 5.565 1.27Z'
      fill={color}
    />
  </svg>
);

export const SignalIcon: React.FC<{
  width?: number;
  height?: number;
  color?: string;
}> = ({ width = 12, height = 12, color = '#0E8345' }) => (
  <svg
    width={width}
    height={height}
    viewBox='0 0 12 12'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M3.88 8.11997C3.335 7.57997 3 6.82997 3 5.99997C3 5.16997 3.335 4.41997 3.88 3.87997L4.59 4.58997C4.225 4.94997 4 5.44997 4 5.99997C4 6.54997 4.225 7.04997 4.585 7.41497L3.88 8.11997ZM8.12 8.11997C8.665 7.57997 9 6.82997 9 5.99997C9 5.16997 8.665 4.41997 8.12 3.87997L7.41 4.58997C7.775 4.94997 8 5.44997 8 5.99997C8 6.54997 7.775 7.04997 7.415 7.41497L8.12 8.11997ZM6 4.99997C5.45 4.99997 5 5.44997 5 5.99997C5 6.54997 5.45 6.99997 6 6.99997C6.55 6.99997 7 6.54997 7 5.99997C7 5.44997 6.55 4.99997 6 4.99997ZM10 5.99997C10 7.10497 9.55 8.10497 8.825 8.82497L9.535 9.53497C10.44 8.62997 11 7.37997 11 5.99997C11 4.61997 10.44 3.36997 9.535 2.46497L8.825 3.17497C9.55 3.89497 10 4.89497 10 5.99997ZM3.175 3.17497L2.465 2.46497C1.56 3.36997 1 4.61997 1 5.99997C1 7.37997 1.56 8.62997 2.465 9.53497L3.175 8.82497C2.45 8.10497 2 7.10497 2 5.99997C2 4.89497 2.45 3.89497 3.175 3.17497Z'
      fill={color}
    />
  </svg>
);
export const OffIcon: React.FC = () => (
  <svg
    width='12'
    height='12'
    viewBox='0 0 12 12'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M6 1C3.24 1 1 3.24 1 6C1 8.76 3.24 11 6 11C8.76 11 11 8.76 11 6C11 3.24 8.76 1 6 1ZM2 6C2 3.79 3.79 2 6 2C6.925 2 7.775 2.315 8.45 2.845L2.845 8.45C2.315 7.775 2 6.925 2 6ZM6 10C5.075 10 4.225 9.685 3.55 9.155L9.155 3.55C9.685 4.225 10 5.075 10 6C10 8.21 8.21 10 6 10Z'
      fill='#BB032A'
    />
  </svg>
);

export const RightArrowIcon: React.FC<{
  width?: string | number;
  height?: string | number;
}> = ({ width, height }) => (
  <svg
    width={width || '16'}
    height={height || '16'}
    viewBox='0 0 16 16'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M6.47003 4L5.53003 4.94L8.58336 8L5.53003 11.06L6.47003 12L10.47 8L6.47003 4Z'
      fill='var(--text-primary)'
    />
  </svg>
);
export const LeftArrowIcon: React.FC = () => (
  <svg
    width='16'
    height='16'
    viewBox='0 0 16 16'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M10.47 4.94L9.53003 4L5.53003 8L9.53003 12L10.47 11.06L7.4167 8L10.47 4.94Z'
      fill='var(--text-primary)'
    />
  </svg>
);
export const ResetIcon: React.FC = () => (
  <svg
    width='16'
    height='16'
    viewBox='0 0 16 16'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M9 2C5.68667 2 3 4.68667 3 8H1L3.59333 10.5933L3.64 10.6867L6.33333 8H4.33333C4.33333 5.42 6.42 3.33333 9 3.33333C11.58 3.33333 13.6667 5.42 13.6667 8C13.6667 10.58 11.58 12.6667 9 12.6667C7.71333 12.6667 6.54667 12.14 5.70667 11.2933L4.76 12.24C5.84667 13.3267 7.34 14 9 14C12.3133 14 15 11.3133 15 8C15 4.68667 12.3133 2 9 2ZM8.33333 5.33333V8.66667L11.1867 10.36L11.6667 9.55333L9.33333 8.16667V5.33333H8.33333Z'
      fill='var(--text-primary)'
    />
  </svg>
);
export const ChangelogIcon: React.FC<{ color?: string }> = ({
  color = 'var(--text-primary)',
}) => (
  <svg
    width='16'
    height='16'
    viewBox='0 0 16 16'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M11.1666 2.66671C11.9 2.66671 12.5 3.26671 12.5 4.00004V12C12.5 12.7334 11.9 13.3334 11.1666 13.3334V2.66671ZM1.16663 13.3334C1.16663 14.0667 1.76663 14.6667 2.49996 14.6667H8.49996C9.23329 14.6667 9.83329 14.0667 9.83329 13.3334V2.66671C9.83329 1.93337 9.23329 1.33337 8.49996 1.33337H2.49996C1.76663 1.33337 1.16663 1.93337 1.16663 2.66671V13.3334ZM13.8333 12C14.3866 12 14.8333 11.5534 14.8333 11V5.00004C14.8333 4.44671 14.3866 4.00004 13.8333 4.00004V12Z'
      fill={color}
    />
  </svg>
);
export const SensorNotConnectedIcon: React.FC = () => (
  <svg
    width='12'
    height='12'
    viewBox='0 0 12 12'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M4.22247 5.12749C4.17747 5.29249 4.15247 5.46749 4.15247 5.64749C4.15247 6.19749 4.37747 6.69749 4.73747 7.06249L4.02747 7.77249C3.48747 7.22749 3.15247 6.47749 3.15247 5.64749C3.15247 5.18249 3.25747 4.74749 3.44247 4.35249L2.70747 3.61749C2.35247 4.21249 2.15247 4.90749 2.15247 5.64749C2.15247 6.75249 2.60247 7.75249 3.32747 8.47249L2.61747 9.18249C1.71247 8.27749 1.15247 7.02749 1.15247 5.64749C1.15247 4.62749 1.45747 3.68249 1.98247 2.89249L0.847473 1.75749L1.55247 1.05249L10.7425 10.2425L10.0375 10.9475L4.22247 5.12749ZM8.86247 6.94249C9.04747 6.54749 9.15247 6.11249 9.15247 5.64749C9.15247 4.81749 8.81747 4.06749 8.27247 3.52749L7.56247 4.23749C7.92747 4.59749 8.15247 5.09749 8.15247 5.64749C8.15247 5.82749 8.12747 6.00249 8.08247 6.16749L8.86247 6.94249ZM10.1525 5.64749C10.1525 6.38749 9.95247 7.08249 9.59747 7.67749L10.3225 8.40249C10.8475 7.61249 11.1525 6.66749 11.1525 5.64749C11.1525 4.26749 10.5925 3.01749 9.68747 2.11249L8.97747 2.82249C9.70247 3.54249 10.1525 4.54249 10.1525 5.64749Z'
      fill='var(--text-light)'
    />
  </svg>
);

export const CopyIconAlertCustomization: React.FC = () => (
  <svg
    width='16'
    height='16'
    viewBox='0 0 16 16'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M12.3333 1.33325H6.33325C5.59992 1.33325 4.99992 1.93325 4.99992 2.66659V10.6666C4.99992 11.3999 5.59992 11.9999 6.33325 11.9999H12.3333C13.0666 11.9999 13.6666 11.3999 13.6666 10.6666V2.66659C13.6666 1.93325 13.0666 1.33325 12.3333 1.33325ZM12.3333 10.6666H6.33325V2.66659H12.3333V10.6666ZM2.33325 9.99992V8.66659H3.66659V9.99992H2.33325ZM2.33325 6.33325H3.66659V7.66659H2.33325V6.33325ZM6.99992 13.3333H8.33325V14.6666H6.99992V13.3333ZM2.33325 12.3333V10.9999H3.66659V12.3333H2.33325ZM3.66659 14.6666C2.93325 14.6666 2.33325 14.0666 2.33325 13.3333H3.66659V14.6666ZM5.99992 14.6666H4.66659V13.3333H5.99992V14.6666ZM9.33325 14.6666V13.3333H10.6666C10.6666 14.0666 10.0666 14.6666 9.33325 14.6666ZM3.66659 3.99992V5.33325H2.33325C2.33325 4.59992 2.93325 3.99992 3.66659 3.99992Z'
      fill='var(--text-primary)'
    />
  </svg>
);
export const NotificationIcon: React.FC = () => (
  <svg
    width='16'
    height='16'
    viewBox='0 0 16 16'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M13.3334 1.3335H2.66671C1.93337 1.3335 1.34004 1.9335 1.34004 2.66683L1.33337 14.6668L4.00004 12.0002H13.3334C14.0667 12.0002 14.6667 11.4002 14.6667 10.6668V2.66683C14.6667 1.9335 14.0667 1.3335 13.3334 1.3335ZM12 9.3335H4.00004V8.00016H12V9.3335ZM12 7.3335H4.00004V6.00016H12V7.3335ZM12 5.3335H4.00004V4.00016H12V5.3335Z'
      fill='white'
    />
  </svg>
);
export const AttachFileIcon: React.FC = () => (
  <svg
    width='28'
    height='28'
    viewBox='0 0 28 28'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M16.6666 9.99984V17.6665C16.6666 19.1398 15.4733 20.3332 13.9999 20.3332C12.5266 20.3332 11.3333 19.1398 11.3333 17.6665V9.33317C11.3333 8.41317 12.0799 7.6665 12.9999 7.6665C13.9199 7.6665 14.6666 8.41317 14.6666 9.33317V16.3332C14.6666 16.6998 14.3666 16.9998 13.9999 16.9998C13.6333 16.9998 13.3333 16.6998 13.3333 16.3332V9.99984H12.3333V16.3332C12.3333 17.2532 13.0799 17.9998 13.9999 17.9998C14.9199 17.9998 15.6666 17.2532 15.6666 16.3332V9.33317C15.6666 7.85984 14.4733 6.6665 12.9999 6.6665C11.5266 6.6665 10.3333 7.85984 10.3333 9.33317V17.6665C10.3333 19.6932 11.9733 21.3332 13.9999 21.3332C16.0266 21.3332 17.6666 19.6932 17.6666 17.6665V9.99984H16.6666Z'
      fill='var(--text-primary)'
    />
  </svg>
);
export const MentionIcon: React.FC = () => (
  <svg
    width='28'
    height='28'
    viewBox='0 0 28 28'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M13.9999 7.3335C10.3199 7.3335 7.33325 10.3202 7.33325 14.0002C7.33325 17.6802 10.3199 20.6668 13.9999 20.6668H17.3333V19.3335H13.9999C11.1066 19.3335 8.66659 16.8935 8.66659 14.0002C8.66659 11.1068 11.1066 8.66683 13.9999 8.66683C16.8933 8.66683 19.3333 11.1068 19.3333 14.0002V14.9535C19.3333 15.4802 18.8599 16.0002 18.3333 16.0002C17.8066 16.0002 17.3333 15.4802 17.3333 14.9535V14.0002C17.3333 12.1602 15.8399 10.6668 13.9999 10.6668C12.1599 10.6668 10.6666 12.1602 10.6666 14.0002C10.6666 15.8402 12.1599 17.3335 13.9999 17.3335C14.9199 17.3335 15.7599 16.9602 16.3599 16.3535C16.7933 16.9468 17.5399 17.3335 18.3333 17.3335C19.6466 17.3335 20.6666 16.2668 20.6666 14.9535V14.0002C20.6666 10.3202 17.6799 7.3335 13.9999 7.3335ZM13.9999 16.0002C12.8933 16.0002 11.9999 15.1068 11.9999 14.0002C11.9999 12.8935 12.8933 12.0002 13.9999 12.0002C15.1066 12.0002 15.9999 12.8935 15.9999 14.0002C15.9999 15.1068 15.1066 16.0002 13.9999 16.0002Z'
      fill='var(--text-primary)'
    />
  </svg>
);
export const URLIcon: React.FC = () => (
  <svg
    width='28'
    height='28'
    viewBox='0 0 28 28'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M8.59992 13.9998C8.59992 12.8598 9.52659 11.9332 10.6666 11.9332H13.3333V10.6665H10.6666C8.82659 10.6665 7.33325 12.1598 7.33325 13.9998C7.33325 15.8398 8.82659 17.3332 10.6666 17.3332H13.3333V16.0665H10.6666C9.52659 16.0665 8.59992 15.1398 8.59992 13.9998ZM11.3333 14.6665H16.6666V13.3332H11.3333V14.6665ZM17.3333 10.6665H14.6666V11.9332H17.3333C18.4733 11.9332 19.3999 12.8598 19.3999 13.9998C19.3999 15.1398 18.4733 16.0665 17.3333 16.0665H14.6666V17.3332H17.3333C19.1733 17.3332 20.6666 15.8398 20.6666 13.9998C20.6666 12.1598 19.1733 10.6665 17.3333 10.6665Z'
      fill='var(--text-primary)'
    />
  </svg>
);
export const CoCReplyIcon: React.FC = () => (
  <svg
    width='28'
    height='28'
    viewBox='0 0 28 28'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <rect width='28' height='28' rx='14' fill='var(--dark-border)' />
    <path
      d='M12.6667 11.6667V9L8 13.6667L12.6667 18.3333V15.6C16 15.6 18.3333 16.6667 20 19C19.3333 15.6667 17.3333 12.3333 12.6667 11.6667Z'
      fill='var(--text-primary)'
    />
  </svg>
);
export const AtRickCOCIcon: React.FC = () => (
  <svg
    width='36'
    height='36'
    viewBox='0 0 36 36'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <g clipPath='url(#clip0_18192_21505)'>
      <g clipPath='url(#clip1_18192_21505)'>
        <circle cx='18' cy='18' r='18' fill='#F6BC2F' />
        <path
          d='M10.6667 24.3332H25.3334L18.0001 11.6665L10.6667 24.3332ZM18.6667 22.3332H17.3334V20.9998H18.6667V22.3332ZM18.6667 19.6665H17.3334V16.9998H18.6667V19.6665Z'
          fill='white'
        />
      </g>
    </g>
    <defs>
      <clipPath id='clip0_18192_21505'>
        <rect width='36' height='36' fill='white' />
      </clipPath>
      <clipPath id='clip1_18192_21505'>
        <rect width='36' height='36' fill='white' />
      </clipPath>
    </defs>
  </svg>
);
export const RightTailArrowIcon: React.FC<{
  size?: number;
  color?: string;
}> = ({ size = 16, color = 'var(--text-primary)' }) => (
  <svg
    width={size}
    height={size}
    viewBox='0 0 16 16'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M13.3337 7.33329H5.22033L8.94699 3.60663L8.00033 2.66663L2.66699 7.99996L8.00033 13.3333L8.94033 12.3933L5.22033 8.66663H13.3337V7.33329Z'
      fill={color}
    />
  </svg>
);

export const UpArrowIcon: React.FC<{
  size?: number;
  color?: string;
  style?: React.CSSProperties;
}> = ({ size = 12, color = '#DE1135', style = {} }) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width={size}
    height={size}
    viewBox='0 0 12 12'
    fill='none'
    // eslint-disable-next-line react/forbid-dom-props -- forwards the caller's style prop
    style={{ marginRight: '4px', ...style }}
  >
    <path
      d='M2 6L2.705 6.705L5.5 3.915V10H6.5V3.915L9.29 6.71L10 6L6 2L2 6Z'
      fill={color}
    />
  </svg>
);

export const DownArrowIcon: React.FC<{
  size?: number;
  color?: string;
  style?: React.CSSProperties;
}> = ({ size = 12, color = '#008000', style = {} }) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width={size}
    height={size}
    viewBox='0 0 12 12'
    fill='none'
    // eslint-disable-next-line react/forbid-dom-props -- forwards the caller's style prop
    style={{ marginRight: '4px', ...style }}
  >
    <path
      d='M10 6L9.295 5.295L6.5 8.085V2H5.5V8.085L2.71 5.29L2 6L6 10L10 6Z'
      fill={color}
    />
  </svg>
);

export const AirportIcon: React.FC<{
  size?: number;
  style?: React.CSSProperties;
}> = ({ size = 32, style = {} }) => {
  const svgString = `
    <svg xmlns="http://www.w3.org/2000/svg" width="${size}" height="${size}" viewBox="0 0 32 32" fill="none">
      <defs>
        <filter id="pinShadow" x="-50%" y="-50%" width="200%" height="200%">
          <feOffset result="offOut" in="SourceAlpha" dx="0" dy="2" />
          <feGaussianBlur result="blurOut" in="offOut" stdDeviation="2" />
          <feColorMatrix result="matrixOut" in="blurOut" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
          <feBlend in="SourceGraphic" in2="matrixOut" mode="normal" />
        </filter>
      </defs>
      <circle cx="16" cy="16" r="12" fill="#F19164"/>
      <g transform="translate(8, 8)">
        <svg width="16" height="16" viewBox="0 0 16 16" fill="white">
          <path d="M8 1.33203C8.33114 1.33203 8.62125 1.49394 8.80273 1.74121C8.09731 2.51201 7.66699 3.5388 7.66699 4.66602C7.66717 7.0591 9.60687 8.99902 12 8.99902C12.5604 8.99902 13.0953 8.89093 13.5869 8.69727L14.667 9.33203V10.666L9 8.99902V12.666L10.667 13.666V14.666L8 13.999L5.33301 14.666V13.666L7 12.666V8.99902L1.33301 10.666V9.33203L7 5.99902V2.33203C7.00017 1.77885 7.44678 1.33203 8 1.33203ZM12 1.33203C13.8409 1.33203 15.333 2.82507 15.333 4.66602C15.3328 6.44719 13.9359 7.90176 12.1777 7.99414C12.119 7.99687 12.0598 7.99902 12 7.99902C11.9145 7.99902 11.8302 7.99418 11.7471 7.98828C10.0807 7.86321 8.75576 6.51423 8.6709 4.83691L8.66699 4.66602C8.66699 4.604 8.66889 4.54228 8.67188 4.48145V4.47949C8.7148 3.69989 9.02546 2.99162 9.51367 2.44531C9.53008 2.42702 9.54659 2.40873 9.56348 2.39062C10.1719 1.73935 11.0385 1.33203 12 1.33203ZM11.667 4.79883L13.0996 6.26562L13.5996 5.76562L12.333 4.53223V2.66602H11.667V4.79883Z" />
        </svg>
      </g>
    </svg>
  `;

  return (
    <img
      src={`data:image/svg+xml;base64,${btoa(svgString)}`}
      alt='Pin Icon'
      // eslint-disable-next-line react/forbid-dom-props -- forwards the caller's style prop
      style={style}
    />
  );
};

export const MapSettingsIcon: React.FC<IconProps> = ({
  color = 'var(--text-primary)',
  size = 16,
  ...props
}) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width={size}
    height={size}
    viewBox='0 0 16 16'
    fill='none'
    {...props}
  >
    <path
      d='M12.7597 8.62823C12.7864 8.42823 12.7997 8.22156 12.7997 8.00156C12.7997 7.78823 12.7864 7.5749 12.7531 7.3749L14.1064 6.32156C14.2264 6.22823 14.2597 6.04823 14.1864 5.9149L12.9064 3.70156C12.8264 3.5549 12.6597 3.50823 12.5131 3.5549L10.9197 4.1949C10.5864 3.94156 10.2331 3.72823 9.83975 3.56823L9.59975 1.8749C9.57308 1.7149 9.43975 1.60156 9.27975 1.60156H6.71975C6.55975 1.60156 6.43308 1.7149 6.40641 1.8749L6.16641 3.56823C5.77308 3.72823 5.41308 3.94823 5.08641 4.1949L3.49308 3.5549C3.34641 3.50156 3.17975 3.5549 3.09975 3.70156L1.82641 5.9149C1.74641 6.0549 1.77308 6.22823 1.90641 6.32156L3.25975 7.3749C3.22641 7.5749 3.19975 7.7949 3.19975 8.00156C3.19975 8.20823 3.21308 8.42823 3.24641 8.62823L1.89308 9.68156C1.77308 9.7749 1.73975 9.9549 1.81308 10.0882L3.09308 12.3016C3.17308 12.4482 3.33975 12.4949 3.48641 12.4482L5.07975 11.8082C5.41308 12.0616 5.76641 12.2749 6.15975 12.4349L6.39975 14.1282C6.43308 14.2882 6.55975 14.4016 6.71975 14.4016H9.27975C9.43975 14.4016 9.57308 14.2882 9.59308 14.1282L9.83308 12.4349C10.2264 12.2749 10.5864 12.0616 10.9131 11.8082L12.5064 12.4482C12.6531 12.5016 12.8197 12.4482 12.8997 12.3016L14.1797 10.0882C14.2597 9.94156 14.2264 9.7749 14.0997 9.68156L12.7597 8.62823ZM7.99975 10.4016C6.67975 10.4016 5.59975 9.32156 5.59975 8.00156C5.59975 6.68156 6.67975 5.60156 7.99975 5.60156C9.31975 5.60156 10.3997 6.68156 10.3997 8.00156C10.3997 9.32156 9.31975 10.4016 7.99975 10.4016Z'
      fill={color}
    />
  </svg>
);

export const GearIcon: React.FC<{ color?: string; size?: number }> = ({
  color = '#3D81FF',
  size = 20,
}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox='0 0 20 20'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M19.1667 11.2507V8.75065H16.5833C16.4166 7.83398 16.0833 7.00065 15.5833 6.25065L17.4166 4.41732L15.6667 2.66732L13.8335 4.50065C13.0835 4.00065 12.2501 3.66732 11.3335 3.50065V0.833984H8.83346V3.41732C7.91679 3.58399 7.08346 3.91732 6.33346 4.41732L4.49996 2.58399L2.75008 4.33398L4.58337 6.16731C4.08337 6.91731 3.75008 7.75065 3.58341 8.66731H1V11.1673H3.58341C3.75008 12.084 4.08337 12.9173 4.58337 13.6673L2.75008 15.5007L4.49996 17.2506L6.33346 15.4173C7.08346 15.9173 7.91679 16.2506 8.83346 16.4173V19.0007H11.3335V16.4173C12.2501 16.2506 13.0835 15.9173 13.8335 15.4173L15.6667 17.2506L17.4166 15.5007L15.5833 13.6673C16.0833 12.9173 16.4166 12.084 16.5833 11.1673H19.1667V11.2507ZM10 13.334C8.16671 13.334 6.66671 11.834 6.66671 10.0007C6.66671 8.16732 8.16671 6.66732 10 6.66732C11.8334 6.66732 13.3334 8.16732 13.3334 10.0007C13.3334 11.834 11.8334 13.334 10 13.334Z'
        fill={color}
      />
    </svg>
  );
};

export const FlyIcon: React.FC<
  IconProps & { color?: string; size?: number }
> = ({ color = '#3D81FF', size = 18, ...props }) => (
  <svg
    width={size}
    height={size}
    viewBox='0 0 18 18'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M17.3332 12.3337V10.667L10.2498 6.50033V1.91699C10.2498 1.22533 9.6915 0.666992 8.99984 0.666992C8.30817 0.666992 7.74984 1.22533 7.74984 1.91699V6.50033L0.666504 10.667V12.3337L7.74984 10.2503V14.8337L5.6665 16.0837V17.3337L8.99984 16.5003L12.3332 17.3337V16.0837L10.2498 14.8337V10.2503L17.3332 12.3337Z'
      fill={color}
    />
  </svg>
);

export const searchFilter: React.FC<IconProps> = (props) => (
  <svg
    width={12}
    height={12}
    viewBox='0 0 12 12'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M11.3 10.2L9.1001 7.99995C9.6501 7.19995 10 6.24997 10 5.19997C10 2.59997 7.85 0.449951 5.25 0.449951C2.65 0.449951 0.5 2.59997 0.5 5.19997C0.5 7.79997 2.65 9.94997 5.25 9.94997C6.3 9.94997 7.25005 9.59994 8.05005 9.04994L10.25 11.25L11.3 10.2ZM2 5.24995C2 3.44995 3.45 1.99995 5.25 1.99995C7.05 1.99995 8.5 3.44995 8.5 5.24995C8.5 7.04995 7.05 8.49995 5.25 8.49995C3.45 8.49995 2 7.04995 2 5.24995Z'
      fill='var(--text-primary)'
    />
  </svg>
);

export const VideoSquareIcon: React.FC<
  IconProps & { color?: string; size?: number }
> = ({ color = '#3D81FF', size = 20, ...props }) => (
  <svg
    width={size}
    height={size}
    viewBox='0 0 20 20'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    shapeRendering='crispEdges'
    {...props}
  >
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M4.5 2.5C3.39543 2.5 2.5 3.39543 2.5 4.5V15.5C2.5 16.6046 3.39543 17.5 4.5 17.5H15.5C16.6046 17.5 17.5 16.6046 17.5 15.5V4.5C17.5 3.39543 16.6046 2.5 15.5 2.5H4.5ZM12.7083 4.16667H7.29167V10L10 8.54167L12.7083 10V4.16667Z'
      fill={color}
    />
  </svg>
);

export const PhoneIcon: React.FC<{
  width?: number;
  height?: number;
  color?: string;
}> = ({ width = 12, height = 12, color = 'var(--text-primary)' }) => (
  <svg
    width={width}
    height={height}
    viewBox='0 0 12 12'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M3.31 5.395C4.03 6.81 5.19 7.965 6.605 8.69L7.705 7.59C7.84 7.455 8.04 7.41 8.215 7.47C8.775 7.655 9.38 7.755 10 7.755C10.275 7.755 10.5 7.98 10.5 8.255V10C10.5 10.275 10.275 10.5 10 10.5C5.305 10.5 1.5 6.695 1.5 2C1.5 1.725 1.725 1.5 2 1.5H3.75C4.025 1.5 4.25 1.725 4.25 2C4.25 2.625 4.35 3.225 4.535 3.785C4.59 3.96 4.55 4.155 4.41 4.295L3.31 5.395Z'
      fill={color}
    />
  </svg>
);

export const MailIcon: React.FC<{
  width?: number;
  height?: number;
  color?: string;
  style?: React.CSSProperties;
}> = ({ width = 12, height = 12, color = 'var(--text-primary)', style }) => (
  <svg
    width={width}
    height={height}
    // eslint-disable-next-line react/forbid-dom-props -- forwards the caller's style prop
    style={style}
    viewBox='0 0 12 12'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M10 2H2C1.45 2 1.005 2.45 1.005 3L1 9C1 9.55 1.45 10 2 10H10C10.55 10 11 9.55 11 9V3C11 2.45 10.55 2 10 2ZM10 4L6 6.5L2 4V3L6 5.5L10 3V4Z'
      fill={color}
    />
  </svg>
);
export const MailWhiteIcon: React.FC = () => (
  <svg
    width='16'
    height='16'
    viewBox='0 0 16 16'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M13.3333 2.66675H2.66659C1.93325 2.66675 1.33992 3.26675 1.33992 4.00008L1.33325 12.0001C1.33325 12.7334 1.93325 13.3334 2.66659 13.3334H13.3333C14.0666 13.3334 14.6666 12.7334 14.6666 12.0001V4.00008C14.6666 3.26675 14.0666 2.66675 13.3333 2.66675ZM13.3333 5.33341L7.99992 8.66675L2.66659 5.33341V4.00008L7.99992 7.33341L13.3333 4.00008V5.33341Z'
      fill='white'
    />
  </svg>
);
export const TimerIcon: React.FC = () => (
  <svg
    width='16'
    height='16'
    viewBox='0 0 16 16'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M8.00016 1.33325C4.3335 1.33325 1.3335 4.33325 1.3335 7.99992C1.3335 11.6666 4.3335 14.6666 8.00016 14.6666C11.6668 14.6666 14.6668 11.6666 14.6668 7.99992C14.6668 4.33325 11.6668 1.33325 8.00016 1.33325ZM10.8002 10.7999L7.3335 8.66659V4.66659H8.3335V8.13325L11.3335 9.93325L10.8002 10.7999Z'
      fill='var(--text-secondary)'
    />
  </svg>
);

export const PencilIcon: React.FC<IconProps> = ({
  width = 16,
  height = 16,
  color = 'var(--text-secondary)',
}) => (
  <svg
    width={width}
    height={height}
    viewBox='0 0 16 16'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M1.99902 11.5009V14.0009H4.49902L11.8724 6.6276L9.37236 4.1276L1.99902 11.5009ZM13.8057 4.69427C14.0657 4.43427 14.0657 4.01427 13.8057 3.75427L12.2457 2.19427C11.9857 1.93427 11.5657 1.93427 11.3057 2.19427L10.0857 3.41427L12.5857 5.91427L13.8057 4.69427Z'
      fill={color}
    />
  </svg>
);

export const EyeFillIcon: React.FC<IconProps> = ({
  width = 16,
  height = 16,
  color = 'var(--text-primary)',
}) => (
  <svg
    viewBox='0 0 1024 1024'
    width={width}
    height={height}
    fill='currentColor'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M512 186c-192.2 0-335.4 100.5-430.2 300.3a60.3 60.3 0 0 0 0 51.5C176.6 737.5 319.9 838 512 838s335.4-100.5 430.2-300.3a60.3 60.3 0 0 0 0-51.5C847.4 286.5 704.1 186 512 186zm0 502a176 176 0 1 1 0-352 176 176 0 0 1 0 352zm0-288a112 112 0 1 0 0 224 112 112 0 0 0 0-224z'
      fill={color}
    />
  </svg>
);

export const GreenTickIcon: React.FC<IconProps> = ({
  width = 16,
  height = 16,
  color = 'var(--green-900)',
}) => (
  <svg
    width={width}
    height={height}
    viewBox='0 0 16 16'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M7.99992 1.33325C4.31992 1.33325 1.33325 4.31992 1.33325 7.99992C1.33325 11.6799 4.31992 14.6666 7.99992 14.6666C11.6799 14.6666 14.6666 11.6799 14.6666 7.99992C14.6666 4.31992 11.6799 1.33325 7.99992 1.33325ZM6.66659 11.3333L3.33325 7.99992L4.27325 7.05992L6.66659 9.44659L11.7266 4.38659L12.6666 5.33325L6.66659 11.3333Z'
      fill={color}
    />
  </svg>
);
export const GreenTickCircleOutlineIcon: React.FC<IconProps> = ({
  width = 16,
  height = 16,
  color = '#0E8345',
}) => (
  <svg
    width={width}
    height={height}
    viewBox='0 0 12 12'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M6 1C3.24 1 1 3.24 1 6C1 8.76 3.24 11 6 11C8.76 11 11 8.76 11 6C11 3.24 8.76 1 6 1ZM6 10C3.795 10 2 8.205 2 6C2 3.795 3.795 2 6 2C8.205 2 10 3.795 10 6C10 8.205 8.205 10 6 10ZM8.295 3.79L5 7.085L3.705 5.795L3 6.5L5 8.5L9 4.5L8.295 3.79Z'
      fill={color}
    />
  </svg>
);

export const CrossFillIcon: React.FC = () => (
  <svg
    width='16'
    height='16'
    viewBox='0 0 16 16'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M7.99992 1.33325C4.31325 1.33325 1.33325 4.31325 1.33325 7.99992C1.33325 11.6866 4.31325 14.6666 7.99992 14.6666C11.6866 14.6666 14.6666 11.6866 14.6666 7.99992C14.6666 4.31325 11.6866 1.33325 7.99992 1.33325ZM11.3333 10.3933L10.3933 11.3333L7.99992 8.93992L5.60659 11.3333L4.66659 10.3933L7.05992 7.99992L4.66659 5.60659L5.60659 4.66659L7.99992 7.05992L10.3933 4.66659L11.3333 5.60659L8.93992 7.99992L11.3333 10.3933Z'
      fill='var(--text-primary)'
    />
  </svg>
);
export const AIEmailIcon: React.FC = () => (
  <svg
    width='16'
    height='16'
    viewBox='0 0 16 16'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M11.0533 6.75796L7.99992 8.66681L2.66659 5.33348V6.66681L7.99992 10.0001L11.8736 7.57827L12.1952 7.89989C12.4555 8.15989 12.8777 8.15989 13.1379 7.89989L14.6666 6.37124V13.3335C14.6665 14.0667 14.0665 14.6668 13.3333 14.6668H2.66659C1.93333 14.6668 1.33338 14.0667 1.33325 13.3335L1.33976 5.33348C1.33976 4.60015 1.93325 4.00015 2.66659 4.00015H8.29549L11.0533 6.75796Z'
      fill='var(--text-primary)'
    />
    <path
      d='M12.5416 0.338038C12.5845 0.221956 12.7486 0.221956 12.7916 0.338038L13.3007 1.71434C13.4695 2.17052 13.8295 2.52991 14.2857 2.69872L15.662 3.20848C15.778 3.25151 15.7781 3.41554 15.662 3.45848L14.2857 3.9676C13.8296 4.13638 13.4695 4.49587 13.3007 4.95197L12.7916 6.32892C12.7485 6.44466 12.5847 6.44466 12.5416 6.32892L12.0325 4.95197C11.8636 4.49587 11.5036 4.13638 11.0474 3.9676L9.67114 3.45848C9.5551 3.41554 9.55519 3.25151 9.67114 3.20848L11.0474 2.69872C11.5036 2.52991 11.8637 2.17052 12.0325 1.71434L12.5416 0.338038Z'
      fill='var(--text-primary)'
    />
  </svg>
);
export const SupportHeaderIcon: React.FC<{
  width?: number;
  height?: number;
  color?: string;
}> = ({ width, height, color = 'var(--text-primary)' }) => (
  <svg
    width={width || 16}
    height={height || 16}
    viewBox='0 0 16 16'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M7.33333 12H8.66666V10.6667H7.33333V12ZM8 1.33334C4.31999 1.33334 1.33333 4.32001 1.33333 8.00001C1.33333 11.68 4.31999 14.6667 8 14.6667C11.68 14.6667 14.6667 11.68 14.6667 8.00001C14.6667 4.32001 11.68 1.33334 8 1.33334ZM8 13.3333C5.06 13.3333 2.66666 10.94 2.66666 8.00001C2.66666 5.06001 5.06 2.66668 8 2.66668C10.94 2.66668 13.3333 5.06001 13.3333 8.00001C13.3333 10.94 10.94 13.3333 8 13.3333ZM8 4.00001C6.52666 4.00001 5.33333 5.19334 5.33333 6.66668H6.66666C6.66666 5.93334 7.26666 5.33334 8 5.33334C8.73333 5.33334 9.33333 5.93334 9.33333 6.66668C9.33333 8.00001 7.33333 7.83334 7.33333 10H8.66666C8.66666 8.50001 10.6667 8.33334 10.6667 6.66668C10.6667 5.19334 9.47333 4.00001 8 4.00001Z'
      fill={color}
    />
  </svg>
);
export const AICallIcon: React.FC<{
  size?: number;
  color?: string;
}> = ({ size = 16, color = 'var(--text-primary)' }) => (
  <svg
    width={size}
    height={size}
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M6.5 4.00033C7.05 4.00033 7.5 4.45033 7.5 5.00033C7.50004 6.25013 7.70039 7.44982 8.07031 8.56966C8.1803 8.91964 8.10026 9.31018 7.82031 9.59017L5.62012 11.7904C7.06013 14.6202 9.38007 16.9303 12.21 18.3802L14.4102 16.18C14.6801 15.9102 15.0798 15.82 15.4297 15.9398C16.5497 16.3098 17.76 16.5101 19 16.5101C19.55 16.5101 20 16.9601 20 17.5101V21.0003C19.9998 21.5502 19.5499 22.0003 19 22.0003C9.61011 22.0003 2.00018 14.3902 2 5.00033C2 4.45033 2.45 4.00033 3 4.00033H6.5ZM16.3125 2.50716C16.3769 2.33304 16.6231 2.33304 16.6875 2.50716L17.5869 4.93685C17.8402 5.62087 18.3794 6.16025 19.0635 6.41341L21.4932 7.31283C21.6671 7.37737 21.6672 7.62342 21.4932 7.68783L19.0635 8.58627C18.3792 8.83948 17.8401 9.37951 17.5869 10.0638L16.6875 12.4935C16.6229 12.6671 16.3771 12.6671 16.3125 12.4935L15.4131 10.0638C15.1599 9.37951 14.6208 8.83948 13.9365 8.58627L11.5068 7.68783C11.3328 7.62342 11.3329 7.37737 11.5068 7.31283L13.9365 6.41341C14.6206 6.16025 15.1598 5.62087 15.4131 4.93685L16.3125 2.50716Z'
      fill={color}
    />
  </svg>
);
export const GxPAlertBannerIcon: React.FC<{
  size?: number;
  color?: string;
}> = ({ size = 24, color = '#9F6402' }) => (
  <svg
    width={size}
    height={size}
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M15 13V5C15 3.34 13.66 2 12 2C10.34 2 9 3.34 9 5V13C7.79 13.91 7 15.37 7 17C7 19.76 9.24 22 12 22C14.76 22 17 19.76 17 17C17 15.37 16.21 13.91 15 13ZM11 5C11 4.45 11.45 4 12 4C12.55 4 13 4.45 13 5H12V6H13V8H12V9H13V11H11V5Z'
      fill={color}
    />
  </svg>
);
export const COCGxPReportIcon: React.FC<{
  size?: number;
  color?: string;
}> = ({ size = 16, color = 'var(--text-primary)' }) => (
  <svg
    width={size}
    height={size}
    viewBox='0 0 16 16'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M2.66675 4.66667H13.3334V6H2.66675V4.66667ZM2.66675 8.66667H13.3334V7.33333H2.66675V8.66667ZM2.66675 11.3333H7.33341V10H2.66675V11.3333ZM2.66675 14H7.33341V12.6667H2.66675V14ZM10.2734 12.1133L9.33341 11.1667L8.39341 12.1067L10.2734 14L13.3334 10.9467L12.3867 10L10.2734 12.1133ZM2.66675 2V3.33333H13.3334V2H2.66675Z'
      fill={color}
    />
  </svg>
);
export const COCDismissIcon: React.FC = () => (
  <svg
    width='16'
    height='16'
    viewBox='0 0 16 16'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M7.99998 1.33337C4.31998 1.33337 1.33331 4.32004 1.33331 8.00004C1.33331 11.68 4.31998 14.6667 7.99998 14.6667C11.68 14.6667 14.6666 11.68 14.6666 8.00004C14.6666 4.32004 11.68 1.33337 7.99998 1.33337ZM11.3333 8.66671H4.66665V7.33337H11.3333V8.66671Z'
      fill='var(--text-primary)'
    />
  </svg>
);
export const OneTimeTiemlineIcon: React.FC = () => (
  <svg
    width='36'
    height='36'
    viewBox='0 0 36 36'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <g clipPath='url(#clip0_18756_8955)'>
      <g clipPath='url(#clip1_18756_8955)'>
        <circle cx='18' cy='18' r='18' fill='var(--gray-600)' />
        <path
          d='M11.0067 24L25 18L11.0067 12L11 16.6667L21 18L11 19.3333L11.0067 24Z'
          fill='white'
        />
      </g>
    </g>
    <defs>
      <clipPath id='clip0_18756_8955'>
        <rect width='36' height='36' fill='white' />
      </clipPath>
      <clipPath id='clip1_18756_8955'>
        <rect width='36' height='36' fill='white' />
      </clipPath>
    </defs>
  </svg>
);

export const AiStar: React.FC<
  IconProps & { color?: string; size?: number }
> = ({ color, size = 16, ...props }) => (
  <svg
    width={size}
    height={size}
    viewBox='0 0 16 16'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M6.54164 4.33793C6.5846 4.22184 6.74878 4.22184 6.79174 4.33793L7.46888 6.16788C7.87402 7.26275 8.73726 8.126 9.83214 8.53114L11.6621 9.20828C11.7782 9.25123 11.7782 9.41542 11.6621 9.45837L9.83214 10.1355C8.73726 10.5407 7.87402 11.4039 7.46888 12.4988L6.79174 14.3287C6.74878 14.4448 6.5846 14.4448 6.54164 14.3287L5.8645 12.4988C5.45936 11.4039 4.59612 10.5407 3.50124 10.1355L1.67129 9.45837C1.55521 9.41542 1.55521 9.25123 1.67129 9.20828L3.50124 8.53114C4.59612 8.126 5.45936 7.26275 5.8645 6.16788L6.54164 4.33793Z'
      fill={color}
    />
    <path
      d='M11.875 1.67126C11.9179 1.55518 12.0821 1.55518 12.1251 1.67126L12.4543 2.56102C12.6231 3.01721 12.9828 3.3769 13.439 3.54571L14.3288 3.87495C14.4448 3.9179 14.4448 4.08208 14.3288 4.12504L13.439 4.45428C12.9828 4.62309 12.6231 4.98277 12.4543 5.43897L12.1251 6.32873C12.0821 6.44481 11.9179 6.44481 11.875 6.32872L11.5457 5.43897C11.3769 4.98277 11.0172 4.62309 10.561 4.45428L9.67129 4.12504C9.55521 4.08208 9.55521 3.9179 9.67129 3.87495L10.561 3.54571C11.0172 3.3769 11.3769 3.01721 11.5457 2.56101L11.875 1.67126Z'
      fill={color}
    />
  </svg>
);

export const GridIcon: React.FC<
  IconProps & { color?: string; size?: number }
> = ({ color = '#3D81FF', size = 20, ...props }) => (
  <svg
    width={size}
    height={size}
    viewBox='0 0 20 20'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    shapeRendering='crispEdges'
    {...props}
  >
    <path
      d='M2.5 10.8333H9.16667V2.5H2.5V10.8333ZM2.5 17.5H9.16667V12.5H2.5V17.5ZM10.8333 17.5H17.5V9.16667H10.8333V17.5ZM10.8333 2.5V7.5H17.5V2.5H10.8333Z'
      fill={color}
    />
  </svg>
);

export const HomeIcon: React.FC<
  IconProps & { color?: string; size?: number }
> = ({ color = '#fff', size = 20, ...props }) => (
  <svg
    width={size}
    height={size}
    viewBox='0 0 20 20'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M8.33329 17.0833V12.0833H11.6666V17.0833H15.8333V10.4166H18.3333L9.99996 2.91663L1.66663 10.4166H4.16663V17.0833H8.33329Z'
      fill={color}
    />
  </svg>
);

export const AIHistoryPageIcon: React.FC<
  IconProps & { color?: string; size?: number }
> = ({ color = '#266EF1', size = 20, ...props }) => (
  <svg
    width={size}
    height={size}
    viewBox='0 0 20 20'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M8.17699 5.42242C8.23069 5.27731 8.43592 5.27731 8.48961 5.42242L9.33604 7.70985C9.84246 9.07845 10.9215 10.1575 12.2901 10.6639L14.5776 11.5104C14.7227 11.564 14.7227 11.7693 14.5775 11.823L12.2901 12.6694C10.9215 13.1758 9.84246 14.2549 9.33604 15.6235L8.48961 17.9109C8.43592 18.056 8.23069 18.056 8.17699 17.9109L7.33056 15.6235C6.82414 14.2549 5.74509 13.1758 4.37649 12.6694L2.08905 11.823C1.94395 11.7693 1.94395 11.5641 2.08905 11.5104L4.37649 10.6639C5.74509 10.1575 6.82414 9.07845 7.33056 7.70985L8.17699 5.42242Z'
      fill={color}
    />
    <path
      d='M14.8437 2.08908C14.8974 1.94398 15.1026 1.94398 15.1563 2.08908L15.5678 3.20128C15.7788 3.77153 16.2284 4.22113 16.7987 4.43214L17.9109 4.84369C18.056 4.89738 18.056 5.10261 17.9109 5.15631L16.7987 5.56786C16.2284 5.77887 15.7788 6.22847 15.5678 6.79872L15.1563 7.91091C15.1026 8.05602 14.8974 8.05602 14.8437 7.91091L14.4321 6.79872C14.2211 6.22847 13.7715 5.77887 13.2012 5.56786L12.0891 5.15631C11.9439 5.10261 11.9439 4.89738 12.0891 4.84369L13.2012 4.43214C13.7715 4.22113 14.2211 3.77152 14.4321 3.20128L14.8437 2.08908Z'
      fill={color}
    />
  </svg>
);

export const InventoryPageColorIcon: React.FC<
  IconProps & { color?: string; size?: number }
> = ({ color = '#266EF1', size = 20, ...props }) => (
  <svg
    width={size}
    height={size}
    viewBox='0 0 20 20'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M18.3333 17.5V5.83333L9.99996 2.5L1.66663 5.83333V17.5H5.83329V10H14.1666V17.5H18.3333ZM9.16663 15.8333H7.49996V17.5H9.16663V15.8333ZM10.8333 13.3333H9.16663V15H10.8333V13.3333ZM12.5 15.8333H10.8333V17.5H12.5V15.8333Z'
      fill={color}
    />
  </svg>
);
export const TruckIcon: React.FC<IconProps> = ({
  width = 24,
  height = 24,
  color = 'var(--text-primary)',
}) => (
  <svg
    width={width}
    height={height}
    viewBox='0 0 22 16'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M16 4H19L22 8V13H19.5674L19.5547 13.2578C19.4255 14.53 18.3511 15.5232 17.0449 15.5234C15.7385 15.5234 14.6634 14.5301 14.5342 13.2578L14.5215 13H7.52344L7.50977 13.2578C7.38054 14.53 6.30628 15.5225 5 15.5225C3.69372 15.5225 2.61946 14.53 2.49023 13.2578L2.47754 13H0V2C0 1.45 0.196224 0.979557 0.587891 0.587891C0.979557 0.196224 1.45 0 2 0H16V4ZM16 6V9H20.25L18 6H16Z'
      fill={color}
    />
  </svg>
);

export const ClockIcon: React.FC<IconProps> = ({
  width = 24,
  height = 24,
  color = 'var(--text-primary)',
}) => (
  <svg
    width={width}
    height={height}
    viewBox='0 0 20 20'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M9.99 0C4.47 0 0 4.48 0 10C0 15.52 4.47 20 9.99 20C15.52 20 20 15.52 20 10C20 4.48 15.52 0 9.99 0ZM13.29 14.71L9 10.41V5H11V9.59L14.71 13.3L13.29 14.71Z'
      fill={color}
    />
  </svg>
);

export const LocationIcon: React.FC<IconProps> = ({
  width = 24,
  height = 24,
  color = 'var(--text-primary)',
}) => (
  <svg
    width={width}
    height={height}
    viewBox='0 0 14 20'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M7 0C3.13 0 0 3.13 0 7C0 12.25 7 20 7 20C7 20 14 12.25 14 7C14 3.13 10.87 0 7 0ZM7 9.5C5.62 9.5 4.5 8.38 4.5 7C4.5 5.62 5.62 4.5 7 4.5C8.38 4.5 9.5 5.62 9.5 7C9.5 8.38 8.38 9.5 7 9.5Z'
      fill={color}
    />
  </svg>
);

export const EditLocationAltIcon: React.FC<IconProps> = ({
  width = 16,
  height = 16,
  color = 'var(--text-primary)',
}) => (
  <svg
    width={width}
    height={height}
    viewBox='0 8 16 16'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    aria-hidden='true'
    focusable='false'
  >
    <path
      d='M8.966 17h-3.3v-3.3l3.74-3.74a5.5 5.5 0 0 0-1.74-.293c-2.8 0-5.333 2.146-5.333 5.466q.002 3.32 5.333 7.867 5.332-4.548 5.334-7.867c0-.673-.107-1.293-.3-1.866z'
      fill={color}
    />
    <path
      d='M7 15.667h1.413l4.107-4.107-1.414-1.413L7 14.253zM13.473 9.667 13 9.193A.68.68 0 0 0 12.526 9a.8.8 0 0 0-.473.193l-.48.48 1.413 1.414.48-.48a.66.66 0 0 0 .007-.94'
      fill={color}
    />
  </svg>
);

/** Material Symbols "route", as the design system draws it. */
export const MaterialRouteIcon: React.FC<IconProps> = ({
  width = 10.67,
  height = 10.67,
  color = 'var(--text-primary)',
}) => (
  <svg
    width={width}
    height={height}
    viewBox='0 0 10.6667 10.6667'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    aria-hidden='true'
    focusable='false'
  >
    <path
      d='M8.44444 6.74667V3.11111C8.44444 2.12889 7.64889 1.33333 6.66667 1.33333C5.68444 1.33333 4.88889 2.12889 4.88889 3.11111V7.55556C4.88889 8.04444 4.48889 8.44444 4 8.44444C3.51111 8.44444 3.11111 8.04444 3.11111 7.55556V3.92C3.62667 3.73333 4 3.24444 4 2.66667C4 1.92889 3.40444 1.33333 2.66667 1.33333C1.92889 1.33333 1.33333 1.92889 1.33333 2.66667C1.33333 3.24444 1.70667 3.73333 2.22222 3.92V7.55556C2.22222 8.53778 3.01778 9.33333 4 9.33333C4.98222 9.33333 5.77778 8.53778 5.77778 7.55556V3.11111C5.77778 2.62222 6.17778 2.22222 6.66667 2.22222C7.15556 2.22222 7.55556 2.62222 7.55556 3.11111V6.74667C7.04 6.92889 6.66667 7.41778 6.66667 8C6.66667 8.73778 7.26222 9.33333 8 9.33333C8.73778 9.33333 9.33333 8.73778 9.33333 8C9.33333 7.42222 8.96 6.93333 8.44444 6.74667Z'
      fill={color}
    />
  </svg>
);

export const RouteIcon: React.FC<IconProps> = ({
  width = 16,
  height = 16,
  color = 'var(--text-primary)',
}) => (
  <svg
    width={width}
    height={height}
    viewBox='0 0 16 16'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    aria-hidden='true'
    focusable='false'
  >
    <circle cx='3.5' cy='3.5' r='1.75' stroke={color} strokeWidth='1.5' />
    <circle cx='12.5' cy='12.5' r='1.75' stroke={color} strokeWidth='1.5' />
    <path
      d='M5.25 3.5H10a2 2 0 0 1 0 4H6a2 2 0 0 0 0 4h4.75'
      stroke={color}
      strokeWidth='1.5'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </svg>
);

export const ChevronDownIcon: React.FC<
  IconProps & { size?: number; color?: string }
> = ({ size = 24, color = 'var(--text-primary)', ...props }) => (
  <svg
    width={size}
    height={size}
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    aria-hidden='true'
    focusable='false'
    {...props}
  >
    <path
      d='M16.59 8.29498L12 12.875L7.41 8.29498L6 9.70498L12 15.705L18 9.70498L16.59 8.29498Z'
      fill={color}
    />
  </svg>
);

export const ChevronDownSmallIcon: React.FC<
  IconProps & { size?: number; color?: string }
> = ({ size = 16, color = 'var(--text-primary)' }) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width={size}
    height={size}
    fill='none'
    viewBox='0 0 16 16'
    aria-hidden='true'
    focusable='false'
  >
    <path fill={color} d='M12 5.333v2.534l-4 3.066-4-3.066V5.333L8 8.4z'></path>
  </svg>
);

export const ChevronUpIcon: React.FC<
  IconProps & { size?: number; color?: string }
> = ({ size = 24, color = 'var(--text-secondary)' }) => (
  <svg
    width={size || '16'}
    height={size || '16'}
    viewBox='0 0 16 16'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M8 5.53003L4 9.53003L4.94 10.47L8 7.4167L11.06 10.47L12 9.53003L8 5.53003Z'
      fill={color}
    />
  </svg>
);

export const AIstaricIcon: React.FC = () => (
  <svg
    width='16'
    height='16'
    viewBox='0 0 16 16'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M6.47902 4.50693C6.54345 4.33281 6.78972 4.33281 6.85416 4.50693L7.14963 5.30543C7.75734 6.94775 9.0522 8.24261 10.6945 8.85032L11.493 9.14579C11.6671 9.21023 11.6671 9.4565 11.493 9.52093L10.6945 9.81641C9.0522 10.4241 7.75734 11.719 7.14963 13.3613L6.85416 14.1598C6.78972 14.3339 6.54345 14.3339 6.47901 14.1598L6.18354 13.3613C5.57583 11.719 4.28097 10.4241 2.63865 9.81641L1.84015 9.52093C1.66603 9.4565 1.66603 9.21023 1.84015 9.14579L2.63865 8.85032C4.28097 8.24261 5.57583 6.94775 6.18354 5.30543L6.47902 4.50693Z'
      fill='#3D81FF'
    />
    <path
      d='M11.8123 1.84027C11.8768 1.66615 12.1231 1.66615 12.1875 1.84028L12.3212 2.2017C12.5744 2.88599 13.114 3.42552 13.7983 3.67873L14.1597 3.81247C14.3338 3.8769 14.3338 4.12318 14.1597 4.18761L13.7983 4.32135C13.114 4.57456 12.5744 5.11409 12.3212 5.79839L12.1875 6.15981C12.1231 6.33393 11.8768 6.33393 11.8123 6.15981L11.6786 5.79839C11.4254 5.11409 10.8859 4.57456 10.2016 4.32135L9.84015 4.18761C9.66603 4.12318 9.66603 3.8769 9.84015 3.81247L10.2016 3.67873C10.8859 3.42552 11.4254 2.88599 11.6786 2.20169L11.8123 1.84027Z'
      fill='#3D81FF'
    />
  </svg>
);

export const StarIcon: React.FC<{
  width?: number;
  height?: number;
  color?: string;
}> = ({ width = 14, height = 14, color = '#266EF1' }) => (
  <svg
    width={width}
    height={height}
    viewBox='0 0 14 14'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M5.54164 3.33796C5.5846 3.22187 5.74878 3.22187 5.79174 3.33796L6.46888 5.16791C6.87402 6.26278 7.73726 7.12603 8.83214 7.53117L10.6621 8.20831C10.7782 8.25126 10.7782 8.41545 10.6621 8.4584L8.83214 9.13554C7.73726 9.54069 6.87402 10.4039 6.46888 11.4988L5.79174 13.3288C5.74878 13.4448 5.5846 13.4448 5.54164 13.3288L4.8645 11.4988C4.45936 10.4039 3.59612 9.54069 2.50124 9.13554L0.67129 8.4584C0.555208 8.41545 0.555208 8.25126 0.67129 8.20831L2.50124 7.53117C3.59612 7.12603 4.45936 6.26278 4.8645 5.16791L5.54164 3.33796Z'
      fill={color}
    />
    <path
      d='M10.875 0.67129C10.9179 0.555208 11.0821 0.555208 11.1251 0.67129L11.4543 1.56105C11.6231 2.01724 11.9828 2.37693 12.439 2.54574L13.3288 2.87498C13.4448 2.91793 13.4448 3.08212 13.3288 3.12507L12.439 3.45431C11.9828 3.62312 11.6231 3.9828 11.4543 4.439L11.1251 5.32876C11.0821 5.44484 10.9179 5.44484 10.875 5.32876L10.5457 4.439C10.3769 3.9828 10.0172 3.62312 9.56105 3.45431L8.67129 3.12507C8.55521 3.08212 8.55521 2.91793 8.67129 2.87498L9.56105 2.54574C10.0172 2.37693 10.3769 2.01724 10.5457 1.56105L10.875 0.67129Z'
      fill={color}
    />
  </svg>
);

export const AIChatExpandMoreIcon: React.FC<{
  width?: number;
  height?: number;
  color?: string;
}> = ({ width = 16, height = 16, color = 'var(--text-primary)' }) => (
  <svg
    width={width}
    height={height}
    viewBox='0 0 16 16'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M11.06 5.53L8 8.58333L4.94 5.53L4 6.47L8 10.47L12 6.47L11.06 5.53Z'
      fill={color}
    />
  </svg>
);

export const AIChatChevronLeftIcon: React.FC<{
  width?: number;
  height?: number;
  color?: string;
}> = ({ width = 16, height = 16, color = 'var(--text-primary)' }) => (
  <svg
    width={width}
    height={height}
    viewBox='0 0 16 16'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M10.06 12.6667L5.39331 8L10.06 3.33333L11 4.27333L7.27331 8L11 11.7267L10.06 12.6667Z'
      fill={color}
    />
  </svg>
);

export const AIChatSearchIcon: React.FC<{
  width?: number;
  height?: number;
  color?: string;
}> = ({ width = 16, height = 16, color = 'var(--text-primary)' }) => (
  <svg
    width={width}
    height={height}
    viewBox='0 0 16 16'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M6.66667 11.3333C5.37778 11.3333 4.27778 10.8778 3.36667 9.96667C2.45556 9.05556 2 7.95556 2 6.66667C2 5.37778 2.45556 4.27778 3.36667 3.36667C4.27778 2.45556 5.37778 2 6.66667 2C7.95556 2 9.05556 2.45556 9.96667 3.36667C10.8778 4.27778 11.3333 5.37778 11.3333 6.66667C11.3333 7.16667 11.2556 7.63889 11.1 8.08333C10.9444 8.52778 10.7333 8.92222 10.4667 9.26667L14 12.8L12.8 14L9.26667 10.4667C8.92222 10.7333 8.52778 10.9444 8.08333 11.1C7.63889 11.2556 7.16667 11.3333 6.66667 11.3333ZM6.66667 10C7.58889 10 8.37222 9.67778 9.01667 9.03333C9.66111 8.38889 9.98333 7.60556 9.98333 6.68333C9.98333 5.76111 9.66111 4.97778 9.01667 4.33333C8.37222 3.68889 7.58889 3.36667 6.66667 3.36667C5.74444 3.36667 4.96111 3.68889 4.31667 4.33333C3.67222 4.97778 3.35 5.76111 3.35 6.68333C3.35 7.60556 3.67222 8.38889 4.31667 9.03333C4.96111 9.67778 5.74444 10 6.66667 10Z'
      fill={color}
    />
  </svg>
);

export const AIChatAssignmentTurnedInIcon: React.FC<{
  width?: number;
  height?: number;
  color?: string;
}> = ({ width = 16, height = 16, color = 'var(--text-primary)' }) => (
  <svg
    width={width}
    height={height}
    viewBox='0 0 16 16'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M12.6667 2.66667H9.88C9.6 1.89333 8.86667 1.33333 8 1.33333C7.13333 1.33333 6.4 1.89333 6.12 2.66667H3.33333C2.6 2.66667 2 3.26667 2 4V13.3333C2 14.0667 2.6 14.6667 3.33333 14.6667H12.6667C13.4 14.6667 14 14.0667 14 13.3333V4C14 3.26667 13.4 2.66667 12.6667 2.66667ZM8 2.66667C8.36667 2.66667 8.66667 2.96667 8.66667 3.33333C8.66667 3.7 8.36667 4 8 4C7.63333 4 7.33333 3.7 7.33333 3.33333C7.33333 2.96667 7.63333 2.66667 8 2.66667ZM6.66667 12L4 9.33333L4.94 8.39333L6.66667 10.1133L11.06 5.72L12 6.66667L6.66667 12Z'
      fill={color}
    />
  </svg>
);

export const AIChatEditSquareIcon: React.FC<{
  width?: number;
  height?: number;
  color?: string;
}> = ({ width = 16, height = 16, color = 'var(--text-primary)' }) => (
  <svg
    width={width}
    height={height}
    viewBox='0 0 16 16'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M3.33333 14C2.96667 14 2.65278 13.8694 2.39167 13.6083C2.13056 13.3472 2 13.0333 2 12.6667V3.33333C2 2.96667 2.13056 2.65278 2.39167 2.39167C2.65278 2.13056 2.96667 2 3.33333 2H9.28333L7.95 3.33333H3.33333V12.6667H12.6667V8.03333L14 6.7V12.6667C14 13.0333 13.8694 13.3472 13.6083 13.6083C13.3472 13.8694 13.0333 14 12.6667 14H3.33333ZM6 10V7.16667L12.1167 1.05C12.25 0.916667 12.4 0.816667 12.5667 0.75C12.7333 0.683333 12.9 0.65 13.0667 0.65C13.2444 0.65 13.4139 0.683333 13.575 0.75C13.7361 0.816667 13.8833 0.916667 14.0167 1.05L14.95 2C15.0722 2.13333 15.1667 2.28056 15.2333 2.44167C15.3 2.60278 15.3333 2.76667 15.3333 2.93333C15.3333 3.1 15.3028 3.26389 15.2417 3.425C15.1806 3.58611 15.0833 3.73333 14.95 3.86667L8.83333 10H6Z'
      fill={color}
    />
  </svg>
);

export const AIChatExpandIcon: React.FC<{
  width?: number;
  height?: number;
  color?: string;
}> = ({ width = 16, height = 16, color = 'var(--text-primary)' }) => (
  <svg
    width={width}
    height={height}
    viewBox='0 0 16 16'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M3.33333 12.6667V8.66667H4.66667V11.3333H7.33333V12.6667H3.33333ZM11.3333 7.33333V4.66667H8.66667V3.33333H12.6667V7.33333H11.3333Z'
      fill={color}
    />
  </svg>
);

export const AIChatCollapseIcon: React.FC<{
  width?: number;
  height?: number;
  color?: string;
}> = ({ width = 36, height = 36, color = 'var(--text-primary)' }) => (
  <svg
    width={width}
    height={height}
    viewBox='0 0 36 36'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M17.333 18.667v4H16V20h-2.667v-1.333zM20 13.333V16h2.667v1.333h-4v-4z'
      fill={color}
    />
  </svg>
);

export const AIChatThumbUpIcon: React.FC<{
  width?: number;
  height?: number;
  color?: string;
}> = ({ width = 16, height = 16, color = '#AFAFAF' }) => (
  <svg
    width={width}
    height={height}
    viewBox='0 0 16 16'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M0.666667 14.6667H3.33333V6.66667H0.666667V14.6667ZM15.3333 7.33333C15.3333 6.6 14.7333 6 14 6H9.79333L10.4267 2.95333L10.4467 2.74C10.4467 2.46667 10.3333 2.21333 10.1533 2.03333L9.44667 1.33333L5.06 5.72667C4.81333 5.96667 4.66667 6.3 4.66667 6.66667V13.3333C4.66667 14.0667 5.26667 14.6667 6 14.6667H12C12.5533 14.6667 13.0267 14.3333 13.2267 13.8533L15.24 9.15333C15.3 9 15.3333 8.84 15.3333 8.66667V7.33333Z'
      fill={color}
    />
  </svg>
);

export const AIChatThumbDownIcon: React.FC<{
  width?: number;
  height?: number;
  color?: string;
}> = ({ width = 16, height = 16, color = '#AFAFAF' }) => (
  <svg
    width={width}
    height={height}
    viewBox='0 0 16 16'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M10 1.33333H4C3.44667 1.33333 2.97333 1.66667 2.77333 2.14667L0.76 6.84667C0.7 7 0.666667 7.16 0.666667 7.33333V8.66667C0.666667 9.4 1.26667 10 2 10H6.20667L5.57333 13.0467L5.55333 13.26C5.55333 13.5333 5.66667 13.7867 5.84667 13.9667L6.55333 14.6667L10.9467 10.2733C11.1867 10.0333 11.3333 9.7 11.3333 9.33333V2.66667C11.3333 1.93333 10.7333 1.33333 10 1.33333ZM12.6667 1.33333V9.33333H15.3333V1.33333H12.6667Z'
      fill={color}
    />
  </svg>
);

export const AIChatContentCopyIcon: React.FC<{
  width?: number;
  height?: number;
  color?: string;
}> = ({ width = 16, height = 16, color = '#AFAFAF' }) => (
  <svg
    width={width}
    height={height}
    viewBox='0 0 16 16'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M11 0.666667H3C2.26667 0.666667 1.66667 1.26667 1.66667 2V11.3333H3V2H11V0.666667ZM13 3.33333H5.66667C4.93333 3.33333 4.33333 3.93333 4.33333 4.66667V14C4.33333 14.7333 4.93333 15.3333 5.66667 15.3333H13C13.7333 15.3333 14.3333 14.7333 14.3333 14V4.66667C14.3333 3.93333 13.7333 3.33333 13 3.33333Z'
      fill={color}
    />
  </svg>
);

export const AIChatCodeIcon: React.FC<{
  width?: number;
  height?: number;
  color?: string;
}> = ({ width = 16, height = 16, color = 'var(--text-primary)' }) => (
  <svg
    width={width}
    height={height}
    viewBox='0 0 16 16'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M6.26667 11.0667L3.2 8L6.26667 4.93333L5.33333 4L1.33333 8L5.33333 12L6.26667 11.0667ZM9.73333 11.0667L12.8 8L9.73333 4.93333L10.6667 4L14.6667 8L10.6667 12L9.73333 11.0667Z'
      fill={color}
    />
  </svg>
);

export const AIChatBookmarkIcon: React.FC<{
  width?: number;
  height?: number;
  color?: string;
}> = ({ width = 16, height = 16, color = 'var(--text-secondary)' }) => (
  <svg
    width={width}
    height={height}
    viewBox='0 0 16 16'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M11.3333 2H4.66667C3.93333 2 3.34 2.6 3.34 3.33333L3.33333 14L8 12L12.6667 14V3.33333C12.6667 2.6 12.0667 2 11.3333 2Z'
      fill={color}
    />
  </svg>
);

export const CustomLogoIcon: React.FC<IconProps> = (props) => (
  <svg
    width='20'
    height='20'
    viewBox='0 0 20 20'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M17.1875 4.49121C17.5393 11.0619 15.9433 14.2864 10.2207 18.75C8.88965 17.7125 7.77815 16.7464 6.85352 15.7842C10.4315 14.3974 12.1041 13.041 13.7852 10.6484C11.1572 12.6231 9.3062 13.8052 5.82617 14.6191C5.16208 13.7902 4.62579 12.9433 4.19922 12.0342C8.95819 11.178 11.7896 9.07964 13.1367 7.31445C11.2724 8.39074 8.57049 10.1578 3.66113 10.6816C3.40732 9.92053 3.2134 9.10995 3.07227 8.22852C6.33411 7.48199 8.03288 6.75275 9.89648 5.46289C7.93762 6.31413 6.3743 6.80899 2.92285 7.10059C2.83736 6.29287 2.78683 5.42739 2.7666 4.49121L10.2207 1.25L17.1875 4.49121Z'
      fill='url(#paint0_linear_18876_10403)'
      fillOpacity='0.78'
    />
    <defs>
      <linearGradient
        id='paint0_linear_18876_10403'
        x1='17.3499'
        y1='4.65278'
        x2='0.0119721'
        y2='4.65278'
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#065DFF' />
        <stop offset='1' stopColor='#0E8345' stopOpacity='0.33' />
      </linearGradient>
    </defs>
  </svg>
);

export const BellIcon: React.FC<
  {
    width?: number;
    height?: number;
    color?: string;
  } & React.SVGProps<SVGSVGElement>
> = ({ width = 14, height = 14, color = 'var(--text-primary)', ...props }) => (
  <svg
    width={width}
    height={height}
    viewBox='0 0 12 14'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M5.99984 13.5C6.73317 13.5 7.33317 12.9 7.33317 12.1667H4.6665C4.6665 12.9 5.25984 13.5 5.99984 13.5ZM9.99984 9.5V6.16667C9.99984 4.12 8.9065 2.40667 6.99984 1.95333V1.5C6.99984 0.946667 6.55317 0.5 5.99984 0.5C5.4465 0.5 4.99984 0.946667 4.99984 1.5V1.95333C3.0865 2.40667 1.99984 4.11333 1.99984 6.16667V9.5L0.666504 10.8333V11.5H11.3332V10.8333L9.99984 9.5Z'
      fill={color}
    />
  </svg>
);

export const MuteBellIcon: React.FC<
  {
    width?: number;
    height?: number;
    color?: string;
  } & React.SVGProps<SVGSVGElement>
> = ({ width = 14, height = 14, color = 'var(--text-primary)', ...props }) => (
  <svg
    width={width}
    height={height}
    viewBox='0 0 16 16'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M13.0002 12.2933L3.18016 2.16L2.3335 3.00667L4.20016 4.87333V4.88C3.8535 5.54 3.66683 6.32 3.66683 7.16V10.4933L2.3335 11.8267V12.4933H11.4868L12.8202 13.8267L13.6668 12.98L13.0002 12.2933ZM7.66683 14.5C8.40683 14.5 9.00016 13.9067 9.00016 13.1667H6.3335C6.3335 13.9067 6.92683 14.5 7.66683 14.5ZM11.6668 9.62V7.16667C11.6668 5.11333 10.5735 3.40667 8.66683 2.95333V2.5C8.66683 1.94667 8.22016 1.5 7.66683 1.5C7.1135 1.5 6.66683 1.94667 6.66683 2.5V2.95333C6.56683 2.97333 6.4735 3.00667 6.38683 3.03333C6.32016 3.05333 6.2535 3.08 6.18683 3.10667H6.18016C6.1735 3.10667 6.1735 3.10667 6.16683 3.11333C6.0135 3.17333 5.86016 3.24667 5.7135 3.32C5.7135 3.32 5.70683 3.32 5.70683 3.32667L11.6668 9.62Z'
      fill={color}
    />
  </svg>
);

export const DownloadIcon: React.FC<{
  fill?: string;
  width?: number;
  height?: number;
}> = ({ fill = 'var(--text-primary)', width = 16, height = 16 }) => (
  <svg
    width={width}
    height={height}
    viewBox='0 0 16 16'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M3.3335 13.6666H12.6668V12.3333H3.3335V13.6666ZM12.6668 6.33331H10.0002V2.33331H6.00016V6.33331H3.3335L8.00016 11L12.6668 6.33331Z'
      fill={fill}
    />
  </svg>
);
export const AlertFilterIcon: React.FC<IconProps> = ({
  width = 16,
  height = 16,
  color = 'var(--text-primary)',
}) => (
  <svg
    width={width}
    height={height}
    viewBox='0 0 16 16'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M6.66667 12H9.33333V10.6667H6.66667V12ZM2 4V5.33333H14V4H2ZM4 8.66667H12V7.33333H4V8.66667Z'
      fill={color}
    />
  </svg>
);
export const SuperAdmin: React.FC<{
  color?: string;
  width?: number;
  height?: number;
}> = ({ color, width, height }) => (
  <svg
    width={width || 24}
    height={height || 24}
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M12 2L4 5V11.09C4 16.14 7.41 20.85 12 22C16.59 20.85 20 16.14 20 11.09V5L12 2ZM10.94 15.54L7.4 12L8.81 10.59L10.93 12.71L15.17 8.47L16.58 9.88L10.94 15.54Z'
      fill={color}
    />
  </svg>
);
export default SuperAdmin;

export const SectionsRoles: React.FC<React.SVGProps<SVGSVGElement>> = (
  props
) => (
  <svg
    width={16}
    height={16}
    viewBox='0 0 16 16'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M3.33333 7.33333H6C6.73333 7.33333 7.33333 6.73333 7.33333 6V3.33333C7.33333 2.6 6.73333 2 6 2H3.33333C2.6 2 2 2.6 2 3.33333V6C2 6.73333 2.6 7.33333 3.33333 7.33333Z'
      fill='var(--text-primary)'
    />
    <path
      d='M3.33333 14H6C6.73333 14 7.33333 13.4 7.33333 12.6667V10C7.33333 9.26667 6.73333 8.66667 6 8.66667H3.33333C2.6 8.66667 2 9.26667 2 10V12.6667C2 13.4 2.6 14 3.33333 14Z'
      fill='var(--text-primary)'
    />
    <path
      d='M8.66667 3.33333V6C8.66667 6.73333 9.26667 7.33333 10 7.33333H12.6667C13.4 7.33333 14 6.73333 14 6V3.33333C14 2.6 13.4 2 12.6667 2H10C9.26667 2 8.66667 2.6 8.66667 3.33333Z'
      fill='var(--text-primary)'
    />
    <path
      d='M10 14H12.6667C13.4 14 14 13.4 14 12.6667V10C14 9.26667 13.4 8.66667 12.6667 8.66667H10C9.26667 8.66667 8.66667 9.26667 8.66667 10V12.6667C8.66667 13.4 9.26667 14 10 14Z'
      fill='var(--text-primary)'
    />
  </svg>
);

export const FeaturesRoles: React.FC<React.SVGProps<SVGSVGElement>> = (
  props
) => (
  <svg
    width={16}
    height={16}
    viewBox='0 0 16 16'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M2 12C2 12.3667 2.3 12.6667 2.66667 12.6667H6V11.3333H2.66667C2.3 11.3333 2 11.6333 2 12ZM2 4C2 4.36667 2.3 4.66667 2.66667 4.66667H8.66667V3.33333H2.66667C2.3 3.33333 2 3.63333 2 4ZM8.66667 13.3333V12.6667H13.3333C13.7 12.6667 14 12.3667 14 12C14 11.6333 13.7 11.3333 13.3333 11.3333H8.66667V10.6667C8.66667 10.3 8.36667 10 8 10C7.63333 10 7.33333 10.3 7.33333 10.6667V13.3333C7.33333 13.7 7.63333 14 8 14C8.36667 14 8.66667 13.7 8.66667 13.3333ZM4.66667 6.66667V7.33333H2.66667C2.3 7.33333 2 7.63333 2 8C2 8.36667 2.3 8.66667 2.66667 8.66667H4.66667V9.33333C4.66667 9.7 4.96667 10 5.33333 10C5.7 10 6 9.7 6 9.33333V6.66667C6 6.3 5.7 6 5.33333 6C4.96667 6 4.66667 6.3 4.66667 6.66667ZM14 8C14 7.63333 13.7 7.33333 13.3333 7.33333H7.33333V8.66667H13.3333C13.7 8.66667 14 8.36667 14 8ZM10.6667 6C11.0333 6 11.3333 5.7 11.3333 5.33333V4.66667H13.3333C13.7 4.66667 14 4.36667 14 4C14 3.63333 13.7 3.33333 13.3333 3.33333H11.3333V2.66667C11.3333 2.3 11.0333 2 10.6667 2C10.3 2 10 2.3 10 2.66667V5.33333C10 5.7 10.3 6 10.6667 6Z'
      fill='var(--text-primary)'
    />
  </svg>
);

export const NoteAdd: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg
    width={16}
    height={16}
    viewBox='0 0 16 16'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M9.33329 1.3334H3.99996C3.26663 1.3334 2.67329 1.9334 2.67329 2.66674L2.66663 13.3334C2.66663 14.0667 3.25996 14.6667 3.99329 14.6667H12C12.7333 14.6667 13.3333 14.0667 13.3333 13.3334V5.3334L9.33329 1.3334ZM10.6666 10.6667H8.66663V12.6667H7.33329V10.6667H5.33329V9.3334H7.33329V7.3334H8.66663V9.3334H10.6666V10.6667ZM8.66663 6.00007V2.3334L12.3333 6.00007H8.66663Z'
      fill='var(--text-primary)'
    />
  </svg>
);

export const DragIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg
    width={16}
    height={16}
    viewBox='0 0 12 4'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M11.3334 6.10352e-05H0.666687V1.33339H11.3334V6.10352e-05ZM0.666687 4.00006H11.3334V2.66673H0.666687V4.00006Z'
      fill='var(--text-primary)'
    />
  </svg>
);

export const OneTimeArrowIcon = ({
  width = 16,
  height = 16,
  fill = 'var(--text-primary)',
}) => (
  <svg
    width={width}
    height={height}
    viewBox='0 0 16 16'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M1.00667 14L15 8L1.00667 2L1 6.66667L11 8L1 9.33333L1.00667 14Z'
      fill={fill}
    />
  </svg>
);
export const ProductsIcon: React.FC<
  IconProps & { size?: number; color?: string }
> = ({ size = '16px', color = 'var(--text-primary)', ...props }) => (
  <svg
    width={size}
    height={size}
    viewBox='0 0 12 12'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M10.27 2.615L9.575 1.775C9.44 1.605 9.235 1.5 9 1.5H3C2.765 1.5 2.56 1.605 2.42 1.775L1.73 2.615C1.585 2.785 1.5 3.01 1.5 3.25V9.5C1.5 10.05 1.95 10.5 2.5 10.5H9.5C10.05 10.5 10.5 10.05 10.5 9.5V3.25C10.5 3.01 10.415 2.785 10.27 2.615ZM3.12 2.5H8.88L9.5 3.25H2.5L3.12 2.5ZM2.5 9.5V4H9.5V9.5H2.5Z'
      fill={color}
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M9.5 4H2.5V10H9.5V4ZM4.5 4.25V6.75H7.5V4.25H4.5Z'
      fill={color}
    />
  </svg>
);

export const Slack: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg
    width='16'
    height='16'
    viewBox='0 0 16 16'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M10.3999 3.53342L8.19995 4.30009L7.73328 2.86676C7.53328 2.26676 7.83328 1.60009 8.46661 1.40009C9.06661 1.20009 9.73328 1.50009 9.93328 2.13342L10.3999 3.53342ZM9.73328 8.86676L11.9333 8.10009L11.1666 5.73342L8.96661 6.50009L9.73328 8.86676ZM10.8666 12.2668C11.0333 12.7334 11.4999 13.0668 11.9666 13.0668C12.0999 13.0668 12.2333 13.0334 12.3333 13.0001C12.9333 12.8001 13.2666 12.1334 13.0666 11.5334L12.6666 10.3334L10.4666 11.1001L10.8666 12.2668Z'
      fill='#FFB300'
    />
    <path
      d='M5.73332 5.16671L3.53332 5.93338L3.06665 4.53338C2.86665 3.93338 3.16665 3.26671 3.79999 3.06671C4.39999 2.86671 5.06665 3.16671 5.26665 3.80005L5.73332 5.16671ZM6.19999 13.9334C6.36665 14.4 6.83332 14.7334 7.29999 14.7334C7.43332 14.7334 7.56665 14.7 7.66665 14.6667C8.26665 14.4667 8.59999 13.8 8.39999 13.2L7.99999 11.9667L5.79999 12.7334L6.19999 13.9334ZM6.46665 7.40005L4.26665 8.16671L5.03332 10.5334L7.23332 9.76671L6.46665 7.40005Z'
      fill='#00BFA5'
    />
    <path
      d='M11.1333 5.76671L10.3999 3.56671L11.7666 3.10004C12.3666 2.90004 13.0333 3.20004 13.2333 3.83337C13.4333 4.43337 13.1333 5.10004 12.4999 5.30004L11.1333 5.76671ZM8.93327 6.53337L8.19994 4.33337L5.73327 5.20004L6.46661 7.40004L8.93327 6.53337ZM2.13327 6.43337C1.53327 6.63337 1.19994 7.30004 1.39994 7.90004C1.56661 8.40004 2.03327 8.70004 2.49994 8.70004C2.63327 8.70004 2.76661 8.66671 2.86661 8.63337L4.23327 8.16671L3.49994 5.96671L2.13327 6.43337Z'
      fill='#00BCD4'
    />
    <path
      d='M5.03328 10.5001L5.76661 12.7001L4.19995 13.2334C4.06661 13.2667 3.93328 13.3001 3.83328 13.3001C3.33328 13.3001 2.89995 13.0001 2.73328 12.5001C2.53328 11.9001 2.83328 11.2334 3.46661 11.0334L5.03328 10.5001ZM14.5666 8.43338C14.3666 7.83338 13.6999 7.50005 13.0999 7.70005L11.9333 8.10005L12.6666 10.3334L13.8666 9.93338C14.4666 9.70005 14.7999 9.03338 14.5666 8.43338ZM7.23328 9.73338L7.96661 11.9334L10.4333 11.0667L9.69995 8.86672L7.23328 9.73338Z'
      fill='#E91E63'
    />
    <path
      d='M11.1333 5.76672L10.4 3.53339L8.19995 4.30005L8.93328 6.53339L11.1333 5.76672Z'
      fill='#388E3C'
    />
    <path
      d='M5.73333 5.16675L3.53333 5.93341L4.26666 8.16675L6.46666 7.40008L5.73333 5.16675Z'
      fill='#00897B'
    />
    <path
      d='M9.73328 8.8667L10.4666 11.1L12.6666 10.3334L11.9333 8.10004L9.73328 8.8667Z'
      fill='#BF360C'
    />
    <path
      d='M5.03333 10.5001L5.76666 12.7334L7.96666 11.9667L7.23333 9.7334L5.03333 10.5001Z'
      fill='#4E342E'
    />
  </svg>
);

export const TeamsIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='16'
    height='16'
    viewBox='0 0 16 16'
    fill='none'
    {...props}
  >
    <path
      d='M13.8334 4.33337C13.6802 4.33337 13.5285 4.36355 13.3869 4.42218C13.2454 4.48081 13.1168 4.56675 13.0084 4.67508C12.9001 4.78342 12.8141 4.91203 12.7555 5.05358C12.6969 5.19512 12.6667 5.34683 12.6667 5.50004C12.6667 5.65325 12.6969 5.80496 12.7555 5.9465C12.8141 6.08805 12.9001 6.21666 13.0084 6.325C13.1168 6.43333 13.2454 6.51927 13.3869 6.5779C13.5285 6.63653 13.6802 6.66671 13.8334 6.66671C13.9866 6.66671 14.1383 6.63653 14.2798 6.5779C14.4214 6.51927 14.55 6.43333 14.6583 6.325C14.7667 6.21666 14.8526 6.08805 14.9112 5.9465C14.9699 5.80496 15 5.65325 15 5.50004C15 5.34683 14.9699 5.19512 14.9112 5.05358C14.8526 4.91203 14.7667 4.78342 14.6583 4.67508C14.55 4.56675 14.4214 4.48081 14.2798 4.42218C14.1383 4.36355 13.9866 4.33337 13.8334 4.33337ZM1.33337 13.3334L9.00004 14.6667V1.33337L1.33337 2.66671V13.3334Z'
      fill='#5C6BC0'
    />
    <path
      d='M7.00004 5.4234V6.3334L5.67004 6.3934L5.66337 10.3467L4.67004 10.3167V6.43007L3.33337 6.4834V5.64673L7.00004 5.4234Z'
      fill='white'
    />
    <path
      d='M12 4.66671C12 5.40337 11.4033 6.00004 10.6666 6.00004C10.2666 6.00004 9.90996 5.82337 9.66663 5.54671V3.78671C9.90996 3.51004 10.2666 3.33337 10.6666 3.33337C11.4033 3.33337 12 3.93004 12 4.66671ZM12.6666 7.66671V11.3334C12.6666 11.3334 13.189 11.3334 13.8333 11.3334C14.4206 11.3334 14.9016 10.898 14.9833 10.3334H15V7.66671H12.6666ZM9.66663 6.66671V12.3334C9.66663 12.3334 10.189 12.3334 10.8333 12.3334C11.4206 12.3334 11.9016 11.898 11.9833 11.3334H12V6.66671H9.66663Z'
      fill='#5C6BC0'
    />
  </svg>
);

export const RefreshIcon: React.FC<IconProps> = ({
  width = 12,
  height = 12,
  color = '#0E8345',
}) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width={width}
    height={height}
    viewBox='0 0 12 12'
    fill='none'
  >
    <path
      d='M6 2V0.5L4 2.5L6 4.5V3C7.655 3 9 4.345 9 6C9 6.505 8.875 6.985 8.65 7.4L9.38 8.13C9.77 7.515 10 6.785 10 6C10 3.79 8.21 2 6 2ZM6 9C4.345 9 3 7.655 3 6C3 5.495 3.125 5.015 3.35 4.6L2.62 3.87C2.23 4.485 2 5.215 2 6C2 8.21 3.79 10 6 10V11.5L8 9.5L6 7.5V9Z'
      fill={color}
    />
  </svg>
);

export const FailedIcon: React.FC<IconProps> = ({
  width = 10,
  height = 8,
  color = '#DE1135',
}) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width={width}
    height={height}
    viewBox='0 0 10 8'
    fill='none'
  >
    <path
      d='M0.5 4C0.5 5.105 0.955 6.1 1.68 6.82L0.5 8H3.5V5L2.38 6.12C1.84 5.575 1.5 4.83 1.5 4C1.5 2.695 2.335 1.585 3.5 1.175V0.13C1.775 0.575 0.5 2.135 0.5 4ZM4.5 6.5H5.5V5.5H4.5V6.5ZM9.5 0H6.5V3L7.62 1.88C8.16 2.425 8.5 3.17 8.5 4C8.5 5.305 7.665 6.415 6.5 6.825V7.87C8.225 7.425 9.5 5.865 9.5 4C9.5 2.895 9.045 1.9 8.32 1.18L9.5 0ZM4.5 4.5H5.5V1.5H4.5V4.5Z'
      fill={color}
    />
  </svg>
);

export const ClockShareIcon: React.FC<IconProps> = (props) => (
  <svg
    width={10}
    height={10}
    viewBox='0 0 10 10'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M4.995 0C2.235 0 0 2.24 0 5C0 7.76 2.235 10 4.995 10C7.76 10 10 7.76 10 5C10 2.24 7.76 0 4.995 0ZM6.645 7.355L4.5 5.205V2.5H5.5V4.795L7.355 6.65L6.645 7.355Z'
      fill='var(--text-secondary)'
    />
  </svg>
);

export const COCMyTeamIcon: React.FC<
  IconProps & { size?: number; color?: string }
> = ({ size = 24, color = 'var(--text-primary)', ...props }) => (
  <svg
    width={size}
    height={size}
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M12 7V3H2V21H22V7H12ZM6 19H4V17H6V19ZM6 15H4V13H6V15ZM6 11H4V9H6V11ZM6 7H4V5H6V7ZM10 19H8V17H10V19ZM10 15H8V13H10V15ZM10 11H8V9H10V11ZM10 7H8V5H10V7ZM20 19H12V17H14V15H12V13H14V11H12V9H20V19ZM18 11H16V13H18V11ZM18 15H16V17H18V15Z'
      fill={color}
    />
  </svg>
);
export const COCSpecificTeamIcon: React.FC<
  IconProps & { size?: number; color?: string }
> = ({ size = 24, color = 'var(--text-primary)', ...props }) => (
  <svg
    width={size}
    height={size}
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M16.67 13.13C18.04 14.06 19 15.32 19 17V20H23V17C23 14.82 19.43 13.53 16.67 13.13Z'
      fill={color}
    />
    <path
      d='M9 12C11.2091 12 13 10.2091 13 8C13 5.79086 11.2091 4 9 4C6.79086 4 5 5.79086 5 8C5 10.2091 6.79086 12 9 12Z'
      fill={color}
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M15 12C17.21 12 19 10.21 19 8C19 5.79 17.21 4 15 4C14.53 4 14.09 4.1 13.67 4.24C14.5 5.27 15 6.58 15 8C15 9.42 14.5 10.73 13.67 11.76C14.09 11.9 14.53 12 15 12Z'
      fill={color}
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M9 13C6.33 13 1 14.34 1 17V20H17V17C17 14.34 11.67 13 9 13Z'
      fill={color}
    />
  </svg>
);
export const PeopleAltIcon: React.FC<
  IconProps & { size?: number; color?: string }
> = ({ size = 16, color = '#A7A7A7', ...props }) => (
  <svg
    width={size}
    height={size}
    viewBox='0 0 16 16'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M10.6667 7.33334C11.7733 7.33334 12.66 6.44001 12.66 5.33334C12.66 4.22668 11.7733 3.33334 10.6667 3.33334C9.56 3.33334 8.66667 4.22668 8.66667 5.33334C8.66667 6.44001 9.56 7.33334 10.6667 7.33334ZM5.33333 7.33334C6.44 7.33334 7.32667 6.44001 7.32667 5.33334C7.32667 4.22668 6.44 3.33334 5.33333 3.33334C4.22667 3.33334 3.33333 4.22668 3.33333 5.33334C3.33333 6.44001 4.22667 7.33334 5.33333 7.33334ZM5.33333 8.66668C3.78 8.66668 0.666667 9.44668 0.666667 11V12.6667H10V11C10 9.44668 6.88667 8.66668 5.33333 8.66668ZM10.6667 8.66668C10.4733 8.66668 10.2533 8.68001 10.02 8.70001C10.7933 9.26001 11.3333 10.0133 11.3333 11V12.6667H15.3333V11C15.3333 9.44668 12.22 8.66668 10.6667 8.66668Z'
      fill={color}
    />
  </svg>
);
export const COCPublicIcon: React.FC<
  IconProps & { size?: number; color?: string }
> = ({ size = 24, color = 'var(--text-primary)', ...props }) => (
  <svg
    width={size}
    height={size}
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM4 12C4 11.39 4.08 10.79 4.21 10.22L8.99 15V16C8.99 17.1 9.89 18 10.99 18V19.93C7.06 19.43 4 16.07 4 12ZM17.89 17.4C17.63 16.59 16.89 16 15.99 16H14.99V13C14.99 12.45 14.54 12 13.99 12H7.99V10H9.99C10.54 10 10.99 9.55 10.99 9V7H12.99C14.09 7 14.99 6.1 14.99 5V4.59C17.92 5.77 20 8.65 20 12C20 14.08 19.19 15.98 17.89 17.4Z'
      fill={color}
    />
  </svg>
);
export const LeftTailArrowIcon: React.FC<
  IconProps & { size?: number; color?: string }
> = ({ size = 16, color = 'var(--text-secondary)', ...props }) => (
  <svg
    width={size}
    height={size}
    viewBox='0 0 16 16'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M13.3333 7.33334H5.21996L8.94663 3.60667L7.99996 2.66667L2.66663 8L7.99996 13.3333L8.93996 12.3933L5.21996 8.66667H13.3333V7.33334Z'
      fill={color}
    />
  </svg>
);

interface MailOffIconProps {
  width?: number | string;
  height?: number | string;
  color?: string;
  className?: string;
}

export const MailOffIcon: React.FC<MailOffIconProps> = ({
  width = 14,
  height = 14,
  color = '#DE1135',
  className,
}) => (
  <svg
    width={width}
    height={height}
    viewBox='0 0 14 14'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    className={className}
  >
    <path
      d='M12.2667 13.2167L10.5167 11.4667H1.75C1.38333 11.4667 1.06944 11.3361 0.808333 11.075C0.547222 10.8139 0.416667 10.5 0.416667 10.1333V2.13333C0.416667 1.76667 0.547222 1.45278 0.808333 1.19167C1.06944 0.930556 1.38333 0.8 1.75 0.8L3.08333 2.13333H1.18333L0 0.95L0.95 0L13.2167 12.2667L12.2667 13.2167ZM13.6 10.75L8.66667 5.81667L12.4167 3.46667V2.13333L7.85 5L3.65 0.8H12.4167C12.7833 0.8 13.0972 0.930556 13.3583 1.19167C13.6194 1.45278 13.75 1.76667 13.75 2.13333V10.1333C13.75 10.2444 13.7389 10.3528 13.7167 10.4583C13.6944 10.5639 13.6556 10.6611 13.6 10.75Z'
      fill={color}
    />
  </svg>
);

export const TaskListIcon = () => (
  <svg
    width='12'
    height='12'
    viewBox='0 0 13 9'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M7.33333 2.66667H0V4H7.33333V2.66667Z'
      fill='var(--text-primary)'
    />
    <path d='M7.33333 0H0V1.33333H7.33333V0Z' fill='var(--text-primary)' />
    <path
      d='M4.66667 5.33333H0V6.66667H4.66667V5.33333Z'
      fill='var(--text-primary)'
    />
    <path
      d='M11.7267 3.95333L8.89333 6.78L7.48 5.36667L6.54 6.30667L8.89333 8.66667L12.6667 4.89333L11.7267 3.95333Z'
      fill='var(--text-primary)'
    />
  </svg>
);

export const CloseFilledIcon: React.FC<React.SVGProps<SVGSVGElement>> = (
  props
) => (
  <svg
    width='16'
    height='16'
    viewBox='0 0 16 16'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <g clipPath='url(#clip0_23037_24608)'>
      <path
        d='M8.00002 0.666504C3.93335 0.666504 0.666687 3.93317 0.666687 7.99984C0.666687 12.0665 3.93335 15.3332 8.00002 15.3332C12.0667 15.3332 15.3334 12.0665 15.3334 7.99984C15.3334 3.93317 12.0667 0.666504 8.00002 0.666504ZM12 10.6665L10.6667 11.9998L8.00002 9.33317L5.33335 11.9998L4.00002 10.6665L6.66669 7.99984L4.00002 5.33317L5.33335 3.99984L8.00002 6.6665L10.6667 3.99984L12 5.33317L9.33335 7.99984L12 10.6665Z'
        fill='var(--text-primary)'
      />
    </g>
    <defs>
      <clipPath id='clip0_23037_24608'>
        <rect width='16' height='16' fill='white' />
      </clipPath>
    </defs>
  </svg>
);

export const SortUpIcons: React.FC<
  IconProps & { size?: number; color?: string }
> = ({ size = 6, color = 'var(--text-secondary)', ...props }) => (
  <svg
    width={size}
    height={8}
    viewBox='0 0 6 8'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M2.66667 0L0 2.66H2V7.33333H3.33333V2.66H5.33333L2.66667 0Z'
      fill={color}
    />
  </svg>
);
export const SortDownIcons: React.FC<
  IconProps & { size?: number; color?: string }
> = ({ size = 6, color = 'var(--text-secondary)', ...props }) => (
  <svg
    width={size}
    height='8'
    viewBox='0 0 6 8'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M3.33333 4.67333V0H2V4.67333H0L2.66667 7.33333L5.33333 4.67333H3.33333Z'
      fill={color}
    />
  </svg>
);

export const UploadSmallIcon = ({
  width = 11,
  height = 15,
  color = 'var(--text-secondary)',
}) => (
  <svg
    width={width}
    height={height}
    viewBox='0 0 11 15'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M8 2.66667L7.05333 3.61333L5.99333 2.55333V10H4.67333V2.55333L3.61333 3.61333L2.66667 2.66667L5.33333 0L8 2.66667ZM10.6667 6V13.3333C10.6667 14.0667 10.0667 14.6667 9.33333 14.6667H1.33333C0.593333 14.6667 0 14.0667 0 13.3333V6C0 5.26 0.593333 4.66667 1.33333 4.66667H3.33333V6H1.33333V13.3333H9.33333V6H7.33333V4.66667H9.33333C10.0667 4.66667 10.6667 5.26 10.6667 6Z'
      fill={color}
    />
  </svg>
);

export const DotsIcon: React.FC<
  IconProps & { width?: number; height?: number; color?: string }
> = ({ width = 11, height = 3, color = 'var(--text-secondary)', ...props }) => (
  <svg
    width={width}
    height={height}
    viewBox='0 0 11 3'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M1.33333 0C0.6 0 0 0.6 0 1.33333C0 2.06667 0.6 2.66667 1.33333 2.66667C2.06667 2.66667 2.66667 2.06667 2.66667 1.33333C2.66667 0.6 2.06667 0 1.33333 0ZM9.33333 0C8.6 0 8 0.6 8 1.33333C8 2.06667 8.6 2.66667 9.33333 2.66667C10.0667 2.66667 10.6667 2.06667 10.6667 1.33333C10.6667 0.6 10.0667 0 9.33333 0ZM5.33333 0C4.6 0 4 0.6 4 1.33333C4 2.06667 4.6 2.66667 5.33333 2.66667C6.06667 2.66667 6.66667 2.06667 6.66667 1.33333C6.66667 0.6 6.06667 0 5.33333 0Z'
      fill={color}
    />
  </svg>
);

export const LogiblocksIcon: React.FC<
  IconProps & { size?: number; color?: string }
> = ({ size = 20, color = '#266EF1', ...props }) => (
  <svg
    width={size}
    height={size}
    viewBox='0 0 20 20'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M15.8333 12.65V5.83333C15.8333 3.99167 14.3417 2.5 12.5 2.5C10.6583 2.5 9.16667 3.99167 9.16667 5.83333V14.1667C9.16667 15.0833 8.41667 15.8333 7.5 15.8333C6.58333 15.8333 5.83333 15.0833 5.83333 14.1667V7.35C6.8 7 7.5 6.08333 7.5 5C7.5 3.61667 6.38333 2.5 5 2.5C3.61667 2.5 2.5 3.61667 2.5 5C2.5 6.08333 3.2 7 4.16667 7.35V14.1667C4.16667 16.0083 5.65833 17.5 7.5 17.5C9.34167 17.5 10.8333 16.0083 10.8333 14.1667V5.83333C10.8333 4.91667 11.5833 4.16667 12.5 4.16667C13.4167 4.16667 14.1667 4.91667 14.1667 5.83333V12.65C13.2 12.9917 12.5 13.9083 12.5 15C12.5 16.3833 13.6167 17.5 15 17.5C16.3833 17.5 17.5 16.3833 17.5 15C17.5 13.9167 16.8 13 15.8333 12.65Z'
      fill={color}
    />
  </svg>
);

export const ArrowLeft: React.FC<{
  size?: number;
  fill?: string;
}> = ({ size = 12, fill = 'currentColor' }) => (
  <svg width={size} height={size} viewBox='0 0 12 12' aria-hidden='true'>
    <path
      d='M7.85246 3.705L7.14746 3L4.14746 6L7.14746 9L7.85246 8.295L5.56246 6L7.85246 3.705Z'
      fill={fill}
    />
  </svg>
);

export const ArrowRight: React.FC<{
  size?: number;
  fill?: string;
}> = ({ size = 12, fill = 'currentColor' }) => (
  <svg width={size} height={size} viewBox='0 0 12 12' aria-hidden='true'>
    <path
      d='M4.85246 3L4.14746 3.705L6.43746 6L4.14746 8.295L4.85246 9L7.85246 6L4.85246 3Z'
      fill={fill}
    />
  </svg>
);

export const ArrowForwardIcon: React.FC<{
  size?: number;
  color?: string;
}> = ({ size = 16, color = 'currentColor' }) => (
  <svg
    width={size}
    height={size}
    viewBox='0 0 16 16'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    aria-hidden='true'
  >
    <path
      d='M8 2.66663L7.06 3.60663L10.78 7.33329H2.66667V8.66663H10.78L7.06 12.3933L8 13.3333L13.3333 7.99996L8 2.66663Z'
      fill={color}
    />
  </svg>
);
export const ShareAlertIcon = () => (
  <svg
    width='12'
    height='12'
    viewBox='0 0 12 12'
    xmlns='http://www.w3.org/2000/svg'
    aria-hidden='true'
  >
    <path
      d='M6 10.875C6.55 10.875 7 10.425 7 9.875H5C5 10.425 5.445 10.875 6 10.875ZM9 7.875V5.375C9 3.84 8.18 2.555 6.75 2.215V1.875C6.75 1.46 6.415 1.125 6 1.125C5.585 1.125 5.25 1.46 5.25 1.875V2.215C3.815 2.555 3 3.835 3 5.375V7.875L2 8.875V9.375H10V8.875L9 7.875Z'
      fill='currentColor'
    />
  </svg>
);

export const MailFillIcon: React.FC<
  IconProps & { size?: number; color?: string }
> = ({ size = 16, color = 'var(--text-primary)', ...props }) => (
  <svg
    width={size}
    height={size}
    viewBox='0 0 16 16'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M13.3333 2.66663H2.66659C1.93325 2.66663 1.33992 3.26663 1.33992 3.99996L1.33325 12C1.33325 12.7333 1.93325 13.3333 2.66659 13.3333H13.3333C14.0666 13.3333 14.6666 12.7333 14.6666 12V3.99996C14.6666 3.26663 14.0666 2.66663 13.3333 2.66663ZM13.3333 5.33329L7.99992 8.66663L2.66659 5.33329V3.99996L7.99992 7.33329L13.3333 3.99996V5.33329Z'
      fill={color}
    />
  </svg>
);
export const CallFillIcon: React.FC<
  IconProps & { size?: number; color?: string }
> = ({ size = 16, color = 'var(--text-primary)', ...props }) => (
  <svg
    width={size}
    height={size}
    viewBox='0 0 16 16'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M4.41333 7.19333C5.37333 9.08 6.92 10.62 8.80667 11.5867L10.2733 10.12C10.4533 9.94 10.72 9.88 10.9533 9.96C11.7 10.2067 12.5067 10.34 13.3333 10.34C13.7 10.34 14 10.64 14 11.0067V13.3333C14 13.7 13.7 14 13.3333 14C7.07333 14 2 8.92667 2 2.66667C2 2.3 2.3 2 2.66667 2H5C5.36667 2 5.66667 2.3 5.66667 2.66667C5.66667 3.5 5.8 4.3 6.04667 5.04667C6.12 5.28 6.06667 5.54 5.88 5.72667L4.41333 7.19333Z'
      fill={color}
    />
  </svg>
);
export const ArrowOutwardIcon: React.FC<
  IconProps & { size?: number; color?: string }
> = ({ size = 16, color = 'var(--text-primary)', ...props }) => (
  <svg
    width={size}
    height={size}
    viewBox='0 0 16 16'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M4.33341 3.6665V4.99984H10.0601L3.66675 11.3932L4.60675 12.3332L11.0001 5.93984V11.6665H12.3334V3.6665H4.33341Z'
      fill={color}
    />
  </svg>
);
export const RoadmapFillIcon: React.FC<
  IconProps & { size?: number; color?: string }
> = ({ size = 16, color = 'var(--text-primary)', ...props }) => (
  <svg
    width={size}
    height={size}
    viewBox='0 0 16 16'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M12.6667 10.12V4.66667C12.6667 3.19333 11.4733 2 10 2C8.52667 2 7.33333 3.19333 7.33333 4.66667V11.3333C7.33333 12.0667 6.73333 12.6667 6 12.6667C5.26667 12.6667 4.66667 12.0667 4.66667 11.3333V5.88C5.44 5.6 6 4.86667 6 4C6 2.89333 5.10667 2 4 2C2.89333 2 2 2.89333 2 4C2 4.86667 2.56 5.6 3.33333 5.88V11.3333C3.33333 12.8067 4.52667 14 6 14C7.47333 14 8.66667 12.8067 8.66667 11.3333V4.66667C8.66667 3.93333 9.26667 3.33333 10 3.33333C10.7333 3.33333 11.3333 3.93333 11.3333 4.66667V10.12C10.56 10.3933 10 11.1267 10 12C10 13.1067 10.8933 14 12 14C13.1067 14 14 13.1067 14 12C14 11.1333 13.44 10.4 12.6667 10.12Z'
      fill={color}
    />
  </svg>
);

export const FileRefreshIcon = () => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='16'
    height='16'
    viewBox='0 0 16 16'
    fill='none'
  >
    <path
      d='M9.33366 1.3335H4.00033C3.26699 1.3335 2.67366 1.9335 2.67366 2.66683L2.66699 13.3335C2.66699 14.0668 3.26033 14.6668 3.99366 14.6668H12.0003C12.7337 14.6668 13.3337 14.0668 13.3337 13.3335V5.3335L9.33366 1.3335ZM8.00033 12.0002C6.63366 12.0002 5.46033 11.1735 4.94699 10.0002H6.08699C6.50699 10.6002 7.20699 11.0002 8.00033 11.0002C9.28699 11.0002 10.3337 9.9535 10.3337 8.66683C10.3337 7.38016 9.28699 6.3335 8.00033 6.3335C7.10033 6.3335 6.32033 6.8535 5.93366 7.60016L7.00033 8.66683H4.33366V6.00016L5.20033 6.86683C5.79366 5.94683 6.82033 5.3335 8.00033 5.3335C9.84033 5.3335 11.3337 6.82683 11.3337 8.66683C11.3337 10.5068 9.84033 12.0002 8.00033 12.0002Z'
      fill='currentColor'
    />
  </svg>
);

export const HoldHandIcon: React.FC<
  IconProps & { size?: number; color?: string }
> = ({ size = 16, color = '#fff', ...props }) => (
  <svg
    width={size}
    height={size}
    viewBox='0 0 16 16'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M12.6667 5.33333C12.2067 5.33333 11.8333 5.70667 11.8333 6.16667V10H11.5C10.4 10 9.5 10.9 9.5 12H8.83333C8.83333 10.64 9.85333 9.52 11.1667 9.35333V2.16667C11.1667 1.70667 10.7933 1.33333 10.3333 1.33333C9.87333 1.33333 9.5 1.70667 9.5 2.16667V7.33333H8.83333V0.833333C8.83333 0.373333 8.46 0 8 0C7.54 0 7.16667 0.373333 7.16667 0.833333V7.33333H6.5V1.83333C6.5 1.37333 6.12667 1 5.66667 1C5.20667 1 4.83333 1.37333 4.83333 1.83333V8H4.16667V3.83333C4.16667 3.37333 3.79333 3 3.33333 3C2.87333 3 2.5 3.37333 2.5 3.83333V10.5C2.5 13.54 4.96 16 8 16C11.04 16 13.5 13.54 13.5 10.5V6.16667C13.5 5.70667 13.1267 5.33333 12.6667 5.33333Z'
      fill={color}
    />
  </svg>
);

export const CallIcon: React.FC<
  IconProps & { size?: number; color?: string }
> = ({ size = 16, color = '#fff', ...props }) => (
  <svg
    width={size}
    height={size}
    viewBox='0 0 16 16'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M4.41333 7.19333C5.37333 9.08 6.92 10.62 8.80667 11.5867L10.2733 10.12C10.4533 9.94 10.72 9.88 10.9533 9.96C11.7 10.2067 12.5067 10.34 13.3333 10.34C13.7 10.34 14 10.64 14 11.0067V13.3333C14 13.7 13.7 14 13.3333 14C7.07333 14 2 8.92667 2 2.66667C2 2.3 2.3 2 2.66667 2H5C5.36667 2 5.66667 2.3 5.66667 2.66667C5.66667 3.5 5.8 4.3 6.04667 5.04667C6.12 5.28 6.06667 5.54 5.88 5.72667L4.41333 7.19333Z'
      fill={color}
    />
  </svg>
);

export const CopyContent: React.FC<
  IconProps & { size?: number; color?: string }
> = ({ size = 16, color = 'var(--text-primary)', ...props }) => (
  <svg
    width={size}
    height={size}
    viewBox='0 0 36 36'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M21.0013 10.6667H13.0013C12.268 10.6667 11.668 11.2667 11.668 12.0001V21.3334H13.0013V12.0001H21.0013V10.6667ZM23.0013 13.3334H15.668C14.9346 13.3334 14.3346 13.9334 14.3346 14.6667V24.0001C14.3346 24.7334 14.9346 25.3334 15.668 25.3334H23.0013C23.7346 25.3334 24.3346 24.7334 24.3346 24.0001V14.6667C24.3346 13.9334 23.7346 13.3334 23.0013 13.3334Z'
      fill={color}
    />
  </svg>
);
export const CloseDrawerIcon: React.FC<
  IconProps & { size?: number; color?: string }
> = ({ size = 16, color = 'var(--text-primary)', ...props }) => (
  <svg
    width={size}
    height={size}
    viewBox='0 0 16 16'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M12.6654 4.27325L11.7254 3.33325L7.9987 7.05992L4.27203 3.33325L3.33203 4.27325L7.0587 7.99992L3.33203 11.7266L4.27203 12.6666L7.9987 8.93992L11.7254 12.6666L12.6654 11.7266L8.9387 7.99992L12.6654 4.27325Z'
      fill={color}
    />
  </svg>
);
export const HeaderAddIcon: React.FC<
  IconProps & { height?: number; width?: number; color?: string }
> = ({ height = 12, width = 12, color = 'var(--text-primary)', ...props }) => (
  <svg
    width={height}
    height={width}
    viewBox='0 0 12 12'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M9.5 6.5H6.5V9.5H5.5V6.5H2.5V5.5H5.5V2.5H6.5V5.5H9.5V6.5Z'
      fill={color}
    />
  </svg>
);

export const AddDetialIcon: React.FC<
  IconProps & { size?: number; color?: string }
> = ({ size = 12, color = '#fff', ...props }) => (
  <svg
    width={size}
    height={size}
    viewBox='0 0 12 12'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M9.5 9.5H2.5V2.5H6V1.5H2.5C1.945 1.5 1.5 1.95 1.5 2.5V9.5C1.5 10.05 1.945 10.5 2.5 10.5H9.5C10.05 10.5 10.5 10.05 10.5 9.5V6H9.5V9.5ZM7 1.5V2.5H8.795L3.88 7.415L4.585 8.12L9.5 3.205V5H10.5V1.5H7Z'
      fill={color}
    />
  </svg>
);
export const BrackedAddIcon: React.FC<
  IconProps & { size?: number; color?: string }
> = ({ size = 16, color = 'var(--text-secondary)', ...props }) => (
  <svg
    width={size}
    height={size}
    viewBox='0 0 17 13'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M0.443182 5.47146V4.94305C0.917614 4.94305 1.24858 4.84362 1.43608 4.64475C1.62642 4.44589 1.72159 4.1135 1.72159 3.64759V2.28396C1.72159 1.89191 1.75852 1.55242 1.83239 1.26549C1.90909 0.97856 2.03267 0.741344 2.20312 0.553844C2.37358 0.366344 2.60085 0.227139 2.88494 0.13623C3.16903 0.045321 3.51989 -0.000133753 3.9375 -0.000133753V0.835094C3.60795 0.835094 3.34801 0.88623 3.15767 0.988503C2.97017 1.09078 2.83665 1.24987 2.7571 1.46578C2.6804 1.67884 2.64205 1.95157 2.64205 2.28396V3.9885C2.64205 4.21009 2.61222 4.4118 2.55256 4.59362C2.49574 4.77543 2.3892 4.93168 2.23295 5.06237C2.0767 5.19305 1.85369 5.2939 1.56392 5.36492C1.27699 5.43595 0.903409 5.47146 0.443182 5.47146ZM3.9375 10.909C3.51989 10.909 3.16903 10.8635 2.88494 10.7726C2.60085 10.6817 2.37358 10.5425 2.20312 10.355C2.03267 10.1675 1.90909 9.93026 1.83239 9.64333C1.75852 9.3564 1.72159 9.01691 1.72159 8.62487V7.26123C1.72159 6.79532 1.62642 6.46293 1.43608 6.26407C1.24858 6.06521 0.917614 5.96578 0.443182 5.96578V5.43737C0.903409 5.43737 1.27699 5.47288 1.56392 5.5439C1.85369 5.61492 2.0767 5.71578 2.23295 5.84646C2.3892 5.97714 2.49574 6.13339 2.55256 6.31521C2.61222 6.49703 2.64205 6.69873 2.64205 6.92032V8.62487C2.64205 8.95725 2.6804 9.22998 2.7571 9.44305C2.83665 9.65612 2.97017 9.81379 3.15767 9.91606C3.34801 10.0212 3.60795 10.0737 3.9375 10.0737V10.909ZM0.443182 5.96578V4.94305H1.44886V5.96578H0.443182ZM7.82493 8.53964V2.91464H8.77947V8.53964H7.82493ZM5.4897 6.20441V5.24987H11.1147V6.20441H5.4897ZM16.1612 5.43737V5.96578C15.6868 5.96578 15.3544 6.06521 15.1641 6.26407C14.9766 6.46293 14.8828 6.79532 14.8828 7.26123V8.62487C14.8828 9.01691 14.8445 9.3564 14.7678 9.64333C14.6939 9.93026 14.5717 10.1675 14.4013 10.355C14.2308 10.5425 14.0036 10.6817 13.7195 10.7726C13.4354 10.8635 13.0845 10.909 12.6669 10.909V10.0737C12.9964 10.0737 13.255 10.0212 13.4425 9.91606C13.6328 9.81379 13.7663 9.65612 13.843 9.44305C13.9226 9.22998 13.9624 8.95725 13.9624 8.62487V6.92032C13.9624 6.69873 13.9908 6.49703 14.0476 6.31521C14.1072 6.13339 14.2152 5.97714 14.3714 5.84646C14.5277 5.71578 14.7493 5.61492 15.0362 5.5439C15.326 5.47288 15.701 5.43737 16.1612 5.43737ZM12.6669 -0.000133753C13.0845 -0.000133753 13.4354 0.045321 13.7195 0.13623C14.0036 0.227139 14.2308 0.366344 14.4013 0.553844C14.5717 0.741344 14.6939 0.97856 14.7678 1.26549C14.8445 1.55242 14.8828 1.89191 14.8828 2.28396V3.64759C14.8828 4.1135 14.9766 4.44589 15.1641 4.64475C15.3544 4.84362 15.6868 4.94305 16.1612 4.94305V5.47146C15.701 5.47146 15.326 5.43595 15.0362 5.36492C14.7493 5.2939 14.5277 5.19305 14.3714 5.06237C14.2152 4.93168 14.1072 4.77543 14.0476 4.59362C13.9908 4.4118 13.9624 4.21009 13.9624 3.9885V2.28396C13.9624 1.95157 13.9226 1.67884 13.843 1.46578C13.7663 1.24987 13.6328 1.09078 13.4425 0.988503C13.255 0.88623 12.9964 0.835094 12.6669 0.835094V-0.000133753ZM16.1612 4.94305V5.96578H15.1555V4.94305H16.1612Z'
      fill={color}
    />
    <path d='M0 11.5226H16.6044V12.3408H0V11.5226Z' fill={color} />
  </svg>
);

export const MaleIcon: React.FC<
  IconProps & { size?: number; color?: string }
> = ({ size = 16, color = 'var(--text-primary)', ...props }) => (
  <svg
    width={size}
    height={size}
    viewBox='0 0 16 16'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M9.33203 4.66683H6.66536C5.93203 4.66683 5.33203 5.26683 5.33203 6.00016V10.0002H6.66536V14.6668H9.33203V10.0002H10.6654V6.00016C10.6654 5.26683 10.0654 4.66683 9.33203 4.66683Z'
      fill={color}
    />
    <path
      d='M7.9987 4.00016C8.73508 4.00016 9.33203 3.40321 9.33203 2.66683C9.33203 1.93045 8.73508 1.3335 7.9987 1.3335C7.26232 1.3335 6.66536 1.93045 6.66536 2.66683C6.66536 3.40321 7.26232 4.00016 7.9987 4.00016Z'
      fill={color}
    />
  </svg>
);

export const FemaleIcon: React.FC<
  IconProps & { size?: number; color?: string }
> = ({ size = 16, color = 'var(--text-primary)', ...props }) => (
  <svg
    width={size}
    height={size}
    viewBox='0 0 16 16'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M9.29463 5.54016C9.0813 5.0135 8.56797 4.66683 8.0013 4.66683C7.43464 4.66683 6.9213 5.0135 6.70797 5.54016L4.66797 10.6668H6.66797V14.6668H9.33464V10.6668H11.3346L9.29463 5.54016Z'
      fill={color}
    />
    <path
      d='M8.0013 4.00016C8.73768 4.00016 9.33464 3.40321 9.33464 2.66683C9.33464 1.93045 8.73768 1.3335 8.0013 1.3335C7.26492 1.3335 6.66797 1.93045 6.66797 2.66683C6.66797 3.40321 7.26492 4.00016 8.0013 4.00016Z'
      fill={color}
    />
  </svg>
);

export const VoicePlayIcon: React.FC<
  IconProps & { size?: number; color?: string }
> = ({ size = 16, color = 'var(--text-primary)', ...props }) => (
  <svg
    width={size}
    height={size}
    viewBox='0 0 16 16'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M4.33203 3.3335V12.6668L11.6654 8.00016L4.33203 3.3335Z'
      fill={color}
    />
  </svg>
);

export const VoicePauseIcon: React.FC<
  IconProps & { size?: number; color?: string }
> = ({ size = 16, color = 'var(--text-primary)', ...props }) => (
  <svg
    width={size}
    height={size}
    viewBox='0 0 16 16'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M4 12.6668H6.66667V3.3335H4V12.6668ZM9.33333 3.3335V12.6668H12V3.3335H9.33333Z'
      fill={color}
    />
  </svg>
);

export const CopyOUtlined: React.FC<
  IconProps & { size?: number; color?: string }
> = ({ width = 13, height = 15, color = 'var(--text-primary)', ...props }) => (
  <svg
    width={width}
    height={height}
    viewBox='0 0 13 15'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M9.33333 0H1.33333C0.6 0 0 0.6 0 1.33333V10.6667H1.33333V1.33333H9.33333V0ZM11.3333 2.66667H4C3.26667 2.66667 2.66667 3.26667 2.66667 4V13.3333C2.66667 14.0667 3.26667 14.6667 4 14.6667H11.3333C12.0667 14.6667 12.6667 14.0667 12.6667 13.3333V4C12.6667 3.26667 12.0667 2.66667 11.3333 2.66667ZM11.3333 13.3333H4V4H11.3333V13.3333Z'
      fill={color}
    />
  </svg>
);

export const Shortcut: React.FC<
  IconProps & { size?: number; color?: string }
> = ({ width = 16, height = 16, color = 'var(--text-primary)', ...props }) => (
  <svg
    width={width}
    height={height}
    viewBox='0 0 16 16'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M10 3.3335L9.06 4.2735L10 5.22016L11.4467 6.66683H5.33333C3.49333 6.66683 2 8.16016 2 10.0002V12.6668H3.33333V10.0002C3.33333 8.90016 4.23333 8.00016 5.33333 8.00016H11.4467L9.06 10.3868L10 11.3335L14 7.3335L10 3.3335Z'
      fill={color}
    />
  </svg>
);

export const PlaySupport: React.FC<
  IconProps & { size?: number; color?: string }
> = ({ width = 16, height = 16, color = 'var(--text-primary)', ...props }) => (
  <svg
    width={width}
    height={height}
    viewBox='0 0 14 14'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M6.66667 0C2.98667 0 0 2.98667 0 6.66667C0 10.3467 2.98667 13.3333 6.66667 13.3333C10.3467 13.3333 13.3333 10.3467 13.3333 6.66667C13.3333 2.98667 10.3467 0 6.66667 0ZM5.33333 9.66667V3.66667L9.33333 6.66667L5.33333 9.66667Z'
      fill={color}
    />
  </svg>
);
export const PlayTriangleIcon: React.FC<IconProps & { color?: string }> = ({
  width = 16,
  height = 16,
  color = 'var(--text-primary)',
  ...props
}) => (
  <svg
    width={width}
    height={height}
    viewBox='0 0 16 16'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M5.33333 3.33333V12.6667L12.6667 8L5.33333 3.33333Z'
      fill={color}
    />
  </svg>
);
export const ActivityCommentIcon: React.FC<
  IconProps & { filled?: boolean; color?: string }
> = ({
  filled = true,
  width = 16,
  height = 16,
  color = 'var(--text-primary)',
  ...props
}) => (
  <svg
    width={width}
    height={height}
    viewBox='0 0 16 16'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    aria-hidden='true'
    {...props}
  >
    <path
      d='M13.3333 1.33334H2.66665C1.93331 1.33334 1.33331 1.93334 1.33331 2.66668V14.6667L3.99998 12H13.3333C14.0666 12 14.6666 11.4 14.6666 10.6667V2.66668C14.6666 1.93334 14.0666 1.33334 13.3333 1.33334Z'
      fill={filled ? color : 'none'}
      stroke={color}
      strokeWidth={filled ? 0 : 1.4}
      strokeLinejoin='round'
    />
  </svg>
);
export const EmailSupport: React.FC<
  IconProps & { size?: number; color?: string }
> = ({ width = 16, height = 16, color = 'var(--text-primary)', ...props }) => (
  <svg
    width={width}
    height={height}
    viewBox='0 0 16 16'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M13.3333 2.66667H2.66665C1.93331 2.66667 1.33998 3.26667 1.33998 4.00001L1.33331 12C1.33331 12.7333 1.93331 13.3333 2.66665 13.3333H13.3333C14.0666 13.3333 14.6666 12.7333 14.6666 12V4.00001C14.6666 3.26667 14.0666 2.66667 13.3333 2.66667ZM13.3333 5.33334L7.99998 8.66667L2.66665 5.33334V4.00001L7.99998 7.33334L13.3333 4.00001V5.33334Z'
      fill={color}
    />
  </svg>
);

export const BookOpenIcon: React.FC<
  IconProps & { size?: number; color?: string }
> = ({
  width = 16,
  height = 16,
  color = 'var(--text-secondary)',
  ...props
}) => (
  <svg
    width={width}
    height={height}
    viewBox='0 0 16 16'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M14 2.66671C13.26 2.43337 12.4467 2.33337 11.6667 2.33337C10.3667 2.33337 8.96669 2.60004 8.00002 3.33337C7.03335 2.60004 5.63335 2.33337 4.33335 2.33337C3.03335 2.33337 1.63335 2.60004 0.666687 3.33337V13.1C0.666687 13.2667 0.833354 13.4334 1.00002 13.4334C1.06669 13.4334 1.10002 13.4 1.16669 13.4C2.06669 12.9667 3.36669 12.6667 4.33335 12.6667C5.63335 12.6667 7.03335 12.9334 8.00002 13.6667C8.90002 13.1 10.5334 12.6667 11.6667 12.6667C12.7667 12.6667 13.9 12.8667 14.8334 13.3667C14.9 13.4 14.9334 13.4 15 13.4C15.1667 13.4 15.3334 13.2334 15.3334 13.0667V3.33337C14.9334 3.03337 14.5 2.83337 14 2.66671ZM14 11.6667C13.2667 11.4334 12.4667 11.3334 11.6667 11.3334C10.5334 11.3334 8.90002 11.7667 8.00002 12.3334V4.66671C8.90002 4.10004 10.5334 3.66671 11.6667 3.66671C12.4667 3.66671 13.2667 3.76671 14 4.00004V11.6667Z'
      fill={color}
    />
    <path
      d='M11.6667 6.33337C12.2534 6.33337 12.82 6.39337 13.3334 6.50671V5.49337C12.8067 5.39337 12.24 5.33337 11.6667 5.33337C10.5334 5.33337 9.50669 5.52671 8.66669 5.88671V6.99337C9.42002 6.56671 10.4667 6.33337 11.6667 6.33337Z'
      fill={color}
    />
    <path
      d='M8.66669 7.66004V8.76671C9.42002 8.34004 10.4667 8.10671 11.6667 8.10671C12.2534 8.10671 12.82 8.16671 13.3334 8.28004V7.26671C12.8067 7.16671 12.24 7.10671 11.6667 7.10671C10.5334 7.10671 9.50669 7.30671 8.66669 7.66004Z'
      fill={color}
    />
    <path
      d='M11.6667 8.88671C10.5334 8.88671 9.50669 9.08004 8.66669 9.44004V10.5467C9.42002 10.12 10.4667 9.88671 11.6667 9.88671C12.2534 9.88671 12.82 9.94671 13.3334 10.06V9.04671C12.8067 8.94004 12.24 8.88671 11.6667 8.88671Z'
      fill={color}
    />
  </svg>
);

export const CopyIcon: React.FC<
  IconProps & { size?: number; color?: string }
> = ({ width = 16, height = 16, color = 'var(--text-primary)', ...props }) => (
  <svg
    width={width}
    height={height}
    viewBox='0 0 16 16'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M9.33342 1.33325H4.00008C3.26675 1.33325 2.67341 1.93325 2.67341 2.66659L2.66675 13.3333C2.66675 14.0666 3.26008 14.6666 3.99341 14.6666H12.0001C12.7334 14.6666 13.3334 14.0666 13.3334 13.3333V5.33325L9.33342 1.33325ZM10.6667 11.9999H5.33341V10.6666H10.6667V11.9999ZM10.6667 9.33325H5.33341V7.99992H10.6667V9.33325ZM8.66675 5.99992V2.33325L12.3334 5.99992H8.66675Z'
      fill={color}
    />
  </svg>
);
export const CriticalCircleIcon: React.FC<
  IconProps & { size?: number; color?: string }
> = ({ width = 16, height = 16, color = '#DE1135', ...props }) => (
  <svg
    width={width}
    height={height}
    viewBox='0 0 16 16'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M7.99992 1.33333C4.31992 1.33333 1.33325 4.31999 1.33325 7.99999C1.33325 11.68 4.31992 14.6667 7.99992 14.6667C11.6799 14.6667 14.6666 11.68 14.6666 7.99999C14.6666 4.31999 11.6799 1.33333 7.99992 1.33333ZM8.66658 11.3333H7.33325V9.99999H8.66658V11.3333ZM8.66658 8.66666H7.33325V4.66666H8.66658V8.66666Z'
      fill={color}
    />
  </svg>
);
export const AtRiskTringleIcon: React.FC<
  IconProps & { size?: number; color?: string }
> = ({ width = 16, height = 16, color = '#9F6402', ...props }) => (
  <svg
    width={width}
    height={height}
    viewBox='0 0 16 16'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M0.666748 14.3333H15.3334L8.00008 1.66667L0.666748 14.3333ZM8.66675 12.3333H7.33342V11H8.66675V12.3333ZM8.66675 9.66667H7.33342V7H8.66675V9.66667Z'
      fill={color}
    />
  </svg>
);
export const ListMenuIcon: React.FC<IconProps> = ({
  fill,
  width = 15,
  height = 9,
}) => (
  <svg
    width={width}
    height={height}
    viewBox='0 0 15 9'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M0 1.66667H11.6667V0H0V1.66667ZM0 5H11.6667V3.33333H0V5ZM0 8.33333H11.6667V6.66667H0V8.33333ZM13.3333 8.33333H15V6.66667H13.3333V8.33333ZM13.3333 0V1.66667H15V0H13.3333ZM13.3333 5H15V3.33333H13.3333V5Z'
      fill={fill}
    />
  </svg>
);
export const InboundIcon: React.FC<{
  size?: number;
  color?: string;
}> = ({ size = 16, color = 'var(--text-primary)', ...props }) => (
  <svg
    width={size}
    height={size}
    viewBox='0 0 12 12'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M4.375 9.5H6.625L4.125 6L6.625 2.5L4.375 2.5L1.875 6L4.375 9.5Z'
      fill={color}
    />
    <path
      d='M7.875 9.5H10.125L7.625 6L10.125 2.5H7.875L5.375 6L7.875 9.5Z'
      fill={color}
    />
  </svg>
);
export const OutboundIcon: React.FC<
  IconProps & { size?: number; color?: string }
> = ({ size = 16, color = 'var(--text-primary)', ...props }) => (
  <svg
    width={size}
    height={size}
    viewBox='0 0 12 12'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M7.625 2.5H5.375L7.875 6L5.375 9.5H7.625L10.125 6L7.625 2.5Z'
      fill={color}
    />
    <path
      d='M4.125 2.5H1.875L4.375 6L1.875 9.5H4.125L6.625 6L4.125 2.5Z'
      fill={color}
    />
  </svg>
);

export const StarTickIcon: React.FC<
  IconProps & { size?: number; color?: string }
> = ({ size = 16, color = 'var(--text-primary)', ...props }) => (
  <svg
    width={size}
    height={size}
    viewBox='0 0 12 12'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M11.3076 4.81608L4.24119 11.8831L0.441057 8.08301L1.39093 7.13314L4.24119 9.98275L10.3577 3.86621L11.3076 4.81608Z'
      fill={color}
    />
    <path
      d='M3.81215 1.37663C3.83375 1.31891 3.91558 1.31889 3.93715 1.37663L4.27569 2.292C4.47828 2.83938 4.90993 3.27108 5.45733 3.47364L6.37205 3.81218C6.43009 3.83365 6.43009 3.9157 6.37205 3.93718L5.45733 4.27572C4.90989 4.47829 4.47826 4.90992 4.27569 5.45736L3.93715 6.37207C3.91567 6.43011 3.83363 6.43011 3.81215 6.37207L3.47361 5.45736C3.27105 4.90996 2.83936 4.47831 2.29197 4.27572L1.3766 3.93718C1.31889 3.9156 1.31893 3.83379 1.3766 3.81218L2.29197 3.47364C2.83936 3.27107 3.27103 2.83938 3.47361 2.292L3.81215 1.37663Z'
      fill={color}
    />
    <path
      d='M1.14548 0.0432975C1.16708 -0.0144194 1.24892 -0.0144456 1.27048 0.0432975L1.4352 0.48861C1.51963 0.716609 1.69936 0.896415 1.92739 0.980797L2.37205 1.14551C2.43009 1.16699 2.43009 1.24903 2.37205 1.27051L1.92739 1.43522C1.69934 1.51964 1.5196 1.69936 1.4352 1.92741L1.27048 2.37207C1.24901 2.43011 1.16696 2.43011 1.14548 2.37207L0.980771 1.92741C0.896389 1.69937 0.716596 1.51966 0.488583 1.43522L0.043271 1.27051C-0.0144433 1.24894 -0.014404 1.16712 0.043271 1.14551L0.488583 0.980797C0.716571 0.896394 0.896357 0.716592 0.980771 0.48861L1.14548 0.0432975Z'
      fill={color}
    />
  </svg>
);
export const UndoIcon: React.FC<
  IconProps & { size?: number; color?: string }
> = ({ size = 16, color = 'var(--text-primary)', ...props }) => (
  <svg
    width={size}
    height={size}
    viewBox='0 0 16 16'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M4.66699 13V11.6667H9.40033C10.1003 11.6667 10.7087 11.4444 11.2253 11C11.742 10.5556 12.0003 10 12.0003 9.33333C12.0003 8.66667 11.742 8.11111 11.2253 7.66667C10.7087 7.22222 10.1003 7 9.40033 7H5.20033L6.93366 8.73333L6.00033 9.66667L2.66699 6.33333L6.00033 3L6.93366 3.93333L5.20033 5.66667H9.40033C10.4781 5.66667 11.4031 6.01667 12.1753 6.71667C12.9475 7.41667 13.3337 8.28889 13.3337 9.33333C13.3337 10.3778 12.9475 11.25 12.1753 11.95C11.4031 12.65 10.4781 13 9.40033 13H4.66699Z'
      fill={color}
    />
  </svg>
);

export const TemplateIcon: React.FC<
  IconProps & { size?: number; color?: string }
> = ({ size = 16, color = 'var(--text-primary)', ...props }) => (
  <svg
    width={size}
    height={size}
    viewBox='0 0 36 36'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M11.333 12.666V17.3327H24.6663V12.666H11.333ZM16.6663 23.3327H24.6663V18.666H16.6663V23.3327ZM11.333 23.3327H15.333V18.666H11.333V23.3327Z'
      fill={color}
    />
  </svg>
);
export const CancelIcon: React.FC<
  IconProps & { size?: number; color?: string }
> = ({ size = 16, color = 'var(--text-primary)', ...props }) => (
  <svg
    width={size}
    height={size}
    viewBox='0 0 16 16'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M7.99967 1.33398C4.31301 1.33398 1.33301 4.31398 1.33301 8.00065C1.33301 11.6873 4.31301 14.6673 7.99967 14.6673C11.6863 14.6673 14.6663 11.6873 14.6663 8.00065C14.6663 4.31398 11.6863 1.33398 7.99967 1.33398ZM7.99967 13.334C5.05967 13.334 2.66634 10.9407 2.66634 8.00065C2.66634 5.06065 5.05967 2.66732 7.99967 2.66732C10.9397 2.66732 13.333 5.06065 13.333 8.00065C13.333 10.9407 10.9397 13.334 7.99967 13.334ZM10.393 4.66732L7.99967 7.06065L5.60634 4.66732L4.66634 5.60732L7.05967 8.00065L4.66634 10.394L5.60634 11.334L7.99967 8.94065L10.393 11.334L11.333 10.394L8.93967 8.00065L11.333 5.60732L10.393 4.66732Z'
      fill={color}
    />
  </svg>
);

export const CopyOutlinedRect: React.FC<
  IconProps & { size?: number; color?: string }
> = ({ size = 16, color = 'var(--text-primary)', ...props }) => (
  <svg
    width={size}
    height={size}
    viewBox='0 0 16 16'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <g clipPath='url(#clip0_30503_262)'>
      <path
        d='M2.00008 3.33329H0.666748V14C0.666748 14.7333 1.26675 15.3333 2.00008 15.3333H12.6667V14H2.00008V3.33329ZM14.0001 0.666626H4.66675C3.93341 0.666626 3.33341 1.26663 3.33341 1.99996V11.3333C3.33341 12.0666 3.93341 12.6666 4.66675 12.6666H14.0001C14.7334 12.6666 15.3334 12.0666 15.3334 11.3333V1.99996C15.3334 1.26663 14.7334 0.666626 14.0001 0.666626ZM14.0001 11.3333H4.66675V1.99996H14.0001V11.3333Z'
        fill={color}
      />
    </g>
    <defs>
      <clipPath id='clip0_30503_262'>
        <rect width='16' height='16' fill='white' />
      </clipPath>
    </defs>
  </svg>
);

export const PlusCircleIcon: React.FC<IconProps> = ({
  width = 12,
  height = 12,
  color = 'var(--text-primary)',
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox='0 0 12 12'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M6 1C3.24 1 1 3.24 1 6C1 8.76 3.24 11 6 11C8.76 11 11 8.76 11 6C11 3.24 8.76 1 6 1ZM8.5 6.5H6.5V8.5H5.5V6.5H3.5V5.5H5.5V3.5H6.5V5.5H8.5V6.5Z'
        fill={color}
      />
    </svg>
  );
};

export const CloseCircleIcon: React.FC<IconProps> = ({
  width = 12,
  height = 12,
  color = 'var(--text-primary)',
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox='0 0 11 11'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M5.5 0C2.45 0 0 2.45 0 5.5C0 8.55 2.45 11 5.5 11C8.55 11 11 8.55 11 5.5C11 2.45 8.55 0 5.5 0ZM8.5 7.5L7.5 8.5L5.5 6.5L3.5 8.5L2.5 7.5L4.5 5.5L2.5 3.5L3.5 2.5L5.5 4.5L7.5 2.5L8.5 3.5L6.5 5.5L8.5 7.5Z'
        fill={color}
      />
    </svg>
  );
};
export const EditChartIcon: React.FC<
  IconProps & { size?: number; color?: string }
> = ({ width = 16, height = 16, color = 'var(--text-primary)', ...props }) => (
  <svg
    width={width}
    height={height}
    viewBox='0 0 16 16'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M2 2H7.33333V7.33333H2V2ZM8.66667 2H14V7.33333H8.66667V2ZM2 8.66667H7.33333V14H2V8.66667ZM12 8.66667H10.6667V10.6667H8.66667V12H10.6667V14H12V12H14V10.6667H12V8.66667Z'
      fill={color}
    />
  </svg>
);

export const RocketIcon: React.FC<IconProps & { color?: string }> = ({
  width = 24,
  height = 24,
  color = 'var(--text-primary)',
  ...props
}) => (
  <svg
    width={width}
    height={height}
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M9.43512 6.10707C7.39512 8.39707 5.99512 11.6871 5.86512 11.9971L2.24512 10.4471L6.29512 6.39707C6.76512 5.92707 7.44512 5.71707 8.10512 5.84707L9.43512 6.10707ZM11.4151 16.7571C11.4151 16.7571 15.1551 15.2071 17.3051 13.0571C22.7051 7.65707 21.8051 3.43707 21.5151 2.48707C20.5651 2.18707 16.3451 1.29707 10.9451 6.69707C8.79512 8.84707 7.24512 12.5871 7.24512 12.5871L11.4151 16.7571ZM17.8951 14.5671C15.6051 16.6071 12.3151 18.0071 12.0051 18.1371L13.5551 21.7571L17.6051 17.7071C18.0751 17.2371 18.2851 16.5571 18.1551 15.8971L17.8951 14.5671ZM9.24512 17.7571C9.24512 18.5871 8.90512 19.3371 8.36512 19.8771C7.18512 21.0571 2.24512 21.7571 2.24512 21.7571C2.24512 21.7571 2.94512 16.8171 4.12512 15.6371C4.66512 15.0971 5.41512 14.7571 6.24512 14.7571C7.90512 14.7571 9.24512 16.0971 9.24512 17.7571ZM13.2451 8.75707C13.2451 7.65707 14.1451 6.75707 15.2451 6.75707C16.3451 6.75707 17.2451 7.65707 17.2451 8.75707C17.2451 9.85707 16.3451 10.7571 15.2451 10.7571C14.1451 10.7571 13.2451 9.85707 13.2451 8.75707Z'
      fill={color}
    />
  </svg>
);

export const AddChartIcon: React.FC<
  IconProps & { size?: number; color?: string }
> = ({ width = 52, height = 52, color = '#266EF1', ...props }) => (
  <svg
    width={width}
    height={height}
    viewBox='0 0 52 52'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M25.9999 4.33334C14.0399 4.33334 4.33325 14.04 4.33325 26C4.33325 37.96 14.0399 47.6667 25.9999 47.6667C37.9599 47.6667 47.6666 37.96 47.6666 26C47.6666 14.04 37.9599 4.33334 25.9999 4.33334ZM36.8332 28.1667H28.1666V36.8333H23.8333V28.1667H15.1666V23.8333H23.8333V15.1667H28.1666V23.8333H36.8332V28.1667Z'
      fill={color}
    />
  </svg>
);

export const ListIcon: React.FC<
  IconProps & { size?: number; color?: string }
> = ({ width = 16, height = 16, color = 'var(--text-primary)', ...props }) => (
  <svg
    width={width}
    height={height}
    viewBox='0 0 16 16'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M2 8.6665H3.33333V7.33317H2V8.6665ZM2 11.3332H3.33333V9.99984H2V11.3332ZM2 5.99984H3.33333V4.6665H2V5.99984ZM4.66667 8.6665H14V7.33317H4.66667V8.6665ZM4.66667 11.3332H14V9.99984H4.66667V11.3332ZM4.66667 4.6665V5.99984H14V4.6665H4.66667ZM2 8.6665H3.33333V7.33317H2V8.6665ZM2 11.3332H3.33333V9.99984H2V11.3332ZM2 5.99984H3.33333V4.6665H2V5.99984ZM4.66667 8.6665H14V7.33317H4.66667V8.6665ZM4.66667 11.3332H14V9.99984H4.66667V11.3332ZM4.66667 4.6665V5.99984H14V4.6665H4.66667Z'
      fill={color}
    />
  </svg>
);
export const CalendarIcon: React.FC<
  IconProps & { size?: number; color?: string }
> = ({ width = 16, height = 16, color = 'var(--text-primary)', ...props }) => (
  <svg
    width={width}
    height={height}
    viewBox='0 0 16 16'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M12.6667 2.66683H12V1.3335H10.6667V2.66683H5.33333V1.3335H4V2.66683H3.33333C2.59333 2.66683 2.00667 3.26683 2.00667 4.00016L2 13.3335C2 14.0668 2.59333 14.6668 3.33333 14.6668H12.6667C13.4 14.6668 14 14.0668 14 13.3335V4.00016C14 3.26683 13.4 2.66683 12.6667 2.66683ZM12.6667 13.3335H3.33333V6.66683H12.6667V13.3335ZM12.6667 5.3335H3.33333V4.00016H12.6667V5.3335ZM6 9.3335H4.66667V8.00016H6V9.3335ZM8.66667 9.3335H7.33333V8.00016H8.66667V9.3335ZM11.3333 9.3335H10V8.00016H11.3333V9.3335ZM6 12.0002H4.66667V10.6668H6V12.0002ZM8.66667 12.0002H7.33333V10.6668H8.66667V12.0002ZM11.3333 12.0002H10V10.6668H11.3333V12.0002Z'
      fill={color}
    />
  </svg>
);

export const ProfileIcon: React.FC<IconProps> = ({
  width = 20,
  height = 20,
  fill = 'currentColor',
}: IconProps) => (
  <svg
    width={width}
    height={height}
    viewBox='0 0 20 20'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M10.0002 5.00004C10.9168 5.00004 11.6668 5.75004 11.6668 6.66671C11.6668 7.58337 10.9168 8.33337 10.0002 8.33337C9.0835 8.33337 8.3335 7.58337 8.3335 6.66671C8.3335 5.75004 9.0835 5.00004 10.0002 5.00004ZM10.0002 13.3334C12.2502 13.3334 14.8335 14.4084 15.0002 15H5.00016C5.19183 14.4 7.7585 13.3334 10.0002 13.3334ZM10.0002 3.33337C8.1585 3.33337 6.66683 4.82504 6.66683 6.66671C6.66683 8.50837 8.1585 10 10.0002 10C11.8418 10 13.3335 8.50837 13.3335 6.66671C13.3335 4.82504 11.8418 3.33337 10.0002 3.33337ZM10.0002 11.6667C7.77516 11.6667 3.3335 12.7834 3.3335 15V16.6667H16.6668V15C16.6668 12.7834 12.2252 11.6667 10.0002 11.6667Z'
      fill={fill}
    />
  </svg>
);

export const LogoutIcon = ({
  width = 16,
  height = 16,
  fill = '#266EF1',
}: IconProps) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox='0 0 16 16'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M14.0003 2.00684H2.00033C1.26699 2.00684 0.666992 2.60684 0.666992 3.34017V6.00017H2.00033V3.32684H14.0003V12.6802H2.00033V10.0002H0.666992V12.6735C0.666992 13.4068 1.26699 13.9935 2.00033 13.9935H14.0003C14.7337 13.9935 15.3337 13.4068 15.3337 12.6735V3.34017C15.3337 2.60017 14.7337 2.00684 14.0003 2.00684ZM7.33366 10.6668L10.0003 8.00017L7.33366 5.3335V7.3335H0.666992V8.66684H7.33366V10.6668Z'
        fill={fill}
      />
    </svg>
  );
};

export const RefreshClockIcon: React.FC<IconProps> = ({
  color = '#266EF1',
  width = 18,
  height = 18,
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox='0 0 18 18'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M17.9988 7.12H11.2188L13.9588 4.3C11.2288 1.6 6.80878 1.5 4.07878 4.2C1.34878 6.91 1.34878 11.28 4.07878 13.99C6.80878 16.7 11.2288 16.7 13.9588 13.99C15.3188 12.65 15.9988 11.08 15.9988 9.1H17.9988C17.9988 11.08 17.1188 13.65 15.3588 15.39C11.8488 18.87 6.14878 18.87 2.63878 15.39C-0.861217 11.92 -0.891217 6.28 2.61878 2.81C6.12878 -0.66 11.7588 -0.66 15.2688 2.81L17.9988 0V7.12ZM9.49878 5V9.25L12.9988 11.33L12.2788 12.54L7.99878 10V5H9.49878Z'
        fill={color}
      />
    </svg>
  );
};

export const ManualTriggerIcon: React.FC<IconProps> = ({
  width = 15,
  height = 21,
  color = '#266EF1',
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox='0 0 15 21'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M4.25 8.24V4.5C4.25 3.12 5.37 2 6.75 2C8.13 2 9.25 3.12 9.25 4.5V8.24C10.46 7.43 11.25 6.06 11.25 4.5C11.25 2.01 9.24 0 6.75 0C4.26 0 2.25 2.01 2.25 4.5C2.25 6.06 3.04 7.43 4.25 8.24ZM14.09 12.87L9.55 10.61C9.38 10.54 9.2 10.5 9.01 10.5H8.25V4.5C8.25 3.67 7.58 3 6.75 3C5.92 3 5.25 3.67 5.25 4.5V15.24C1.65 14.48 1.71 14.49 1.58 14.49C1.27 14.49 0.99 14.62 0.79 14.82L0 15.62L4.94 20.56C5.21 20.83 5.59 21 6 21H12.79C13.54 21 14.12 20.45 14.23 19.72L14.98 14.45C14.99 14.38 15 14.31 15 14.25C15 13.63 14.62 13.09 14.09 12.87Z'
        fill={color}
      />
    </svg>
  );
};

export const FilterIcon: React.FC<IconProps> = ({
  width,
  height,
  color = '#E09D64',
}) => {
  return (
    <>
      <svg
        width={width}
        height={height}
        viewBox='0 0 16 16'
        fill={color}
        xmlns='http://www.w3.org/2000/svg'
      >
        <path
          d='M0.211604 1.61C2.2316 4.2 5.9616 9 5.9616 9V15C5.9616 15.55 6.4116 16 6.9616 16H8.9616C9.5116 16 9.9616 15.55 9.9616 15V9C9.9616 9 13.6816 4.2 15.7016 1.61C16.2116 0.95 15.7416 0 14.9116 0H1.0016C0.171604 0 -0.298396 0.95 0.211604 1.61Z'
          fill={color}
        />
      </svg>
    </>
  );
};
export const TableRows: React.FC<IconProps> = ({
  width,
  height,
  color = '#fff',
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox='0 0 12 12'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M10.5 4H1.5V2H10.5V4ZM10.5 5H1.5V7H10.5V5ZM10.5 8H1.5V10H10.5V8Z'
        fill={color}
      />
    </svg>
  );
};
export const TickIcon: React.FC<IconProps> = ({
  width,
  height,
  color = '#fff',
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox='0 0 16 32'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M5.86339 18.5834L3.08339 15.8034L2.13672 16.7434L5.86339 20.47L13.8634 12.47L12.9234 11.53L5.86339 18.5834Z'
        fill={color}
      />
    </svg>
  );
};
export const NavigateLinkIcon: React.FC<IconProps> = ({
  width = 16,
  height = 16,
  color = 'var(--text-primary)',
}) => {
  return (
    <>
      <svg
        width={width}
        height={height}
        viewBox='0 0 16 16'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
      >
        <path
          d='M12.6667 12.6667H3.33333V3.33333H8V2H3.33333C2.59333 2 2 2.6 2 3.33333V12.6667C2 13.4 2.59333 14 3.33333 14H12.6667C13.4 14 14 13.4 14 12.6667V8H12.6667V12.6667ZM9.33333 2V3.33333H11.7267L5.17333 9.88667L6.11333 10.8267L12.6667 4.27333V6.66667H14V2H9.33333Z'
          fill={color}
        />
      </svg>
    </>
  );
};

// chain-link icon, used for "Copy shipment link" in the shipment menu
export const LinkIcon: React.FC<IconProps> = ({
  width = 16,
  height = 16,
  color = 'var(--text-primary)',
}) => (
  <svg
    width={width}
    height={height}
    viewBox='0 0 16 16'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M6.66667 8.66667C6.95323 9.05978 7.32094 9.38663 7.74457 9.62307C8.16821 9.85951 8.63731 9.99979 9.11979 10.0259C9.60227 10.052 10.0843 9.97335 10.5334 9.79499C10.9824 9.61662 11.3878 9.34273 11.7211 8.992L13.7211 6.992C14.3204 6.37146 14.6519 5.54046 14.6444 4.67786C14.637 3.81526 14.291 2.99016 13.681 2.38013C13.0709 1.77011 12.2458 1.42404 11.3832 1.4166C10.5206 1.40916 9.68964 1.74062 9.06911 2.33999L7.92245 3.47999M9.33335 7.33333C9.04679 6.94022 8.67908 6.61337 8.25545 6.37693C7.83181 6.14049 7.36271 6.00021 6.88023 5.97409C6.39775 5.94797 5.91569 6.02665 5.46665 6.20501C5.01761 6.38338 4.61221 6.65727 4.27892 7.008L2.27892 9.008C1.67955 9.62854 1.34809 10.4595 1.35553 11.3221C1.36297 12.1847 1.70904 13.0098 2.31907 13.6199C2.92909 14.2299 3.75419 14.576 4.61679 14.5834C5.47939 14.5909 6.31039 14.2594 6.93092 13.66L8.07092 12.52'
      stroke={color}
      strokeWidth='1.33333'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </svg>
);
export const LinkInlineIcon: React.FC<IconProps> = ({
  width = 16,
  height = 16,
  color = 'var(--text-primary)',
}) => (
  <svg
    width={width}
    height={height}
    viewBox='0 0 16 16'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M2.59998 7.99999C2.59998 6.85999 3.52665 5.93332 4.66665 5.93332H7.33331V4.66666H4.66665C2.82665 4.66666 1.33331 6.15999 1.33331 7.99999C1.33331 9.83999 2.82665 11.3333 4.66665 11.3333H7.33331V10.0667H4.66665C3.52665 10.0667 2.59998 9.13999 2.59998 7.99999ZM5.33331 8.66666H10.6666V7.33332H5.33331V8.66666ZM11.3333 4.66666H8.66665V5.93332H11.3333C12.4733 5.93332 13.4 6.85999 13.4 7.99999C13.4 9.13999 12.4733 10.0667 11.3333 10.0667H8.66665V11.3333H11.3333C13.1733 11.3333 14.6666 9.83999 14.6666 7.99999C14.6666 6.15999 13.1733 4.66666 11.3333 4.66666Z'
      fill={color}
    />
  </svg>
);

// Help center "Open {path}" button.
export const ExternalLinkIcon: React.FC<IconProps> = ({
  width = 16,
  height = 16,
  color = 'var(--text-primary)',
}) => (
  <svg
    width={width}
    height={height}
    viewBox='0 0 24 24'
    fill='none'
    stroke={color}
    strokeWidth={2}
    strokeLinecap='round'
    strokeLinejoin='round'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path d='M14 4h6v6M20 4l-9 9M19 14v5a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1h5' />
  </svg>
);

//using in logiblocks conditional node
export const CustomSelectIcon: React.FC<IconProps> = ({
  width = 8,
  height = 6,
  color = 'var(--text-secondary)',
}) => (
  <svg
    width={width}
    height={height}
    viewBox='0 0 8 6'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path d='M8 0V2.53333L4 5.6L0 2.53333V0L4 3.06667L8 0Z' fill={color} />
  </svg>
);

export const SubsetIcon: React.FC<IconProps> = ({
  width = 16,
  height = 16,
  color = 'var(--gray-300)',
}) => (
  <svg
    width={width}
    height={height}
    viewBox='0 0 16 16'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path d='M4 3.33337H5.33333V12.6667H4V3.33337Z' fill={color} />
    <path d='M4 11.3334H13.3333V12.6667H4V11.3334Z' fill={color} />
  </svg>
);

/** Same warehouse mark as InventoryPageColorIcon (20×20) so trigger menus match other row icons at 20px. */
export const LowInventoryIcon: React.FC<IconProps> = ({
  width = 24,
  height = 24,
  color = 'var(--text-primary)',
  fill,
  className,
  style,
}) => {
  const ink = fill ?? color;
  return (
    <svg
      width={width}
      height={height}
      viewBox='0 0 20 20'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      className={className}
      // eslint-disable-next-line react/forbid-dom-props -- forwards the caller's style prop
      style={{ display: 'block', ...style }}
    >
      <path
        d='M18.3333 17.5V5.83333L9.99996 2.5L1.66663 5.83333V17.5H5.83329V10H14.1666V17.5H18.3333ZM9.16663 15.8333H7.49996V17.5H9.16663V15.8333ZM10.8333 13.3333H9.16663V15H10.8333V13.3333ZM12.5 15.8333H10.8333V17.5H12.5V15.8333Z'
        fill={ink}
      />
    </svg>
  );
};

export const TemperatureGxpReportIcon: React.FC<IconProps> = ({
  width = 24,
  height = 24,
  color = 'var(--text-primary)',
  fill,
  className,
  style,
}) => {
  const ink = fill ?? color;
  return (
    <svg
      width={width}
      height={height}
      viewBox='0 0 24 24'
      fill='none'
      className={className}
      // eslint-disable-next-line react/forbid-dom-props -- forwards the caller's style prop
      style={{ display: 'block', ...style }}
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M15 13V5C15 3.34 13.66 2 12 2C10.34 2 9 3.34 9 5V13C7.79 13.91 7 15.37 7 17C7 19.76 9.24 22 12 22C14.76 22 17 19.76 17 17C17 15.37 16.21 13.91 15 13ZM11 11V5C11 4.45 11.45 4 12 4C12.55 4 13 4.45 13 5V6H12V7H13V9H12V10H13V11H11Z'
        fill={ink}
      />
    </svg>
  );
};

export const CircleInfoIcon = ({
  size = 14,
  color = 'var(--text-primary)',
}) => (
  <svg
    width={size}
    height={size}
    viewBox='0 0 14 14'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M6.66667 0C2.98667 0 0 2.98667 0 6.66667C0 10.3467 2.98667 13.3333 6.66667 13.3333C10.3467 13.3333 13.3333 10.3467 13.3333 6.66667C13.3333 2.98667 10.3467 0 6.66667 0ZM7.33333 10H6V6H7.33333V10ZM7.33333 4.66667H6V3.33333H7.33333V4.66667Z'
      fill={color}
    />
  </svg>
);

export const ColumnsIcon: React.FC<IconProps> = ({
  width = 12,
  height = 12,
  color = 'var(--text-primary)',
}) => (
  <svg
    width={width}
    height={height}
    viewBox='0 0 12 12'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M10 2H2C1.45 2 1 2.45 1 3V9C1 9.55 1.45 10 2 10H10C10.55 10 11 9.55 11 9V3C11 2.45 10.55 2 10 2ZM4 9H2V3H4V9ZM7 9H5V3H7V9ZM10 9H8V3H10V9Z'
      fill={color}
    />
  </svg>
);

export const BellPlusIcon: React.FC<IconProps> = ({
  width = 16,
  height = 16,
  color = 'var(--text-primary)',
}) => (
  <svg
    width={width}
    height={height}
    viewBox='0 0 16 16'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M5.33337 13.3333H8.00004C8.00004 14.0666 7.40004 14.6666 6.66671 14.6666C5.93337 14.6666 5.33337 14.0666 5.33337 13.3333ZM8.00004 5.99998C8.00004 7.73998 9.11337 9.21998 10.6667 9.77331V11.3333H12V12.6666H1.33337V11.3333H2.66671V6.66665C2.66671 4.80665 3.94004 3.23998 5.66671 2.79998V2.33331C5.66671 1.77998 6.11337 1.33331 6.66671 1.33331C7.22004 1.33331 7.66671 1.77998 7.66671 2.33331V2.79998C8.14004 2.91998 8.57337 3.12665 8.96671 3.39998C8.36004 4.09331 8.00004 5.00665 8.00004 5.99998ZM14.6667 5.33331H12.6667V3.33331H11.3334V5.33331H9.33337V6.66665H11.3334V8.66665H12.6667V6.66665H14.6667V5.33331Z'
      fill={color}
    />
  </svg>
);
export const MapExpandIcon: React.FC<IconProps> = ({
  width = 16,
  height = 16,
  color = 'var(--text-primary)',
}) => (
  <svg
    width={width}
    height={height}
    viewBox='0 0 16 16'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M10 2L11.5333 3.53333L9.60667 5.44667L10.5533 6.39333L12.4667 4.46667L14 6V2H10ZM2 6L3.53333 4.46667L5.44667 6.39333L6.39333 5.44667L4.46667 3.53333L6 2H2V6ZM6 14L4.46667 12.4667L6.39333 10.5533L5.44667 9.60667L3.53333 11.5333L2 10V14H6ZM14 10L12.4667 11.5333L10.5533 9.60667L9.60667 10.5533L11.5333 12.4667L10 14H14V10Z'
      fill={color}
    />
  </svg>
);

export const GroupUsersIcon = ({
  size = 15,
  color = '#62BBE1',
  ...props
}: IconProps) => (
  <svg
    width={size}
    height={size}
    viewBox='0 0 15 11'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M10.4467 6.08667C11.36 6.70667 12 7.54667 12 8.66667V10.6667H14.6667V8.66667C14.6667 7.21333 12.2867 6.35333 10.4467 6.08667Z'
      fill={color}
    />
    <path
      d='M5.33333 5.33333C6.80609 5.33333 8 4.13943 8 2.66667C8 1.19391 6.80609 0 5.33333 0C3.86057 0 2.66667 1.19391 2.66667 2.66667C2.66667 4.13943 3.86057 5.33333 5.33333 5.33333Z'
      fill={color}
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M9.33333 5.33333C10.8067 5.33333 12 4.14 12 2.66667C12 1.19333 10.8067 0 9.33333 0C9.02 0 8.72667 0.0666665 8.44667 0.16C9 0.846667 9.33333 1.72 9.33333 2.66667C9.33333 3.61333 9 4.48667 8.44667 5.17333C8.72667 5.26667 9.02 5.33333 9.33333 5.33333Z'
      fill={color}
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M5.33333 6C3.55333 6 0 6.89333 0 8.66667V10.6667H10.6667V8.66667C10.6667 6.89333 7.11333 6 5.33333 6Z'
      fill={color}
    />
  </svg>
);
export const UserIcon = ({
  size = 16,
  color = 'var(--text-primary)',
  ...props
}: IconProps) => (
  <svg
    width={size}
    height={size}
    viewBox='0 0 16 16'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M8 8C10.21 8 12 6.21 12 4C12 1.79 10.21 0 8 0C5.79 0 4 1.79 4 4C4 6.21 5.79 8 8 8ZM8 10C5.33 10 0 11.34 0 14V16H16V14C16 11.34 10.67 10 8 10Z'
      fill={color}
    />
  </svg>
);

export const HamburgerIcon: React.FC<IconProps> = ({
  width = 20,
  height = 20,
  color = '#fff',
}) => (
  <svg
    width={width}
    height={height}
    viewBox='0 0 20 20'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M2.5 15H17.5V13.3333H2.5V15ZM2.5 10.8333H17.5V9.16667H2.5V10.8333ZM2.5 5V6.66667H17.5V5H2.5Z'
      fill={color}
    />
  </svg>
);

export const WatchLaterIcon: React.FC<IconProps> = ({
  width = 8,
  height = 8,
  color = 'var(--text-primary)',
}) => (
  <svg
    width={width}
    height={height}
    viewBox='0 0 8 8'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <g clipPath='url(#wl)'>
      <path
        d='M3.99996 0.666626C2.16663 0.666626 0.666626 2.16663 0.666626 3.99996C0.666626 5.83329 2.16663 7.33329 3.99996 7.33329C5.83329 7.33329 7.33329 5.83329 7.33329 3.99996C7.33329 2.16663 5.83329 0.666626 3.99996 0.666626ZM3.99996 6.66663C2.52996 6.66663 1.33329 5.46996 1.33329 3.99996C1.33329 2.52996 2.52996 1.33329 3.99996 1.33329C5.46996 1.33329 6.66663 2.52996 6.66663 3.99996C6.66663 5.46996 5.46996 6.66663 3.99996 6.66663ZM4.16663 2.33329H3.66663V4.33329L5.39996 5.39996L5.66663 4.96663L4.16663 4.06663V2.33329Z'
        fill={color}
      />
    </g>
    <defs>
      <clipPath id='wl'>
        <rect width='8' height='8' fill='white' />
      </clipPath>
    </defs>
  </svg>
);

export const AiInsightsIcon: React.FC<IconProps> = ({
  width = 20,
  height = 20,
  color = 'currentColor',
}) => (
  <svg
    width={width}
    height={height}
    viewBox='0 0 16 16'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M8 0L10.5 5.5L16 8L10.5 10.5L8 16L5.5 10.5L0 8L5.5 5.5L8 0Z'
      fill={color}
    />
  </svg>
);

export const AiAssistantHeaderIcon: React.FC<{
  width?: number;
  height?: number;
}> = ({ width = 38, height = 38 }) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width={width}
    height={height}
    fill='none'
    viewBox='0 0 38 38'
  >
    <rect width='36' height='36' x='1' y='1' fill='#000' rx='18' />
    <rect
      width='36'
      height='36'
      x='1'
      y='1'
      stroke='url(#paint0_linear_37298_52562)'
      strokeWidth='2'
      rx='18'
    />
    <path
      fill='#fff'
      d='M17.542 15.338a.133.133 0 0 1 .25 0l.677 1.83a4 4 0 0 0 2.363 2.363l1.83.677a.133.133 0 0 1 0 .25l-1.83.678a4 4 0 0 0-2.363 2.363l-.677 1.83a.133.133 0 0 1-.25 0l-.678-1.83a4 4 0 0 0-2.363-2.363l-1.83-.678a.133.133 0 0 1 0-.25l1.83-.677a4 4 0 0 0 2.364-2.363zM22.875 12.671a.133.133 0 0 1 .25 0l.33.89c.168.456.528.816.984.985l.89.329a.133.133 0 0 1 0 .25l-.89.33a1.67 1.67 0 0 0-.985.984l-.329.89a.133.133 0 0 1-.25 0l-.33-.89a1.67 1.67 0 0 0-.984-.985l-.89-.329a.133.133 0 0 1 0-.25l.89-.33c.456-.168.816-.528.985-.984z'
    />
    <defs>
      <linearGradient
        id='paint0_linear_37298_52562'
        x1='37.289'
        x2='-5.855'
        y1='8'
        y2='8'
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#42C47F' />
        <stop offset='1' stopColor='#065DFF' />
      </linearGradient>
    </defs>
  </svg>
);

export const AirIcon: React.FC<IconProps> = (props) => (
  <svg
    width={28}
    height={28}
    viewBox='0 0 28 28'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <rect x={2} y={2} width={24} height={24} rx={6} fill='var(--dark-border)' />
    <path
      d='M9.36804 12.6666H12.889L10.6667 8.66663H12.0001L16.0001 12.6666H19.3334C20.0698 12.6666 20.6667 13.2636 20.6667 14C20.6667 14.7363 20.0698 15.3333 19.3334 15.3333H16.0001L12.0001 19.3333H10.6667L12.889 15.3333H9.33338C8.597 15.3333 8.00005 14.7363 8.00005 14C8.00005 13.9912 8.00013 13.9825 8.0003 13.9738L7.43335 10.6666H7.89241C8.1376 10.6666 8.36301 10.8012 8.47931 11.0171L9.36804 12.6666Z'
      fill='var(--text-primary)'
    />
  </svg>
);

export const CartageIcon: React.FC<IconProps> = (props) => (
  <svg
    width={28}
    height={28}
    viewBox='0 0 28 28'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <rect x={2} y={2} width={24} height={24} rx={6} fill='var(--dark-border)' />
    <path
      d='M17.333 11.333H19.333L21.333 14V17.333H19.7109C19.7109 18.2618 18.9581 19.0155 18.0293 19.0156C17.1003 19.0156 16.3467 18.2619 16.3467 17.333H11.6816C11.6816 18.2619 10.9279 19.0146 9.99902 19.0146C9.07029 19.0145 8.31745 18.2618 8.31738 17.333H6.66602V13.665H10C10.3673 13.665 10.665 13.3673 10.665 13C10.665 12.6327 10.3673 12.335 10 12.335H6.66602V11.665H10C10.3673 11.665 10.665 11.3673 10.665 11C10.665 10.6327 10.3673 10.335 10 10.335H6.66602V10C6.66602 9.63345 6.79667 9.31966 7.05762 9.05859C7.31865 8.79756 7.6325 8.66707 7.99902 8.66699H17.333V11.333ZM17.333 14.667H20.166L18.666 12.667H17.333V14.667Z'
      fill='var(--text-primary)'
    />
  </svg>
);

export const ClearanceIcon: React.FC<IconProps> = (props) => (
  <svg
    width={28}
    height={28}
    viewBox='0 0 28 28'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <rect x={2} y={2} width={24} height={24} rx={6} fill='var(--dark-border)' />
    <path
      d='M15.3334 7.33337H10.0001C9.26675 7.33337 8.67341 7.93337 8.67341 8.66671L8.66675 19.3334C8.66675 20.0667 9.26008 20.6667 9.99341 20.6667H18.0001C18.7334 20.6667 19.3334 20.0667 19.3334 19.3334V11.3334L15.3334 7.33337ZM13.2934 18L10.9334 15.64L11.8734 14.7L13.2867 16.1134L16.1134 13.2867L17.0534 14.2267L13.2934 18ZM14.6667 12V8.33337L18.3334 12H14.6667Z'
      fill='var(--text-primary)'
    />
  </svg>
);

export const EmptyIcon: React.FC<IconProps> = (props) => (
  <svg
    width={28}
    height={28}
    viewBox='0 0 28 28'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <rect x={2} y={2} width={24} height={24} rx={6} fill='var(--dark-border)' />
    <path
      d='M15.5559 7.51697C16.2466 7.68164 16.8955 7.95225 17.4836 8.31287L17.137 8.88025C17.9438 9.37517 18.6244 10.0558 19.1194 10.8627L19.6858 10.515C20.0466 11.1032 20.3178 11.752 20.4827 12.4427L19.8372 12.597C19.9443 13.0463 20.0012 13.5163 20.0012 14.0004C20.0012 14.4843 19.9443 14.9536 19.8372 15.4027L20.4827 15.556C20.3179 16.2469 20.0466 16.8954 19.6858 17.4838L19.1194 17.1371C18.6244 17.944 17.9439 18.6245 17.137 19.1195L17.4836 19.6859C16.8953 20.0467 16.2468 20.3181 15.5559 20.4828L15.4026 19.8373C14.9535 19.9444 14.4841 20.0013 14.0002 20.0013C13.5161 20.0013 13.0462 19.9445 12.5969 19.8373L12.4426 20.4828C11.7519 20.3179 11.1031 20.0468 10.5149 19.6859L10.8625 19.1195C10.0557 18.6246 9.37504 17.944 8.88013 17.1371L8.31274 17.4838C7.95213 16.8956 7.68152 16.2467 7.51685 15.556L8.16235 15.4027C8.08204 15.066 8.03007 14.7178 8.00903 14.3607L7.99829 14.0004C7.99829 13.5163 8.05517 13.0463 8.16235 12.597L7.51685 12.4427C7.68164 11.7522 7.95205 11.1031 8.31274 10.515L8.88013 10.8627C9.37507 10.0558 10.0557 9.37519 10.8625 8.88025L10.5149 8.31287C11.103 7.95217 11.7521 7.68176 12.4426 7.51697L12.5969 8.16248C13.0462 8.05529 13.5162 7.99841 14.0002 7.99841C14.4841 7.99844 14.9535 8.05536 15.4026 8.16248L15.5559 7.51697ZM14.0002 8.00134C13.5189 8.00134 13.0497 8.05886 12.5999 8.16638L12.7542 8.81287V8.81384C12.2019 8.9459 11.6827 9.16265 11.2122 9.45154L10.8645 8.88513C10.0589 9.37972 9.37959 10.0591 8.88501 10.8646L9.45142 11.2123C9.16253 11.6828 8.94578 12.202 8.81372 12.7543H8.81274L8.16626 12.6C8.05873 13.0498 8.00122 13.519 8.00122 14.0004C8.00125 14.4817 8.05874 14.951 8.16626 15.4008L8.81274 15.2455L8.81372 15.2445C8.94566 15.7969 9.1626 16.3159 9.45142 16.7865V16.7875L8.88501 17.1351C9.37967 17.9409 10.0587 18.621 10.8645 19.1156L11.2122 18.5482V18.5472C11.6827 18.8363 12.2018 19.0528 12.7542 19.1849V19.1869L12.5999 19.8344C13.0497 19.9419 13.5189 19.9984 14.0002 19.9984C14.4815 19.9984 14.9509 19.9419 15.4006 19.8344L15.2454 19.1869L15.2444 19.1849C15.7969 19.0529 16.3157 18.8362 16.7864 18.5472L16.7874 18.5482L17.135 19.1156C17.9408 18.6209 18.6208 17.9409 19.1155 17.1351L18.5481 16.7875L18.5471 16.7865C18.8361 16.3158 19.0528 15.797 19.1848 15.2445L19.1868 15.2455L19.8342 15.4008C19.9149 15.0634 19.9665 14.7148 19.9875 14.3588L19.9983 14.0004C19.9983 13.5191 19.9417 13.0498 19.8342 12.6L19.1868 12.7543H19.1848C19.0527 12.2019 18.8361 11.6829 18.5471 11.2123L19.1155 10.8646C18.6208 10.0588 17.9408 9.37979 17.135 8.88513L16.7874 9.45154H16.7864C16.3158 9.16273 15.7968 8.94579 15.2444 8.81384L15.2454 8.81287L15.4006 8.16638C14.9509 8.05886 14.4815 8.00137 14.0002 8.00134Z'
      stroke='var(--text-primary)'
      strokeWidth={1.33}
      strokeDasharray='3 2'
    />
  </svg>
);

export const LinehaulIcon: React.FC<IconProps> = (props) => (
  <svg
    width={28}
    height={28}
    viewBox='0 0 28 28'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <rect x={2} y={2} width={24} height={24} rx={6} fill='var(--dark-border)' />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M6.66675 17.3333V9.99996C6.66675 9.63329 6.7973 9.3194 7.05841 9.05829C7.31953 8.79718 7.63341 8.66663 8.00008 8.66663H17.3334V11.3333H19.3334L21.3334 14V17.3333H19.7118C19.7118 18.2622 18.9587 19.0153 18.0297 19.0153C17.1008 19.0153 16.3477 18.2622 16.3477 17.3333H11.682C11.682 18.2622 10.929 19.0151 10.0001 19.0151C9.0712 19.0151 8.31818 18.2622 8.31812 17.3333H6.66675ZM17.3334 14.6666H20.1667L18.6667 12.6666H17.3334V14.6666Z'
      fill='var(--text-primary)'
    />
  </svg>
);

export const UnknownIcon: React.FC<IconProps> = (props) => (
  <svg
    width={28}
    height={28}
    viewBox='0 0 28 28'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <rect x={2} y={2} width={24} height={24} rx={6} fill='var(--dark-border)' />
    <path
      d='M11.88 18.6667H17.3333C18.8067 18.6667 20 17.4733 20 16C20 14.5267 18.8067 13.3333 17.3333 13.3333H10.6667C9.93333 13.3333 9.33333 12.7333 9.33333 12C9.33333 11.2667 9.93333 10.6667 10.6667 10.6667H16.12C16.4 11.44 17.1333 12 18 12C19.1067 12 20 11.1067 20 10C20 8.89333 19.1067 8 18 8C17.1333 8 16.4 8.56 16.12 9.33333H10.6667C9.19333 9.33333 8 10.5267 8 12C8 13.4733 9.19333 14.6667 10.6667 14.6667H17.3333C18.0667 14.6667 18.6667 15.2667 18.6667 16C18.6667 16.7333 18.0667 17.3333 17.3333 17.3333H11.88C11.6067 16.56 10.8733 16 10 16C8.89333 16 8 16.8933 8 18C8 19.1067 8.89333 20 10 20C10.8667 20 11.6 19.44 11.88 18.6667Z'
      fill='var(--text-primary)'
    />
  </svg>
);

export enum ShipmentLegModeIcon {
  Air = 1,
  Linehaul = 2,
  Cartage = 3,
  Clearance = 4,
  Empty = 5,
  Unknown = 6,
}

export const getShipmentLegModeIcon = (
  type: ShipmentLegModeIcon,
  props?: IconProps
) => {
  switch (type) {
    case ShipmentLegModeIcon.Air:
      return <AirIcon {...props} />;
    case ShipmentLegModeIcon.Linehaul:
      return <LinehaulIcon {...props} />;
    case ShipmentLegModeIcon.Cartage:
      return <CartageIcon {...props} />;
    case ShipmentLegModeIcon.Clearance:
      return <ClearanceIcon {...props} />;
    case ShipmentLegModeIcon.Empty:
      return <EmptyIcon {...props} />;
    case ShipmentLegModeIcon.Unknown:
    default:
      return <UnknownIcon {...props} />;
  }
};

export const ThumbsUpIcon: React.FC<IconProps> = ({
  width = 16,
  height = 16,
  fill = 'var(--text-secondary)',
  filled = false,
  ...props
}) => (
  <svg
    width={width}
    height={height}
    viewBox='0 0 16 16'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d={
        filled
          ? 'M6.00002 14.6667H12C12.5534 14.6667 13.0267 14.3333 13.2267 13.8533L15.24 9.15333C15.3 8.99999 15.3334 8.83999 15.3334 8.66666V7.33333C15.3334 6.59999 14.7334 5.99999 14 5.99999H9.79335L10.4267 2.95333L10.4467 2.73999C10.4467 2.46666 10.3334 2.21333 10.1534 2.03333L9.44669 1.33333L5.05335 5.72666C4.81335 5.96666 4.66669 6.29999 4.66669 6.66666V13.3333C4.66669 14.0667 5.26669 14.6667 6.00002 14.6667ZM0.666687 6.66666H3.33335V14.6667H0.666687V6.66666Z'
          : 'M6.00002 14.6667H12C12.5534 14.6667 13.0267 14.3333 13.2267 13.8533L15.24 9.15333C15.3 8.99999 15.3334 8.83999 15.3334 8.66666V7.33333C15.3334 6.59999 14.7334 5.99999 14 5.99999H9.79335L10.4267 2.95333L10.4467 2.73999C10.4467 2.46666 10.3334 2.21333 10.1534 2.03333L9.44669 1.33333L5.05335 5.72666C4.81335 5.96666 4.66669 6.29999 4.66669 6.66666V13.3333C4.66669 14.0667 5.26669 14.6667 6.00002 14.6667ZM6.00002 6.66666L8.89335 3.77333L8.00002 7.33333H14V8.66666L12 13.3333H6.00002V6.66666ZM0.666687 6.66666H3.33335V14.6667H0.666687V6.66666Z'
      }
      fill={fill}
    />
  </svg>
);

export const ThumbsDownIcon: React.FC<IconProps> = ({
  width = 24,
  height = 24,
  fill = 'var(--text-secondary)',
  filled = false,
  ...props
}) => (
  <svg
    width={width}
    height={height}
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d={
        filled
          ? 'M14 5.33333H8.00002C7.44669 5.33333 6.97335 5.66666 6.77335 6.14666L4.76002 10.8467C4.70002 11 4.66669 11.16 4.66669 11.3333V12.6667C4.66669 13.4 5.26669 14 6.00002 14H10.2067L9.57335 17.0467L9.55335 17.26C9.55335 17.5333 9.66669 17.7867 9.84669 17.9667L10.5534 18.6667L14.9467 14.2733C15.1867 14.0333 15.3334 13.7 15.3334 13.3333V6.66666C15.3334 5.93333 14.7334 5.33333 14 5.33333ZM16.6667 5.33333H19.3334V13.3333H16.6667V5.33333Z'
          : 'M14 5.33333H8.00002C7.44669 5.33333 6.97335 5.66666 6.77335 6.14666L4.76002 10.8467C4.70002 11 4.66669 11.16 4.66669 11.3333V12.6667C4.66669 13.4 5.26669 14 6.00002 14H10.2067L9.57335 17.0467L9.55335 17.26C9.55335 17.5333 9.66669 17.7867 9.84669 17.9667L10.5534 18.6667L14.9467 14.2733C15.1867 14.0333 15.3334 13.7 15.3334 13.3333V6.66666C15.3334 5.93333 14.7334 5.33333 14 5.33333ZM14 13.3333L11.1067 16.2267L12 12.6667H6.00002V11.3333L8.00002 6.66666H14V13.3333ZM16.6667 5.33333H19.3334V13.3333H16.6667V5.33333Z'
      }
      fill={fill}
    />
  </svg>
);

export const CloseIcon = () => (
  <svg
    width='7'
    height='7'
    viewBox='0 0 7 7'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M7 0.705L6.295 0L3.5 2.795L0.705 0L0 0.705L2.795 3.5L0 6.295L0.705 7L3.5 4.205L6.295 7L7 6.295L4.205 3.5L7 0.705Z'
      fill='white'
    />
  </svg>
);

export const MenuSearchIcon: React.FC<IconProps> = ({
  width = 12,
  height = 12,
  fill = 'var(--text-primary)',
}) => (
  <svg
    width={width}
    height={height}
    viewBox='0 0 11.66 11.66'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M8.33333 7.33333H7.80667L7.62 7.15333C8.27333 6.39333 8.66667 5.40667 8.66667 4.33333C8.66667 1.94 6.72667 0 4.33333 0C1.94 0 0 1.94 0 4.33333C0 6.72667 1.94 8.66667 4.33333 8.66667C5.40667 8.66667 6.39333 8.27333 7.15333 7.62L7.33333 7.80667V8.33333L10.6667 11.66L11.66 10.6667L8.33333 7.33333ZM4.33333 7.33333C2.67333 7.33333 1.33333 5.99333 1.33333 4.33333C1.33333 2.67333 2.67333 1.33333 4.33333 1.33333C5.99333 1.33333 7.33333 2.67333 7.33333 4.33333C7.33333 5.99333 5.99333 7.33333 4.33333 7.33333Z'
      fill={fill}
    />
  </svg>
);

export const MenuCloseIcon: React.FC<IconProps> = ({
  width = 16,
  height = 16,
  fill = '#AFAFAF',
}) => (
  <svg
    width={width}
    height={height}
    viewBox='0 0 9.33333 9.33333'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M9.33333 0.94L8.39333 0L4.66667 3.72667L0.94 0L0 0.94L3.72667 4.66667L0 8.39333L0.94 9.33333L4.66667 5.60667L8.39333 9.33333L9.33333 8.39333L5.60667 4.66667L9.33333 0.94Z'
      fill={fill}
    />
  </svg>
);

export const AddCircleOutlineSmallIcon: React.FC<IconProps> = ({
  width = 12,
  height = 12,
  fill = 'var(--text-primary)',
}) => (
  <svg
    width={width}
    height={height}
    viewBox='0 0 10 10'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M5 0C2.24 0 0 2.24 0 5C0 7.76 2.24 10 5 10C7.76 10 10 7.76 10 5C10 2.24 7.76 0 5 0ZM7.5 5.5H5.5V7.5H4.5V5.5H2.5V4.5H4.5V2.5H5.5V4.5H7.5V5.5Z'
      fill={fill}
    />
  </svg>
);

export const ChevronDownXSmallIcon: React.FC<IconProps> = ({
  width = 6,
  height = 3.705,
  fill = 'white',
}) => (
  <svg
    width={width}
    height={height}
    viewBox='0 0 6 3.705'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M5.295 0L3 2.29L0.705 0L0 0.705L3 3.705L6 0.705L5.295 0Z'
      fill={fill}
    />
  </svg>
);

export const DoubleChevronDownRoleIcon: React.FC<IconProps> = ({
  width = 16,
  height = 16,
  fill = 'var(--text-secondary)',
  ...props
}) => (
  <svg
    width={width}
    height={height}
    viewBox='0 0 16 16'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M12 5.33337V7.8667L8 10.9334L4 7.8667V5.33337L8 8.40004L12 5.33337Z'
      fill={fill}
    />
  </svg>
);
export const ExitIcon = () => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='11'
    height='11'
    viewBox='0 0 9 9'
    fill='none'
  >
    <path
      d='M3.545 6.295L4.25 7L6.75 4.5L4.25 2L3.545 2.705L4.835 4H0V5H4.835L3.545 6.295ZM8 0H1C0.445 0 0 0.45 0 1V3H1V1H8V8H1V6H0V8C0 8.55 0.445 9 1 9H8C8.55 9 9 8.55 9 8V1C9 0.45 8.55 0 8 0Z'
      fill='white'
    />
  </svg>
);

export const CopyProfileIcon = () => (
  <svg
    width='10'
    height='10'
    viewBox='0 0 10 10'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M1 2H0V9C0 9.55 0.45 10 1 10H8V9H1V2ZM9 0H3C2.45 0 2 0.45 2 1V7C2 7.55 2.45 8 3 8H9C9.55 8 10 7.55 10 7V1C10 0.45 9.55 0 9 0ZM6 1C6.83 1 7.5 1.67 7.5 2.5C7.5 3.33 6.83 4 6 4C5.17 4 4.5 3.33 4.5 2.5C4.5 1.67 5.17 1 6 1ZM9 7H3V6.25C3 5.255 5 4.75 6 4.75C7 4.75 9 5.255 9 6.25V7Z'
      fill='var(--text-primary)'
    />
  </svg>
);

export const ZoomlogiNewColorLogo: React.FC<IconProps> = ({
  width = 26,
  height = 22,
  fill = '#2248D2',
  ...props
}) => (
  <svg
    width={width}
    height={height}
    viewBox='0 0 26 22'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path d='M26 10.7067L26 22H12.3237L26 10.7067Z' fill={fill} />
    <path d='M0 11.44V0L13.9769 3.8147e-06L0 11.44Z' fill={fill} />
    <path d='M26 6.67857V0H18L0 15.3214V22H8L26 6.67857Z' fill={fill} />
  </svg>
);

export const CheckboxFilledIcon: React.FC<IconProps> = ({
  width = 18,
  height = 18,
  fill = 'var(--text-primary)',
  ...props
}) => (
  <svg
    width={width}
    height={height}
    viewBox='0 0 18 18'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M16 0H2C0.89 0 0 0.9 0 2V16C0 17.1 0.89 18 2 18H16C17.11 18 18 17.1 18 16V2C18 0.9 17.11 0 16 0ZM7 14L2 9L3.41 7.59L7 11.17L14.59 3.58L16 5L7 14Z'
      fill={fill}
    />
  </svg>
);
